/* eslint-disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Auto-generated by GraphQL Code Generator
 * Do not edit manually
 *
 * Run `yarn codegen` to regenerate
 * Schema: https://gateway.texture.energy/graphql
 */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown; }
  Long: { input: any; output: any; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: void; output: void; }
};

/** Metadata about a searchable field */
export type AiDeviceFieldMetadata = {
  __typename?: 'AIDeviceFieldMetadata';
  /** Whether the field can be used in aggregations */
  aggregatable: Scalars['Boolean']['output'];
  /** Description of what the field contains */
  description: Scalars['String']['output'];
  /** Example values for the field */
  examples: Maybe<Array<Scalars['String']['output']>>;
  /** The field path (e.g., "state.chargePercentage") */
  path: Scalars['String']['output'];
  /** The field type (keyword, text, number, boolean, date, geo_point, object) */
  type: Scalars['String']['output'];
  /** Valid values for enum/keyword fields */
  validValues: Maybe<Array<Scalars['String']['output']>>;
};

/** A single device hit from the AI query */
export type AiDeviceQueryHit = {
  __typename?: 'AIDeviceQueryHit';
  /** The device document data */
  document: Scalars['JSON']['output'];
  /** The document ID */
  id: Scalars['ID']['output'];
  /** Relevance score (null if not scored) */
  score: Maybe<Scalars['Float']['output']>;
};

/** Input for AI-powered device query using Elasticsearch Query DSL */
export type AiDeviceQueryInput = {
  /** Elasticsearch aggregations to perform */
  aggregations?: InputMaybe<Scalars['JSON']['input']>;
  /** Offset for pagination (default: 0) */
  from?: InputMaybe<Scalars['Int']['input']>;
  /** Elasticsearch Query DSL object. The workspace filter is automatically applied. */
  query?: InputMaybe<Scalars['JSON']['input']>;
  /** Maximum number of results to return (default: 20, max: 100) */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Workspace ID to scope the query to (required for security) */
  workspaceId: Scalars['ID']['input'];
};

/** Query execution metadata */
export type AiDeviceQueryMeta = {
  __typename?: 'AIDeviceQueryMeta';
  /** The actual query that was executed (for debugging) */
  queryExecuted: Scalars['JSON']['output'];
  /** Whether the query timed out */
  timedOut: Scalars['Boolean']['output'];
  /** Time taken in milliseconds */
  took: Scalars['Int']['output'];
};

/** Result of an AI device query */
export type AiDeviceQueryResult = {
  __typename?: 'AIDeviceQueryResult';
  /** Aggregation results if requested */
  aggregations: Maybe<Scalars['JSON']['output']>;
  /** Error message if the query failed */
  error: Maybe<Scalars['String']['output']>;
  /** The returned device documents */
  hits: Array<AiDeviceQueryHit>;
  /** Query execution metadata */
  meta: AiDeviceQueryMeta;
  /** Whether the query was successful */
  success: Scalars['Boolean']['output'];
  /** Total number of matching documents */
  totalCount: Scalars['Int']['output'];
};

/** Schema information for AI-powered device queries */
export type AiDeviceSchemaResult = {
  __typename?: 'AIDeviceSchemaResult';
  /** Available device types */
  deviceTypes: Array<Scalars['String']['output']>;
  /** All available fields with their metadata */
  fields: Array<AiDeviceFieldMetadata>;
  /** Guidelines for constructing queries */
  queryGuidelines: Array<Scalars['String']['output']>;
  /** State fields available for each device type */
  stateFieldsByDeviceType: Scalars['JSON']['output'];
};

export type AcceptInvitationInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptWorkspaceInvitationInput = {
  invitationId: Scalars['ID']['input'];
};

/** Input for acknowledging command execution by a manufacturer. */
export type AcknowledgeCommandInput = {
  /** The API key ID that is acknowledging this command (for authorization validation). */
  apiKeyId: Scalars['String']['input'];
  /** The unique identifier of the command being acknowledged. */
  commandId: Scalars['ID']['input'];
  /** When the command was actually executed by the manufacturer. */
  executedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional reason or error message, especially for FAILED status. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The execution status of the command (COMPLETED or FAILED). */
  status: CommandAcknowledgmentStatus;
  /** The workspace ID of the requesting API key; used for authorization scoping. */
  workspaceId: Scalars['String']['input'];
};

/** Response from the acknowledgeCommand mutation. */
export type AcknowledgeCommandResponse = {
  __typename?: 'AcknowledgeCommandResponse';
  /** The acknowledgment data if successful. */
  data: Maybe<CommandAcknowledgment>;
  /** Error message if acknowledgment failed. */
  error: Maybe<Scalars['String']['output']>;
  /** Whether the acknowledgment was successfully recorded. */
  success: Scalars['Boolean']['output'];
};

/**
 * What the client needs to do to advance this lifecycle instance.
 * When requirements is non-empty, transitions is empty (requirements must be resolved first).
 * When both are empty, the instance is terminal or ready to auto-advance.
 */
export type ActionRequired = {
  __typename?: 'ActionRequired';
  /** Unsatisfied stage requirements (must be resolved before transitions are evaluated) */
  requirements: Array<RequirementBlocker>;
  /** Per-transition blocker status (only meaningful when requirements is empty) */
  transitions: Array<ActionRequiredTransitionStatus>;
};

/** Per-transition blocker status showing whether a transition is ready and what blocks it. */
export type ActionRequiredTransitionStatus = {
  __typename?: 'ActionRequiredTransitionStatus';
  /** Individual rule evaluations that are blocking this transition — empty when ready */
  blockers: Array<TransitionBlocker>;
  /** Whether all conditions for this transition are met */
  ready: Scalars['Boolean']['output'];
  /** Target stage slug */
  targetStageSlug: Scalars['String']['output'];
  /** Transition identifier */
  transitionId: Scalars['ID']['output'];
};

/** Input for creating an operator-defined custom field on a lifecycle definition. */
export type AddCustomFieldInput = {
  /** Optional type-specific configuration (e.g., select options) */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Human-readable label */
  displayName: Scalars['String']['input'];
  /** Which entity this field collects data about (CONTACT, SITE, DEVICE, ENROLLMENT) */
  entityType: Scalars['String']['input'];
  /** The data bag key (lowercase snake_case, unique per definition) */
  factKey: Scalars['String']['input'];
  /** The data type (text, email, phone, boolean, number, date, select, etc.) */
  fieldType: Scalars['String']['input'];
  /** The lifecycle definition to scope this field to */
  lifecycleDefinitionId: Scalars['ID']['input'];
};

export type AddCustomerToDeviceError = CustomerNotFoundError | DeviceNotFoundError;

/** Input type for associating a customer with a device. */
export type AddCustomerToDeviceInput = {
  /** The ID of the customer to associate with the device */
  customerId: Scalars['ID']['input'];
  /** The ID of the device to associate with the customer */
  deviceId: Scalars['ID']['input'];
};

/** Response type for the addCustomerToDevice mutation. */
export type AddCustomerToDeviceResponse = IMutationResponse & {
  __typename?: 'AddCustomerToDeviceResponse';
  /** The customer that was associated with the device, if successful */
  customer: Maybe<Customer>;
  /** Any error messages that occurred during the operation */
  errors: Maybe<Array<AddCustomerToDeviceError>>;
  success: Scalars['Boolean']['output'];
};

export type AddCustomersToWorkspaceProgramInput = {
  autoAssociateDeviceTypes?: InputMaybe<Array<DeviceType>>;
  customerIds: Array<Scalars['ID']['input']>;
  enrollmentGroupId?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceProgramId: Scalars['ID']['input'];
};

export type AddCustomersToWorkspaceProgramResponse = {
  __typename?: 'AddCustomersToWorkspaceProgramResponse';
  failureCount: Scalars['Int']['output'];
  results: Array<CustomerEnrollmentResult>;
  successCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type AddDeviceToWorkspaceError = CDeviceError & {
  __typename?: 'AddDeviceToWorkspaceError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Input for adding an existing device to a workspace */
export type AddDeviceToWorkspaceInput = {
  /** Whether the device is connected (defaults to false) */
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional connection ID that created this device-workspace association */
  connectionId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the canonical device to add */
  deviceId: Scalars['ID']['input'];
  /** External reference ID for the device in this workspace (required) */
  referenceId: Scalars['String']['input'];
  /** Optional site profile ID to associate the device with */
  siteProfileId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional tags to apply to the device */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The workspace to add the device to */
  workspaceId: Scalars['ID']['input'];
};

export type AddDeviceToWorkspaceMutationResponse = IMutationResponse & {
  __typename?: 'AddDeviceToWorkspaceMutationResponse';
  device: Maybe<Device>;
  errors: Maybe<Array<AddDeviceToWorkspaceError>>;
  success: Scalars['Boolean']['output'];
};

export type AddRequirementInput = {
  condition?: InputMaybe<Scalars['JSON']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The data bag key for this requirement (preferred over slug) */
  factKey?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['ID']['input'];
};

export type AddRequirementsInput = {
  requirements: Array<AddRequirementsItemInput>;
  stageId: Scalars['ID']['input'];
};

export type AddRequirementsItemInput = {
  condition?: InputMaybe<Scalars['JSON']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The data bag key for this requirement (preferred over slug) */
  factKey: Scalars['String']['input'];
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AddStageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  lifecycleDefinitionId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Array<StageRequirementInput>>;
  slug: Scalars['String']['input'];
  transitions?: InputMaybe<Array<StageTransitionInput>>;
  userFacingConfig?: InputMaybe<StageUserFacingConfigInput>;
};

export type AddTagToEnrollmentsInput = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tag: Scalars['String']['input'];
  workspaceProgramId: Scalars['ID']['input'];
};

/** Input for adding a new transition to a stage */
export type AddTransitionInput = {
  /** Criteria rule for this transition (null = default transition) */
  rule?: InputMaybe<Scalars['JSON']['input']>;
  stageId: Scalars['ID']['input'];
  targetStageSlug: Scalars['String']['input'];
};

export type AddUploadToEnrollmentInput = {
  documentType: EnrollmentDocumentType;
  enrollmentId: Scalars['String']['input'];
  uploadId: Scalars['ID']['input'];
};

export type AddWorkspaceSystemConnectionInput = {
  customerId: Scalars['ID']['input'];
  manufacturer: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['ID']['input'];
  systemId: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type AddWorkspaceSystemConnectionResponse = {
  __typename?: 'AddWorkspaceSystemConnectionResponse';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  systemConnection: Maybe<WorkspaceSystemConnection>;
};

export type Address = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetOne: Scalars['String']['input'];
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetOne: Scalars['String']['input'];
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type AddressOutput = {
  __typename?: 'AddressOutput';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetOne: Maybe<Scalars['String']['output']>;
  streetTwo: Maybe<Scalars['String']['output']>;
};

export type AddressRequirementConfig = RequirementConfig & {
  __typename?: 'AddressRequirementConfig';
  _type: Scalars['String']['output'];
  regionConstraints: Maybe<Array<Scalars['String']['output']>>;
};

export type AddressValidationBatchResult = {
  __typename?: 'AddressValidationBatchResult';
  /**
   * If true, the validation failed due to a transient error (timeout, rate limit)
   * and should be retried. Only meaningful when isValid is false.
   */
  isTransient: Maybe<Scalars['Boolean']['output']>;
  isValid: Scalars['Boolean']['output'];
  message: Maybe<Scalars['String']['output']>;
  standardizedAddress: Maybe<AddressOutput>;
};

export type AddressValidationResult = {
  __typename?: 'AddressValidationResult';
  /**
   * If true, the validation failed due to a transient error (timeout, rate limit)
   * and should be retried. Only meaningful when isValid is false.
   */
  isTransient: Maybe<Scalars['Boolean']['output']>;
  isValid: Scalars['Boolean']['output'];
  message: Maybe<Scalars['String']['output']>;
};

export type AdvanceStageInput = {
  instanceId: Scalars['ID']['input'];
};

/** Options for aggregating metric data across devices. */
export type AggregationOptions = {
  /**
   * Include count of devices that contributed data to each bucket.
   * Useful for participation tracking in program reporting.
   */
  includeDeviceCounts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Alert = {
  __typename?: 'Alert';
  acknowledgedAt: Maybe<Scalars['DateTime']['output']>;
  acknowledgedBy: Maybe<Scalars['String']['output']>;
  /** @deprecated Legacy free-text. Use type/subtype. */
  alertType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  device: Maybe<Device>;
  deviceId: Maybe<Scalars['String']['output']>;
  deviceModel: Maybe<Scalars['String']['output']>;
  deviceName: Maybe<Scalars['String']['output']>;
  deviceSerialNumber: Maybe<Scalars['String']['output']>;
  deviceType: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ignoredAt: Maybe<Scalars['DateTime']['output']>;
  ignoredBy: Maybe<Scalars['String']['output']>;
  manufacturer: Maybe<Scalars['String']['output']>;
  manufacturerDeviceId: Maybe<Scalars['String']['output']>;
  providerCode: Maybe<Scalars['String']['output']>;
  providerName: Maybe<Scalars['String']['output']>;
  resolvedAt: Maybe<Scalars['DateTime']['output']>;
  resolvedBy: Maybe<Scalars['String']['output']>;
  severity: Severity;
  site: Maybe<Site>;
  siteId: Scalars['String']['output'];
  snoozedUntil: Maybe<Scalars['DateTime']['output']>;
  sourceSystem: Scalars['String']['output'];
  status: Status;
  subtype: Maybe<AlertSubtype>;
  title: Scalars['String']['output'];
  type: AlertType;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
};

export type AlertOrderByInput = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
};

export type AlertSubtype =
  | 'BATTERY_FAULT'
  | 'BATTERY_METER_COMMS'
  | 'CONTACTOR_FAULT'
  | 'CONTROL_AGENT_CRASHED'
  | 'EXCESSIVE_VOLTAGE_DROP'
  | 'EXTERNAL_SWITCH_SHUTDOWN'
  | 'FREQUENCY_DEVIATION'
  | 'GENERATOR_FAULT'
  | 'GPIO_SHUTDOWN'
  | 'GRID_FOLLOWING'
  | 'GRID_FORMING'
  | 'GRID_RESYNC_FAILED'
  | 'INVERTER_COMMS'
  | 'INVERTER_FAULT'
  | 'LOW_SOE'
  | 'METER_DISCONNECTED'
  | 'OPTICASTER_EXE_FAILED'
  | 'PERFORMANCE_BELOW_EXPECTATION'
  | 'POWER_FACTOR_LIMITED'
  | 'PV_INVERTER_COMMS'
  | 'RAMP_RATE_LIMITED'
  | 'SITE_CONTROLLER_COMMS'
  | 'SITE_MAX_LIMITED'
  | 'SITE_MIN_LIMITED'
  | 'SLEEP_MODE'
  | 'TEMPERATURE_SENSOR_FAULT'
  | 'WAIT_FOR_SOLAR';

export type AlertType =
  | 'COMMUNICATIONS'
  | 'CONFIGURATION'
  | 'FIRMWARE_UPDATE'
  | 'GENERATOR'
  | 'GRID_STATUS'
  | 'HARDWARE_FAULT'
  | 'ISLANDING'
  | 'PERFORMANCE_DEGRADED'
  | 'POWER_LIMIT'
  | 'SAFETY'
  | 'SENSOR'
  | 'SITE_LEVEL'
  | 'SOFTWARE_PROCESS'
  | 'STATE_OF_ENERGY'
  | 'SYSTEM_SHUTDOWN'
  | 'TEMPERATURE'
  | 'UNKNOWN'
  | 'VOLTAGE_FREQUENCY';

export type AlertsContext = {
  __typename?: 'AlertsContext';
  device: Maybe<Device>;
  site: Maybe<Site>;
};

export type AlertsFilter = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  manufacturerDeviceId?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Severity>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  sourceSystem?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Status>;
  subtype?: InputMaybe<AlertSubtype>;
  type?: InputMaybe<AlertType>;
  workspaceId: Scalars['String']['input'];
};

export type AlertsInput = {
  filter: AlertsFilter;
  orderBy?: InputMaybe<AlertOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
};

export type AlertsResponse = {
  __typename?: 'AlertsResponse';
  context: Maybe<AlertsContext>;
  data: Array<Alert>;
  page: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

/** Filter options for all users query */
export type AllUsersFilter = {
  /** Filter by Texture employee status */
  isTextureEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by email or name (partial match) */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Input for querying all users */
export type AllUsersInput = {
  filter?: InputMaybe<AllUsersFilter>;
  pagination?: InputMaybe<ListPagination>;
};

/** Error returned when user is already a member of the organization of the collection being shared */
export type AlreadyMemberError = IMutationError & {
  __typename?: 'AlreadyMemberError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt: Scalars['DateTime']['output'];
  /** Optional expiration timestamp. Null means the key never expires. */
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  /** For MANUFACTURER type keys, the list of manufacturer IDs this key can access. */
  manufacturerScope: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** The user who owns this API key. Null for legacy keys not yet associated with a user. */
  owner: Maybe<User>;
  /** The ID of the user who owns this API key. */
  ownerId: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecating in favor of hard linking to the third party system */
  referenceId: Maybe<Scalars['String']['output']>;
  revoked: Scalars['Boolean']['output'];
  thirdPartyId: Maybe<Scalars['String']['output']>;
  type: ApiKeyType;
  updatedAt: Scalars['DateTime']['output'];
  workspace: Maybe<Workspace>;
  workspaceId: Scalars['String']['output'];
};

export type ApiKeyCredentials = {
  __typename?: 'ApiKeyCredentials';
  apiKey: Scalars['String']['output'];
  connectUrl: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
};

export type ApiKeyCredentialsInput = {
  apiKey: Scalars['String']['input'];
  connectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyPaginatedQueryPayload = {
  __typename?: 'ApiKeyPaginatedQueryPayload';
  data: Maybe<Array<ApiKey>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type ApiKeyRole =
  | 'ADMIN'
  | 'VIEWER';

export type ApiKeyType =
  | 'API'
  | 'CONNECT'
  | 'MANAGEMENT'
  | 'MANUFACTURER'
  | 'SCOPED'
  | 'SERVER';

export type ApiKeysFilter = {
  workspaceId: Scalars['ID']['input'];
};

export type ApiKeysInput = {
  filter: ApiKeysFilter;
  pagination?: InputMaybe<ListPagination>;
};

/** Represents a third-party application available for integration */
export type App = {
  __typename?: 'App';
  /** Authentication type required by the app */
  authType: AuthType;
  /** Base URL for the app's API */
  baseUrl: Scalars['String']['output'];
  /** Category of the app */
  category: AppCategory;
  /** When the app was added to the platform */
  createdAt: Scalars['DateTime']['output'];
  /** Current grant for the requesting workspace (if any) */
  currentGrant: Maybe<AppGrant>;
  /** Soft delete timestamp */
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Description of the app's functionality */
  description: Maybe<Scalars['String']['output']>;
  /** URL to the app's documentation */
  docsUrl: Maybe<Scalars['String']['output']>;
  /** List of features supported by the app */
  features: Array<Scalars['String']['output']>;
  /** Usage statistics for this app across all workspaces */
  globalStats: Maybe<AppGlobalStats>;
  /** URL to the app's icon/logo */
  iconUrl: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the app */
  id: Scalars['ID']['output'];
  /** Unique key identifier (e.g., 'slack', 'mailchimp') */
  key: Scalars['String']['output'];
  /** Display name of the app */
  name: Scalars['String']['output'];
  /** OAuth configuration if available */
  oauthConfig: Maybe<OAuthConfig>;
  /** Provider type (first-party or third-party) */
  provider: AppProvider;
  /** Name of the provider organization */
  providerName: Scalars['String']['output'];
  /** Whether OAuth flow is available for this app */
  supportsOAuth: Scalars['Boolean']['output'];
  /** Last update to app configuration */
  updatedAt: Scalars['DateTime']['output'];
};

/** App categories for organization and filtering */
export type AppCategory =
  | 'CRM'
  | 'DEVICE_DATA'
  | 'EMISSIONS'
  | 'GIS'
  | 'GRID_SERVICES'
  | 'MARKET_ACCESS'
  | 'METER_DATA_MANAGEMENT'
  | 'PERMITS'
  | 'REBATES_AND_INCENTIVES'
  | 'SITE_INTELLIGENCE'
  | 'TEXTURE_APPS'
  | 'UTILITY_DATA'
  | 'WEATHER';

/** Global usage statistics for an app across all workspaces */
export type AppGlobalStats = {
  __typename?: 'AppGlobalStats';
  /** Average success rate across all workspaces */
  averageSuccessRate: Scalars['Float']['output'];
  /** Overall health status across all installations */
  overallHealth: HealthStatus;
  /** Total number of API calls across all workspaces */
  totalCalls: Scalars['Long']['output'];
  /** Total number of workspaces using this app */
  totalWorkspaces: Scalars['Int']['output'];
};

/** Represents an app installation/grant for a specific workspace */
export type AppGrant = {
  __typename?: 'AppGrant';
  /** The app this grant is for */
  app: App;
  /** ID of the app */
  appId: Scalars['ID']['output'];
  /** Connection status and health */
  connectionStatus: ConnectionStatus;
  /** Soft delete timestamp */
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Whether the app is currently enabled */
  enabled: Scalars['Boolean']['output'];
  /** Unique identifier for the grant */
  id: Scalars['ID']['output'];
  /** When the app was installed */
  installedAt: Scalars['DateTime']['output'];
  /** Last time the app was used */
  lastUsedAt: Maybe<Scalars['DateTime']['output']>;
  /** Usage statistics for this grant */
  usageStats: AppUsageStats;
  /** Workspace that owns this grant */
  workspace: Workspace;
  /** ID of the workspace */
  workspaceId: Scalars['ID']['output'];
};

/** App provider types */
export type AppProvider =
  | 'FIRST_PARTY'
  | 'THIRD_PARTY';

export type AppProvidersForWorkspacesInput = {
  providers: Array<Scalars['String']['input']>;
  workspaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AppProvidersForWorkspacesResponse = {
  __typename?: 'AppProvidersForWorkspacesResponse';
  providers: Array<Grant>;
};

export type AppProvidersOptions = {
  concealCredentials?: InputMaybe<Scalars['Boolean']['input']>;
  providers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AppProvidersResponse = {
  __typename?: 'AppProvidersResponse';
  providers: Maybe<Array<Grant>>;
};

/** Usage statistics for a specific app grant */
export type AppUsageStats = {
  __typename?: 'AppUsageStats';
  /** Average latency in milliseconds */
  averageLatencyMs: Scalars['Float']['output'];
  /** Number of failed API calls */
  failedCalls: Scalars['Int']['output'];
  /** Number of successful API calls */
  successfulCalls: Scalars['Int']['output'];
  /** Total number of API calls made */
  totalCalls: Scalars['Int']['output'];
  /** Total data transferred in bytes */
  totalDataTransferred: Scalars['Long']['output'];
  /** Usage over time periods */
  usage: UsageOverTime;
};

/** Input for approving an organization access request */
export type ApproveOrganizationAccessRequestInput = {
  /** The role to assign to the user upon approval */
  assignedRole: Role;
  /** The token of the request to approve */
  token: Scalars['String']['input'];
};

export type ArcadiaGrant = {
  __typename?: 'ArcadiaGrant';
  credentialId: Maybe<Scalars['ID']['output']>;
  credentials: Maybe<ClientSecretCredentials>;
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ArithmeticFilter = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type AsPaginatedQueryOptions = {
  type?: InputMaybe<PaginationType>;
};

/** Resolved actor info for audit log entries. */
export type AuditLogActor = {
  __typename?: 'AuditLogActor';
  /** Email address (only for user actors). */
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Display name — user's full name or API key name. */
  name: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** Resolved resource info for audit log entries. */
export type AuditLogResource = {
  __typename?: 'AuditLogResource';
  id: Scalars['String']['output'];
  /** Human-readable label — workspace name, API key name, etc. */
  label: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/**
 * Input for querying audit logs via user authentication.
 * Requires the user to be an admin of the specified organization.
 */
export type AuditLogsInput = {
  /** Filter by action type (e.g., 'workspace.create', 'apiKey.revoke'). */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Filter by actor ID (userId or apiKeyId). */
  actorId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by actor type ('user' or 'apiKey'). */
  actorType?: InputMaybe<Scalars['String']['input']>;
  /** Only return logs created on or before this date (ISO 8601). */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The organization to query audit logs for. Must match the authenticated user's organization. */
  organizationId: Scalars['String']['input'];
  /** Page number (1-indexed). Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Results per page. Defaults to 50, max 100. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by specific resource ID. */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by resource type (e.g., 'Workspace', 'ApiKey'). */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Only return logs created on or after this date (ISO 8601). */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthProviderLog = {
  __typename?: 'AuthProviderLog';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  payload: Scalars['JSON']['output'];
  source: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AuthProviderLogPaginatedQueryPayload = {
  __typename?: 'AuthProviderLogPaginatedQueryPayload';
  data: Maybe<Array<AuthProviderLog>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type AuthProviderLogsInput = {
  pagination?: InputMaybe<ListPagination>;
};

/** Authentication types supported by apps */
export type AuthType =
  | 'API_KEY'
  | 'BASIC_AUTH'
  | 'CUSTOM'
  | 'OAUTH2';

export type AuthenticateByApiKeyInput = {
  apiKey: Scalars['String']['input'];
};

export type AuthenticateByEmailPasswordInput = {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

/** Response for authentication initiation */
export type AuthenticationInitiationResponse = {
  __typename?: 'AuthenticationInitiationResponse';
  credentials: Maybe<IdentityCredentials>;
  mfaChallengeId: Maybe<Scalars['String']['output']>;
  mfaRequired: Scalars['Boolean']['output'];
};

/**
 * A field available for use in lifecycle requirements and data collection.
 * Returned by the availableFields query, merging platform and custom fields.
 */
export type AvailableField = {
  __typename?: 'AvailableField';
  /** Optional type-specific configuration (e.g., select options) */
  config: Maybe<Scalars['JSON']['output']>;
  /** Admin-defined JSON schema for configuring this field (from FieldConfiguration overlay) */
  configSchema: Maybe<Scalars['JSON']['output']>;
  /** Human-readable label */
  displayName: Scalars['String']['output'];
  /** Which entity this field belongs to */
  entityType: FactEntity;
  /** The data bag key for this field */
  factKey: Scalars['String']['output'];
  /** The data type (text, email, phone, boolean, number, date, select, address, etc.) */
  fieldType: Scalars['String']['output'];
  /** Whether this is a PLATFORM or CUSTOM field */
  source: FieldSource;
  /** For composite fields (e.g., address), the child fields with their types */
  subFields: Maybe<Scalars['JSON']['output']>;
};

/** Input for backfill of device states */
export type BackfillDeviceStateInput = {
  /** Reason for archiving existing data (for audit trail) */
  archiveReason?: InputMaybe<Scalars['String']['input']>;
  /** Battery state data points (for battery devices only) */
  batteryStates?: InputMaybe<Array<BatteryStateInput>>;
  /** End of the time range to replace (exclusive) */
  endDate: Scalars['DateTime']['input'];
  /** Inverter state data points (for inverter devices only) */
  inverterStates?: InputMaybe<Array<InverterStateInput>>;
  /** The device manufacturer slug (e.g., "franklinwh", "tesla") */
  manufacturer: Scalars['String']['input'];
  /** The manufacturer's device ID (unique per manufacturer) */
  manufacturerDeviceId: Scalars['String']['input'];
  /**
   * Refresh continuous aggregates after insert (default: false).
   * For bulk operations, leave false and refresh CAGGs once at the end via /admin/cagg/refresh.
   */
  refreshCaggs?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start of the time range to replace (inclusive) */
  startDate: Scalars['DateTime']['input'];
  /** Thermostat state data points (for thermostat devices only) */
  thermostatStates?: InputMaybe<Array<ThermostatStateInput>>;
};

/** Response from the backfill mutation */
export type BackfillDeviceStateResponse = IMutationResponse & {
  __typename?: 'BackfillDeviceStateResponse';
  /** Number of existing records archived */
  archivedCount: Scalars['Int']['output'];
  /** Results of CAGG refresh operations */
  caggRefreshResults: Maybe<Array<CaggRefreshResult>>;
  /** The device ID that was backfilled */
  deviceId: Maybe<Scalars['String']['output']>;
  /** End of the replaced time range */
  endDate: Scalars['DateTime']['output'];
  /** Error message if the operation failed */
  error: Maybe<Scalars['String']['output']>;
  /** Number of new records inserted */
  insertedCount: Scalars['Int']['output'];
  /** Start of the replaced time range */
  startDate: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
};

export type BadUserInputError = CDeviceError & {
  __typename?: 'BadUserInputError';
  errorCode: ErrorCode;
  invalidFields: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Batch = {
  __typename?: 'Batch';
  commands: Array<SendCommandResponse>;
  createdAt: Scalars['DateTime']['output'];
  endAt: Maybe<Scalars['DateTime']['output']>;
  errors: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  executedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  input: Maybe<Scalars['JSON']['output']>;
  metrics: BatchMetrics;
  source: BatchSource;
  startAt: Maybe<Scalars['DateTime']['output']>;
  status: BatchStatus;
  tag: Maybe<Scalars['String']['output']>;
  type: Maybe<CommandType>;
  updatedAt: Scalars['DateTime']['output'];
  workspaceDeviceIds: Array<Scalars['ID']['output']>;
};

export type BatchMetrics = {
  __typename?: 'BatchMetrics';
  failed: Maybe<Scalars['Int']['output']>;
  issued: Maybe<Scalars['Int']['output']>;
  pending: Maybe<Scalars['Int']['output']>;
  planned: Maybe<Scalars['Int']['output']>;
  scheduled: Maybe<Scalars['Int']['output']>;
  succeeded: Maybe<Scalars['Int']['output']>;
};

export type BatchSource = {
  __typename?: 'BatchSource';
  tagScheduleId: Maybe<Scalars['String']['output']>;
  workspaceProgramEventId: Maybe<Scalars['String']['output']>;
};

export type BatchSourceInput = {
  tagScheduleId?: InputMaybe<Scalars['String']['input']>;
  workspaceProgramEventId?: InputMaybe<Scalars['String']['input']>;
};

export type BatchStatus =
  | 'active'
  | 'completed'
  | 'draft'
  | 'pending';

export type BatteryBatchCommandInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  setBatteryReserve?: InputMaybe<SetBatteryReserveInput>;
  setOperatingMode?: InputMaybe<SetBatteryOperatingModeInput>;
  slug: BatteryCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type BatteryChargeDataPoint = {
  __typename?: 'BatteryChargeDataPoint';
  chargeKwh: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
};

export type BatteryChargingState =
  | 'charging'
  | 'discharging'
  | 'idle'
  | 'unknown';

export type BatteryCommandInput = {
  id: Scalars['ID']['input'];
  setBatteryReserve?: InputMaybe<SetBatteryReserveInput>;
  setOperatingMode?: InputMaybe<SetBatteryOperatingModeInput>;
  slug: BatteryCommandSlug;
};

export type BatteryCommandSlug =
  | 'battery_set_operating_mode'
  | 'battery_set_reserve';

export type BatteryState = {
  __typename?: 'BatteryState';
  backupReserve: Maybe<Scalars['Float']['output']>;
  charge: Maybe<Scalars['Float']['output']>;
  chargePercentage: Scalars['Float']['output'];
  chargeRate: Maybe<Scalars['Float']['output']>;
  chargingState: BatteryChargingState;
  createdAt: Scalars['DateTime']['output'];
  gridEnergy: Maybe<Scalars['Int']['output']>;
  gridPower: Maybe<Scalars['Int']['output']>;
  gridStatus: GridStatus;
  id: Scalars['ID']['output'];
  /** Whether the battery has an active storm mode alert. */
  isStormModeActive: Maybe<Scalars['Boolean']['output']>;
  /** Whether the battery has an active storm mode enabled. */
  isStormModeEnabled: Maybe<Scalars['Boolean']['output']>;
  loadEnergy: Maybe<Scalars['Float']['output']>;
  loadPower: Maybe<Scalars['Float']['output']>;
  strategy: Maybe<BatteryStrategy>;
  whConsumed: Scalars['Float']['output'];
};

/** Battery state input. Matches BatteryState DB schema. */
export type BatteryStateInput = {
  backupReserve?: InputMaybe<Scalars['Float']['input']>;
  charge: Scalars['Float']['input'];
  chargePercentage: Scalars['Float']['input'];
  chargeRate?: InputMaybe<Scalars['Float']['input']>;
  chargingState: BatteryChargingState;
  createdAt: Scalars['DateTime']['input'];
  gridEnergy?: InputMaybe<Scalars['Int']['input']>;
  gridPower?: InputMaybe<Scalars['Int']['input']>;
  gridStatus?: InputMaybe<GridStatus>;
  isStormModeActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStormModeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  strategy?: InputMaybe<BatteryStrategy>;
  whConsumed?: InputMaybe<Scalars['Float']['input']>;
};

export type BatteryStaticState = {
  __typename?: 'BatteryStaticState';
  capacity: Scalars['Float']['output'];
  maxChargeRate: Maybe<Scalars['Float']['output']>;
  maxDischargeRate: Maybe<Scalars['Float']['output']>;
  numberOfBatteries: Maybe<Scalars['Int']['output']>;
};

export type BatteryStrategy =
  | 'backup'
  | 'self_consumption'
  | 'time_of_use'
  | 'unknown';

export type BayouGrant = {
  __typename?: 'BayouGrant';
  credentialId: Maybe<Scalars['ID']['output']>;
  credentials: Maybe<ApiKeyCredentials>;
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * Bill meter data sourced from utility bills.
 * Represents the meter identity as it appears on a utility bill, not a physical metering device.
 */
export type BillMeter = {
  __typename?: 'BillMeter';
  /** The consumption from the bill meter. */
  consumption: Maybe<Scalars['Float']['output']>;
  /** The energy usage data from a utility data provider for a given range scoped to a bill meter. */
  energyUsage: Array<EnergyUsagePeriod>;
  /** The unique meter number assigned to the meter by the installer utility. */
  meterNumber: Scalars['String']['output'];
  /** The utility company that installed the meter. */
  utility: Scalars['String']['output'];
};


/**
 * Bill meter data sourced from utility bills.
 * Represents the meter identity as it appears on a utility bill, not a physical metering device.
 */
export type BillMeterEnergyUsageArgs = {
  input: EnergyUsageInput;
};

/**
 * Container to hold billing specific metadata about the energy usage period.
 * Would really only apply to energy usage periods that correspond with a statement (which is all of them at the moment).
 */
export type BillingMeta = {
  __typename?: 'BillingMeta';
  /** The date the statement/bill is due. */
  dueDate: Maybe<Scalars['DateTime']['output']>;
  /** The date the statement was issued. */
  issueDate: Maybe<Scalars['DateTime']['output']>;
  /** Numbers for the meters associated with the statement. */
  meterIds: Array<Scalars['String']['output']>;
  /** The provider of the statement. */
  provider: Maybe<Scalars['String']['output']>;
  /** The unique identifier from Arcadia or more generically the provider for the statement. */
  statementId: Scalars['String']['output'];
  /** The name of the utility provider. */
  utilityProviderName: Maybe<Scalars['String']['output']>;
};

export type BillingPortalSessionInput = {
  organizationId: Scalars['String']['input'];
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Where a blocker attribute originates from. */
export type BlockerSource =
  /** Attribute provided by user input (form fields) */
  | 'REQUIREMENT'
  /** Attribute resolved by platform systems (device checks, account validation) */
  | 'SYSTEM';

export type BooleanAttributeConfig = {
  __typename?: 'BooleanAttributeConfig';
  falseLabel: Maybe<Scalars['String']['output']>;
  trueLabel: Maybe<Scalars['String']['output']>;
};

export type BooleanRequirementConfig = RequirementConfig & {
  __typename?: 'BooleanRequirementConfig';
  _type: Scalars['String']['output'];
};

/** The internal representation of the device. used for internal purposes only. */
export type CDevice = {
  __typename?: 'CDevice';
  /** Creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the device model */
  deviceModelId: Maybe<Scalars['ID']['output']>;
  /** The unique identifier of the device. */
  id: Scalars['ID']['output'];
  /** The manufacturer's unique identifier for this device */
  manufacturerDeviceId: Scalars['String']['output'];
  /** Optional friendly name for the device */
  name: Maybe<Scalars['String']['output']>;
  /** Distinguishes how the device was provisioned */
  provisioningType: ProvisioningType;
  /** Optional serial number */
  serialNumber: Maybe<Scalars['String']['output']>;
  /** The ID of the site where the device is installed */
  siteId: Maybe<Scalars['ID']['output']>;
};

export type CDeviceError = {
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Result of a CAGG refresh operation */
export type CaggRefreshResult = {
  __typename?: 'CaggRefreshResult';
  cagg: Scalars['String']['output'];
  error: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CancelBatchCommandInput = {
  batchId: Scalars['ID']['input'];
};

export type CancelBatchCommandResponse = {
  __typename?: 'CancelBatchCommandResponse';
  batch: Batch;
  inputBatch: Batch;
};

export type CancelWorkspaceInvitationInput = {
  invitationId: Scalars['ID']['input'];
};

export type CapacityGrowthDataPoint = {
  __typename?: 'CapacityGrowthDataPoint';
  date: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type CaptureLifecycleDataInput = {
  data: Scalars['JSON']['input'];
  instanceId: Scalars['ID']['input'];
};

export type ChangeAlertStatusInput = {
  acknowledge?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  ignore?: InputMaybe<Scalars['Boolean']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeAlertStatusResponse = {
  __typename?: 'ChangeAlertStatusResponse';
  success: Maybe<Scalars['Boolean']['output']>;
};

export type ChangePasswordInput = {
  email: Scalars['String']['input'];
};

export type ChargerBatchCommandInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  setOperatingMode?: InputMaybe<SetChargerOperatingModeInput>;
  slug: ChargerCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type ChargerCommandInput = {
  id: Scalars['ID']['input'];
  setOperatingMode?: InputMaybe<SetChargerOperatingModeInput>;
  slug: ChargerCommandSlug;
};

export type ChargerCommandSlug =
  | 'charger_set_operating_mode';

export type ChargerState = {
  __typename?: 'ChargerState';
  chargerCurrent: Maybe<Scalars['Float']['output']>;
  chargerVoltage: Maybe<Scalars['Float']['output']>;
  chargerWattage: Maybe<Scalars['Float']['output']>;
  chargingState: BatteryChargingState;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isPluggedIn: Maybe<Scalars['Boolean']['output']>;
};

export type CheckAppAuthenticationSessionResponse = {
  __typename?: 'CheckAppAuthenticationSessionResponse';
  bearerToken: Scalars['String']['output'];
  claims: Array<ResourceClaim>;
};

export type ClearWorkspaceInput = {
  /** The ID of the workspace to clear */
  workspaceId: Scalars['ID']['input'];
};

export type ClearWorkspaceOperationResult = {
  __typename?: 'ClearWorkspaceOperationResult';
  /** Number of records deleted */
  deletedCount: Scalars['Int']['output'];
  /** Error message if operation failed */
  error: Maybe<Scalars['String']['output']>;
  /** The type of operation (devices, sites, customers) */
  operation: Scalars['String']['output'];
  /** Whether this operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type ClearWorkspaceResponse = {
  __typename?: 'ClearWorkspaceResponse';
  /** Detailed results for each operation */
  results: Array<ClearWorkspaceOperationResult>;
  /** Whether all operations succeeded */
  success: Scalars['Boolean']['output'];
  /** Total number of records deleted across all operations */
  totalDeleted: Scalars['Int']['output'];
};

export type ClientSecretCredentials = {
  __typename?: 'ClientSecretCredentials';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  connectUrl: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  environment: Maybe<Scalars['String']['output']>;
};

/** A collection of items that can be grouped together based on certain criteria */
export type Collection = {
  __typename?: 'Collection';
  /** The type of entity constituting the collection */
  collectionType: CollectionType;
  /** When the collection was created */
  createdAt: Scalars['DateTime']['output'];
  /** The id of the user who created the collection */
  createdById: Scalars['ID']['output'];
  /** The type of entity that created the collection */
  createdByType: CollectionCreatedByType;
  /** The criteria used to define what belongs in the collection */
  criteria: CollectionCriteria;
  /** The version of the criteria used to define what belongs in the collection */
  criteriaVersion: Scalars['String']['output'];
  /** Whether the collection is deleted */
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Optional description of the collection */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Whether the collection contents update automatically based on criteria.
   * - `true`: Live Query. Collection contents are dynamically resolved by a query against its criteria upon every request.
   * - `false`: Materialized Set. Collection contents are stored in a dedicated join table, with behavior further defined by the `isActive` flag.
   */
  dynamic: Scalars['Boolean']['output'];
  /** The unique identifier for the collection */
  id: Scalars['ID']['output'];
  /**
   * Defines the update behavior for a materialized collection (when `dynamic` is `false`).
   * - `true`: Actively Managed Set. Entry and exit events are processed to keep the membership list synchronized with the criteria.
   * - `false`: Frozen Set. The collection's membership is locked. No automatic updates are processed.
   */
  isActive: Scalars['Boolean']['output'];
  memberships: Array<CollectionItem>;
  /** The name of the collection */
  name: Scalars['String']['output'];
  /** Organizations with access */
  organizationsWithAccess: Maybe<Array<Organization>>;
  /** When the collection was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The visibility of the collection in the workspace
   * - INTERNAL is only visible to members of the owning organization
   * - SHARED is visible to members of all organizations with workspace access
   */
  visibilityLevel: VisibilityLevel;
  /** The workspace this collection belongs to */
  workspaceId: Scalars['ID']['output'];
};

/** The type of entity that created a collection */
export type CollectionCreatedByType =
  | 'API_KEY'
  | 'USER';

/** The criteria used to define a collection's contents */
export type CollectionCriteria = {
  __typename?: 'CollectionCriteria';
  /** The rules that define what should be included in the collection */
  filters: Array<CollectionRule>;
};

/** Input for collection criteria */
export type CollectionCriteriaInput = {
  /** The rules that define what should be included in the collection */
  filters: Array<CollectionRuleInput>;
};

export type CollectionCriteriaInputV2 = {
  /** For a nested AND group. The array contains more criteria inputs. */
  and?: InputMaybe<Array<CollectionCriteriaInputV2>>;
  /** For a nested OR group. The array contains more criteria inputs. */
  or?: InputMaybe<Array<CollectionCriteriaInputV2>>;
  /** For a simple leaf node rule. Use this OR one of the logical operators below. */
  rule?: InputMaybe<CollectionRuleInput>;
};

export type CollectionEntitiesPaginatedQueryPayload = {
  __typename?: 'CollectionEntitiesPaginatedQueryPayload';
  /** The entities in the collection */
  data: Maybe<Array<CollectionEntity>>;
  /** Any error that occurred during the query */
  error: Maybe<Scalars['String']['output']>;
  /** Metadata about the query results */
  meta: Maybe<ListPayloadMeta>;
};

export type CollectionEntity = Device;

/** Union of all possible collection errors */
export type CollectionError = CollectionInvalidCriteriaError | CollectionInvalidInputError | CollectionNotFoundError;

/** Error codes specific to collection operations */
export type CollectionErrorCode =
  | 'COLLECTION_NOT_FOUND'
  | 'DUPLICATE_NAME'
  | 'INVALID_CRITERIA'
  | 'INVALID_INPUT'
  | 'UNAUTHORIZED';

/** Error returned when collection criteria is invalid */
export type CollectionInvalidCriteriaError = IMutationError & {
  __typename?: 'CollectionInvalidCriteriaError';
  details: Scalars['String']['output'];
  errorCode: CollectionErrorCode;
  message: Scalars['String']['output'];
};

/** Error returned when collection input is invalid */
export type CollectionInvalidInputError = IMutationError & {
  __typename?: 'CollectionInvalidInputError';
  errorCode: CollectionErrorCode;
  invalidFields: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/**
 * Represents either a direct collection membership or a query result item Used
 * to unify the interface when resolving collection memberships. For dynamic
 * collections, this returns CollectionMembership objects with stored membership
 * details. For static collections, this returns CollectionQueryItem objects from
 * live search queries.
 */
export type CollectionItem = {
  /** The item that is a member of the collection */
  item: CollectionMembershipItem;
};

/** Represents a membership of an item in a collection */
export type CollectionMembership = CollectionItem & {
  __typename?: 'CollectionMembership';
  /** Details about the membership such as when the item joined the collection */
  details: CollectionMembershipDetails;
  /** The item that is a member of the collection */
  item: CollectionMembershipItem;
};

/** Contains details about a collection membership */
export type CollectionMembershipDetails = {
  __typename?: 'CollectionMembershipDetails';
  /** The timestamp when the item was added to the collection */
  joinedAt: Scalars['DateTime']['output'];
};

/**
 * Represents an item that can be a member of a collection
 * Currently only supports Device type
 */
export type CollectionMembershipItem = Device;

export type CollectionMembershipsPaginationInput = {
  pagination?: InputMaybe<ListPagination>;
};

export type CollectionMembershipsPayload = {
  __typename?: 'CollectionMembershipsPayload';
  data: Array<CollectionItem>;
  meta: ListPayloadMeta;
};

/** Response type for collection mutations */
export type CollectionMutationResponse = {
  __typename?: 'CollectionMutationResponse';
  /** The collection that was created/updated, if successful */
  collection: Maybe<Collection>;
  /** Any errors that occurred during the operation */
  errors: Maybe<Array<CollectionError>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type CollectionMutationResponseV2 = IMutationResponse & {
  __typename?: 'CollectionMutationResponseV2';
  collection: Maybe<CollectionV2>;
  errors: Maybe<Array<CollectionError>>;
  success: Scalars['Boolean']['output'];
};

/** Error returned when a collection is not found */
export type CollectionNotFoundError = IMutationError & {
  __typename?: 'CollectionNotFoundError';
  errorCode: CollectionErrorCode;
  message: Scalars['String']['output'];
};

/** Response type for paginated collection queries */
export type CollectionPaginatedQueryPayload = {
  __typename?: 'CollectionPaginatedQueryPayload';
  /** The collections matching the query */
  data: Maybe<Array<Collection>>;
  /** Any error that occurred during the query */
  error: Maybe<Scalars['String']['output']>;
  /** Metadata about the query results */
  meta: Maybe<ListPayloadMeta>;
};

/** Response type for paginated collection queries */
export type CollectionPaginatedQueryPayloadV2 = {
  __typename?: 'CollectionPaginatedQueryPayloadV2';
  /** The collections matching the query */
  data: Maybe<Array<CollectionV2>>;
  /** Any error that occurred during the query */
  error: Maybe<Scalars['String']['output']>;
  /** Metadata about the query results */
  meta: Maybe<ListPayloadMeta>;
};

/**
 * A query result item that contains a reference to a collection membership item
 * Used for static collections where items are retrieved via live queries
 * rather than stored memberships. These items are generated dynamically
 * based on collection criteria through the search service.
 */
export type CollectionQueryItem = CollectionItem & {
  __typename?: 'CollectionQueryItem';
  /** The membership item returned from a collection query */
  item: CollectionMembershipItem;
};

/** A rule that defines what should be included in a collection */
export type CollectionRule = {
  __typename?: 'CollectionRule';
  /** The field to apply the rule to */
  attribute: Scalars['String']['output'];
  /** The operator to use for comparison */
  operator: CollectionRuleOperator;
  /** The value to compare against */
  value: Scalars['JSON']['output'];
};

/** Input for a collection rule */
export type CollectionRuleInput = {
  /** The field to apply the rule to */
  attribute: Scalars['String']['input'];
  /** The operator to use for comparison */
  operator: CollectionRuleOperator;
  /** The value to compare against */
  value: Scalars['JSON']['input'];
};

/** The operators available for collection rules */
export type CollectionRuleOperator =
  | 'EQUALS'
  | 'IN'
  | 'NOT_EQUALS';

/** The type of entity constituting the collection */
export type CollectionType =
  | 'CUSTOMER'
  | 'DEVICE'
  | 'SITE';

export type CollectionV2 = {
  __typename?: 'CollectionV2';
  /** The type of entity constituting the collection */
  collectionType: CollectionType;
  /** When the collection was created */
  createdAt: Scalars['DateTime']['output'];
  /** The id of the user who created the collection */
  createdById: Scalars['ID']['output'];
  /** The type of entity that created the collection */
  createdByType: CollectionCreatedByType;
  /** The criteria used to define what belongs in the collection */
  criteria: Scalars['JSON']['output'];
  /** The version of the criteria used to define what belongs in the collection */
  criteriaVersion: Scalars['String']['output'];
  /** Whether the collection is deleted */
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  /** Optional description of the collection */
  description: Maybe<Scalars['String']['output']>;
  /**
   * Whether the collection contents update automatically based on criteria.
   * - `true`: Live Query. Collection contents are dynamically resolved by a query against its criteria upon every request.
   * - `false`: Materialized Set. Collection contents are stored in a dedicated join table, with behavior further defined by the `isActive` flag.
   */
  dynamic: Scalars['Boolean']['output'];
  /** The unique identifier for the collection */
  id: Scalars['ID']['output'];
  /**
   * Defines the update behavior for a materialized collection (when `dynamic` is `false`).
   * - `true`: Actively Managed Set. Entry and exit events are processed to keep the membership list synchronized with the criteria.
   * - `false`: Frozen Set. The collection's membership is locked. No automatic updates are processed.
   */
  isActive: Scalars['Boolean']['output'];
  memberships: CollectionMembershipsPayload;
  /** The name of the collection */
  name: Scalars['String']['output'];
  /** Organizations with access */
  organizationsWithAccess: Maybe<Array<Organization>>;
  /** When the collection was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The visibility of the collection in the workspace
   * - INTERNAL is only visible to members of the owning organization
   * - SHARED is visible to members of all organizations with workspace access
   */
  visibilityLevel: VisibilityLevel;
  /** The workspace this collection belongs to */
  workspaceId: Scalars['ID']['output'];
};


export type CollectionV2MembershipsArgs = {
  input: InputMaybe<CollectionMembershipsPaginationInput>;
};

/** Filter criteria for collections */
export type CollectionsFilter = {
  /** Optional collection types to filter by */
  collectionType?: InputMaybe<Array<CollectionType>>;
  /** The workspace ID to filter collections by */
  workspaceId: Scalars['String']['input'];
};

export type Command = {
  __typename?: 'Command';
  createdAt: Scalars['DateTime']['output'];
  device: Maybe<Device>;
  endAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  input: Maybe<Scalars['JSON']['output']>;
  reason: Maybe<Scalars['String']['output']>;
  startAt: Maybe<Scalars['DateTime']['output']>;
  status: CommandStatus;
  type: CommandType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

/** Details of a command acknowledgment by a manufacturer. */
export type CommandAcknowledgment = {
  __typename?: 'CommandAcknowledgment';
  /** When the acknowledgment was received by Texture. */
  acknowledgedAt: Scalars['DateTime']['output'];
  /** The command ID that was acknowledged. */
  commandId: Scalars['ID']['output'];
  /** When the command was actually executed by the manufacturer. */
  executedAt: Maybe<Scalars['DateTime']['output']>;
  /** Optional reason or error message, especially for FAILED status. */
  reason: Maybe<Scalars['String']['output']>;
  /** The execution status (COMPLETED or FAILED). */
  status: CommandAcknowledgmentStatus;
};

/** Command execution status reported by the manufacturer. */
export type CommandAcknowledgmentStatus =
  /** Command was successfully executed. */
  | 'COMPLETED'
  /** Command execution failed. */
  | 'FAILED';

export type CommandSlug =
  | 'battery_set_operating_mode'
  | 'battery_set_reserve'
  | 'charger_set_operating_mode'
  | 'thermostat_pause_schedule'
  | 'thermostat_resume_schedule'
  | 'thermostat_set_fan_mode'
  | 'thermostat_set_operating_mode'
  | 'vehicle_set_charge_limit'
  | 'vehicle_set_operating_mode';

export type CommandStatus =
  | 'completed'
  | 'failed'
  | 'pending'
  | 'scheduled';

export type CommandType = {
  __typename?: 'CommandType';
  description: Scalars['String']['output'];
  inputSchema: Maybe<Scalars['JSON']['output']>;
  slug: Scalars['String']['output'];
};

export type CommandWebhook = {
  __typename?: 'CommandWebhook';
  createdAt: Scalars['DateTime']['output'];
  failureCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastPingAt: Maybe<Scalars['DateTime']['output']>;
  lastPingStatus: Maybe<Scalars['Int']['output']>;
  manufacturerId: Scalars['ID']['output'];
  status: WebhookStatus;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type CommandWebhookResponse = {
  __typename?: 'CommandWebhookResponse';
  data: Maybe<CommandWebhook>;
  error: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CommandWebhookWithSecret = {
  __typename?: 'CommandWebhookWithSecret';
  createdAt: Scalars['DateTime']['output'];
  failureCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastPingAt: Maybe<Scalars['DateTime']['output']>;
  lastPingStatus: Maybe<Scalars['Int']['output']>;
  manufacturerId: Scalars['ID']['output'];
  secret: Scalars['String']['output'];
  status: WebhookStatus;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type CommandWebhookWithSecretResponse = {
  __typename?: 'CommandWebhookWithSecretResponse';
  data: Maybe<CommandWebhookWithSecret>;
  error: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ConfirmUploadResult = {
  __typename?: 'ConfirmUploadResult';
  status: Scalars['String']['output'];
  uploadId: Scalars['ID']['output'];
};

export type ConnectFlowRequirementConfig = RequirementConfig & {
  __typename?: 'ConnectFlowRequirementConfig';
  _type: Scalars['String']['output'];
  deviceTypes: Maybe<Array<Scalars['String']['output']>>;
  manufacturers: Maybe<Array<Scalars['String']['output']>>;
  placeholder: Maybe<Scalars['String']['output']>;
  redirectUrl: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  tags: Maybe<Array<Scalars['String']['output']>>;
};

export type ConnectLink = {
  __typename?: 'ConnectLink';
  authorization: Maybe<ConnectLinkAuthorization>;
  customerId: Scalars['ID']['output'];
  expiresAt: Scalars['DateTime']['output'];
  linkSessionId: Scalars['ID']['output'];
  linkToken: Scalars['String']['output'];
  linkUrl: Scalars['String']['output'];
  siteId: Maybe<Scalars['ID']['output']>;
};

export type ConnectLinkAuthorization = {
  __typename?: 'ConnectLinkAuthorization';
  type: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
};

export type ConnectLinkMode =
  | 'HEADLESS'
  | 'STANDARD';

export type ConnectSession = {
  __typename?: 'ConnectSession';
  createdAt: Scalars['DateTime']['output'];
  customerId: Maybe<Scalars['ID']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorDescription: Maybe<Scalars['String']['output']>;
  events: Array<ConnectSessionEvent>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  manufacturer: Maybe<Scalars['String']['output']>;
  siteId: Maybe<Scalars['ID']['output']>;
  status: ConnectSessionStatus;
  tags: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['ID']['output'];
};

export type ConnectSessionEvent = {
  __typename?: 'ConnectSessionEvent';
  createdAt: Scalars['DateTime']['output'];
  errorCode: Maybe<Scalars['String']['output']>;
  errorDescription: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  manufacturer: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['JSON']['output']>;
  previousStatus: Maybe<ConnectSessionStatus>;
  status: ConnectSessionStatus;
};

export type ConnectSessionStatus =
  | 'AUTHORIZING_MANUFACTURER'
  | 'DUPLICATE_CONNECTION'
  | 'ENTERING_CUSTOMER_INFO'
  | 'ENTERING_SYSTEM_INFO'
  | 'ERROR'
  | 'EXPIRED'
  | 'PENDING'
  | 'SELECTING_MANUFACTURER'
  | 'STARTED'
  | 'SUCCESS'
  | 'UNSUPPORTED_MANUFACTURER';

export type ConnectSessionsFilterInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<ConnectSessionStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type ConnectSessionsInput = {
  filter: ConnectSessionsFilterInput;
  orderBy?: InputMaybe<ConnectSessionsOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
};

export type ConnectSessionsOrderByInput = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
};

export type ConnectSessionsResponse = {
  __typename?: 'ConnectSessionsResponse';
  data: Array<ConnectSession>;
  meta: Maybe<ListPayloadMeta>;
};

export type ConnectedCustomerAndSite = WorkspaceSystemConnectionInterface & {
  __typename?: 'ConnectedCustomerAndSite';
  createdAt: Scalars['DateTime']['output'];
  customerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  manufacturerData: Maybe<Scalars['JSON']['output']>;
  manufacturerSlug: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
  systemIdentifier: Scalars['String']['output'];
  tags: Maybe<Array<Scalars['String']['output']>>;
  workspaceId: Scalars['ID']['output'];
};

/** Connection status for an app grant */
export type ConnectionStatus = {
  __typename?: 'ConnectionStatus';
  /** Error message if connection is failing */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Health check status */
  healthStatus: HealthStatus;
  /** Whether credentials are valid and working */
  isConnected: Scalars['Boolean']['output'];
  /** Last failed API call */
  lastErrorAt: Maybe<Scalars['DateTime']['output']>;
  /** Last successful API call */
  lastSuccessAt: Maybe<Scalars['DateTime']['output']>;
};

/** A contact entity. */
export type Contact = {
  __typename?: 'Contact';
  /** Devices that the customer is connected to. */
  connectedDevices: Maybe<Array<Device>>;
  /** Sites that the customer is connected to. */
  connectedSites: Maybe<Array<Site>>;
  /** The contact's email address. */
  email: Scalars['String']['output'];
  /** The contact's first name. */
  firstName: Maybe<Scalars['String']['output']>;
  /** The contact's full name (may be derived from first and last name). */
  fullName: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the contact. */
  id: Scalars['ID']['output'];
  /** The contact's last name. */
  lastName: Maybe<Scalars['String']['output']>;
  /** The contact's phone number. */
  phone: Maybe<Scalars['String']['output']>;
};

/** Input type for filtering contacts by name or email. */
export type ContactsFilter = {
  /** Filter contacts by email (partial match). */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Filter contacts by name (partial match). */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for specifying filters and pagination when querying contacts. */
export type ContactsInput = {
  /** Filtering options for contacts. */
  filter: ContactsFilter;
  /** Pagination options for the contact list. */
  pagination?: InputMaybe<ListPagination>;
};

export type CreateAlertInput = {
  alertType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  severity: Severity;
  siteId: Scalars['String']['input'];
  sourceSystem: Scalars['String']['input'];
  subtype?: InputMaybe<AlertSubtype>;
  title: Scalars['String']['input'];
  type?: InputMaybe<AlertType>;
  workspaceId: Scalars['String']['input'];
};

export type CreateAlertResponse = {
  __typename?: 'CreateAlertResponse';
  alert: Maybe<Alert>;
  success: Scalars['Boolean']['output'];
};

export type CreateApiKeyInput = {
  /** Required when type is MANUFACTURER. The list of manufacturer IDs this key can access. */
  manufacturerScope?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  /** Required when type is MANAGEMENT. The ID of the user who owns this key. */
  ownerId?: InputMaybe<Scalars['String']['input']>;
  role?: ApiKeyRole;
  type: ApiKeyType;
  workspaceId: Scalars['String']['input'];
};

export type CreateAppAuthenticationSessionInput = {
  appProviderGrantId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  /** The duration in seconds or the datetime that the session should be valid for. Defaults to 24 hours. */
  expiration?: InputMaybe<ExpirationInput>;
};

export type CreateAppAuthenticationSessionResponse = {
  __typename?: 'CreateAppAuthenticationSessionResponse';
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
};

export type CreateBatchInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  payload: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateBatteryBatchInput = {
  setBatteryReserve?: InputMaybe<SetBatteryReserveInput>;
  setOperatingMode?: InputMaybe<SetBatteryOperatingModeInput>;
  slug: BatteryCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateChargerBatchInput = {
  setOperatingMode?: InputMaybe<SetChargerOperatingModeInput>;
  slug: ChargerCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/** Input for creating a new collection */
export type CreateCollectionInput = {
  /** The type of collection */
  collectionType: CollectionType;
  /**
   * The criteria used to define what belongs in the collection. The default value
   * for the criteria is a collection that includes all entities of the
   * collectionType in the workspace. The value is replaced with the provided
   * workspaceId.
   */
  criteria?: InputMaybe<CollectionCriteriaInput>;
  /** Optional description of the collection */
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  /** The name of the collection */
  name: Scalars['NonEmptyString']['input'];
  /** The workspace ID this collection belongs to */
  workspaceId: Scalars['ID']['input'];
};

export type CreateCollectionInputV2 = {
  collectionType: CollectionType;
  criteria: CollectionCriteriaInputV2;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name: Scalars['NonEmptyString']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateConnectLinkForEnrollmentInput = {
  enrollmentId: Scalars['ID']['input'];
};

export type CreateConnectLinkForEnrollmentResponse = {
  __typename?: 'CreateConnectLinkForEnrollmentResponse';
  data: Maybe<ConnectLink>;
  success: Scalars['Boolean']['output'];
};

export type CreateConnectLinkForLifecycleInstanceInput = {
  lifecycleInstanceId: Scalars['ID']['input'];
  mode?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConnectLinkForLifecycleInstanceResponse = {
  __typename?: 'CreateConnectLinkForLifecycleInstanceResponse';
  authorization: Maybe<LifecycleConnectAuthorization>;
  data: Maybe<ConnectLink>;
  siteId: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateConnectLinkInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerInfo?: InputMaybe<CustomerInfoInput>;
  manufacturerFilters?: InputMaybe<ManufacturerFiltersInput>;
  mode?: InputMaybe<ConnectLinkMode>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateConnectLinkResponse = {
  __typename?: 'CreateConnectLinkResponse';
  data: Maybe<ConnectLink>;
  error: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type CreateCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** An external ID to link the Customer to an external system. */
  referenceId: Scalars['String']['input'];
  /** The Site of the customer to be created. */
  site?: InputMaybe<CreateSiteInput>;
  /**
   * An existing siteId to link the customer to an existing workspace site.
   * referenceId to be updated
   */
  siteId?: InputMaybe<Scalars['String']['input']>;
  /** The workspaceId of the workspace the customer belongs to. */
  workspaceId: Scalars['String']['input'];
};

export type CreateDeviceManufacturerInput = {
  /** Whether this manufacturer is available in Texture Connect */
  availableInTextureConnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name of the manufacturer */
  name: Scalars['String']['input'];
  /** Unique slug identifier for the manufacturer (e.g., "tesla", "enphase") */
  slug: Scalars['String']['input'];
  /** Support level for this manufacturer */
  supportLevel: SupportLevel;
  /** Whether this manufacturer supports grid services */
  supportsGridServices?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateDeviceModelInput = {
  /** ID of the manufacturer this model belongs to */
  manufacturerId: Scalars['ID']['input'];
  /** Display name of the device model */
  name: Scalars['String']['input'];
  /** Unique slug identifier for the device model */
  slug: Scalars['String']['input'];
  /** Support level for this device model */
  supportLevel: SupportLevel;
  /** Type of device (battery, vehicle, charger, etc.) */
  type: DeviceType;
};

export type CreateDeviceScheduleInput = {
  deviceId: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  rules: Array<CreateRuleInput>;
  schedule: CreateScheduleInput;
};

export type CreateEmailDestinationInput = {
  deviceType: DeviceTypeScope;
  email: Scalars['String']['input'];
  eventTypes: Array<EventType>;
  label: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type CreateEnrollmentGroupInput = {
  name: Scalars['String']['input'];
  workspaceProgramId: Scalars['ID']['input'];
};

export type CreateEnrollmentInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  eligibilityReason?: InputMaybe<Scalars['String']['input']>;
  eligibilityStatus?: InputMaybe<EligibilityStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrollmentId?: InputMaybe<Scalars['ID']['input']>;
  enrollmentStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identificationType: IdentificationType;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadId?: InputMaybe<Scalars['ID']['input']>;
  manufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  programSpecificFields?: InputMaybe<Scalars['JSON']['input']>;
  referenceDescription?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceProgramId: Scalars['ID']['input'];
};

export type CreateGrantInput = {
  credentials?: InputMaybe<Scalars['JSON']['input']>;
  provider: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateGrantResponse = {
  __typename?: 'CreateGrantResponse';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateInvitationInput = {
  email: Scalars['String']['input'];
  role: Role;
};

export type CreateKafkaDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  eventTypes: Array<EventType>;
  kafkaConfig: Scalars['JSON']['input'];
  label: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type CreateLeadAndCheckProgramEligibilityInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  email: Scalars['String']['input'];
  event?: InputMaybe<CreateLeadEventInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type CreateLeadEventInput = {
  data?: InputMaybe<Scalars['JSON']['input']>;
  type: LeadEventType;
};

export type CreateLeadInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<LeadSource>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeadStatus>;
  workspaceId: Scalars['String']['input'];
};

/** Input for creating a management audit log entry. */
export type CreateManagementAuditLogInput = {
  /** The action performed (e.g., 'workspace.create', 'apiKey.revoke'). */
  action: Scalars['String']['input'];
  /** The ID of the actor (userId or apiKeyId). */
  actorId: Scalars['String']['input'];
  /** The type of actor ('user' or 'apiKey'). */
  actorType: Scalars['String']['input'];
  /** Additional metadata (request method, path, IP, user agent). */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** The organization this action belongs to. */
  organizationId: Scalars['String']['input'];
  /** The ID of the affected resource. */
  resourceId: Scalars['String']['input'];
  /** The type of resource affected (e.g., 'Workspace', 'ApiKey'). */
  resourceType: Scalars['String']['input'];
  /** The workspace this action relates to, if applicable. */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManufacturerCredentialInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  generateConnectLink?: InputMaybe<GenerateConnectLinkForCredentialInput>;
  manufacturer: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ManufacturerCredentialParamsInput>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateManufacturerCredentialResponse = {
  __typename?: 'CreateManufacturerCredentialResponse';
  connectLink: Maybe<ConnectLink>;
  credential: Maybe<ManufacturerCredential>;
  error: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

/** Error type for manufacturer device creation */
export type CreateManufacturerDeviceError = {
  __typename?: 'CreateManufacturerDeviceError';
  code: CreateManufacturerDeviceErrorCode;
  message: Scalars['String']['output'];
  mismatchedFields: Maybe<Array<Scalars['String']['output']>>;
};

/** Error codes for manufacturer device creation */
export type CreateManufacturerDeviceErrorCode =
  | 'DEVICE_MODEL_MANUFACTURER_MISMATCH'
  | 'DEVICE_MODEL_NOT_FOUND'
  | 'MANUFACTURER_NOT_FOUND'
  | 'PARAMETER_MISMATCH'
  | 'SITE_NOT_FOUND'
  | 'UNAUTHORIZED';

/** Input for creating a manufacturer device via dashboard */
export type CreateManufacturerDeviceInput = {
  /** The ID of the device model */
  deviceModelId: Scalars['ID']['input'];
  /** The manufacturer's unique identifier for this device */
  manufacturerDeviceId: Scalars['String']['input'];
  /** ID of the manufacturer this device belongs to */
  manufacturerId: Scalars['ID']['input'];
  /** Optional friendly name for the device */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the site where the device is installed */
  siteId: Scalars['ID']['input'];
};

/** Input for creating a manufacturer device model */
export type CreateManufacturerDeviceModelInput = {
  /** ID of the manufacturer this model belongs to */
  manufacturerId: Scalars['ID']['input'];
  /** Display name of the device model */
  name: Scalars['String']['input'];
  /**
   * Unique slug identifier for the device model.
   * Auto-generated from name if not provided.
   */
  slug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Support level for this device model.
   * Defaults to development for new OEM models.
   */
  supportLevel?: InputMaybe<SupportLevel>;
  /** Type of device (battery, vehicle, charger, etc.) */
  type: DeviceType;
};

/** Response for manufacturer device creation mutation */
export type CreateManufacturerDeviceMutationResponse = {
  __typename?: 'CreateManufacturerDeviceMutationResponse';
  device: Maybe<CreateManufacturerDeviceResult>;
  error: Maybe<CreateManufacturerDeviceError>;
  /** Whether this is a newly created device or an existing one (idempotency) */
  isNew: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Result of a device in the creation response */
export type CreateManufacturerDeviceResult = {
  __typename?: 'CreateManufacturerDeviceResult';
  createdAt: Scalars['DateTime']['output'];
  deviceModel: Maybe<ManufacturerDeviceModelInfo>;
  id: Scalars['ID']['output'];
  manufacturerDeviceId: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  serialNumber: Maybe<Scalars['String']['output']>;
  siteId: Maybe<Scalars['ID']['output']>;
};

export type CreateManufacturerIntegrationInput = {
  /** Configuration fields as JSON */
  configurationFields?: InputMaybe<Scalars['JSON']['input']>;
  /** Rich text description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Documentation blocks as JSON */
  documentationBlocks?: InputMaybe<Scalars['JSON']['input']>;
  /** Learn more URL for documentation */
  learnMoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** ID of the manufacturer this integration belongs to */
  manufacturerId: Scalars['ID']['input'];
  /** Display name */
  name: Scalars['String']['input'];
  /** Unique slug identifier (e.g., "tesla", "enphase") */
  slug: Scalars['String']['input'];
  /** Support level for this integration */
  supportLevel: SupportLevel;
};

export type CreateOAuthApplicationInput = {
  allowedScopes: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  redirectUris: Array<Scalars['String']['input']>;
  type: OAuthApplicationType;
  workspaceId: Scalars['ID']['input'];
};

/** Input for creating an OEM-provisioned device */
export type CreateOemDeviceInput = {
  /** The manufacturer IDs the API key is allowed to create devices for */
  allowedManufacturerIds: Array<Scalars['String']['input']>;
  /** The API key ID that's creating this device (for audit) */
  createdByApiKeyId: Scalars['String']['input'];
  /** The ID of the device model */
  deviceModelId: Scalars['String']['input'];
  /** The manufacturer's unique identifier for this device */
  manufacturerDeviceId: Scalars['String']['input'];
  /** Optional friendly name for the device */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional serial number */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the site where the device is installed */
  siteId: Scalars['String']['input'];
  /** The workspace ID of the requesting API key; used for site access scoping */
  workspaceId: Scalars['String']['input'];
};

/** Response for OEM device creation mutation */
export type CreateOemDeviceMutationResponse = {
  __typename?: 'CreateOemDeviceMutationResponse';
  device: Maybe<CDevice>;
  error: Maybe<OemDeviceError>;
  isNew: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input for creating an organization access request */
export type CreateOrganizationAccessRequestInput = {
  /** The ID of the organization to request access to */
  organizationId: Scalars['ID']['input'];
};

/** Input for creating an organization affiliation. */
export type CreateOrganizationAffiliationInput = {
  affiliatedOrganizationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateOrganizationInput = {
  domain: Scalars['String']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  preferredTemperatureUnit?: InputMaybe<PreferredTemperatureUnit>;
};

export type CreateProgramInput = {
  active: Scalars['Boolean']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  eligibilityCriteria?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  programTerms?: InputMaybe<Scalars['String']['input']>;
  public: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
  states: Array<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateProgramInput_Old = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description: Scalars['String']['input'];
  eligibilityCriteria: Scalars['String']['input'];
  programTerms: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateProgramVariantInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  programId: Scalars['ID']['input'];
  programTerms?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type CreateRuleInput = {
  daysOfWeek: Array<Scalars['Int']['input']>;
  deviceOperatingMode: Scalars['JSON']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type CreateScheduleInput = {
  cleanupDeviceOperatingMode?: InputMaybe<Scalars['JSON']['input']>;
  defaultDeviceOperatingMode: Scalars['JSON']['input'];
  deviceTimezone?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateScopedApiKeyInput = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Required when creating a scoped API key. The referenceId specifies the scope of access for the API key. */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  role?: ApiKeyRole;
  workspaceId: Scalars['String']['input'];
};

/** Error type for site create operations */
export type CreateSiteError = {
  __typename?: 'CreateSiteError';
  /** Machine readable error code */
  errorCode: Maybe<CreateSiteErrorCode>;
  /** Human readable error message */
  message: Scalars['String']['output'];
};

/** Possible error codes that can occur during site creation */
export type CreateSiteErrorCode =
  /** Error occurred in the location service */
  | 'LOCATION_SERVICE_ERROR'
  /** Site already exists at this location in this workspace */
  | 'SITE_ALREADY_EXISTS'
  /** Error occurred in the site repository */
  | 'SITE_REPOSITORY_ERROR';

export type CreateSiteInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetOne: Scalars['String']['input'];
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSmsDestinationInput = {
  deviceType: DeviceTypeScope;
  eventTypes: Array<EventType>;
  label: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type CreateTagScheduleInput = {
  deviceType: ScheduleSupportedDeviceType;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  rules: Array<CreateRuleInput>;
  schedule: TagScheduleInput;
  tag: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type CreateThermostatBatchInput = {
  pauseSchedule?: InputMaybe<PauseThermostatScheduleInput>;
  resumeSchedule?: InputMaybe<ResumeThermostatScheduleInput>;
  setFanMode?: InputMaybe<SetThermostatFanModeInput>;
  setOperatingMode?: InputMaybe<SetThermostatOperatingModeInput>;
  slug: ThermostatCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateVehicleBatchInput = {
  setChargeLimit?: InputMaybe<SetVehicleChargeLimitInput>;
  setOperatingMode?: InputMaybe<SetVehicleOperatingModeInput>;
  slug: VehicleCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateVirtualAccountInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<VirtualAccountType>;
  workspaceId: Scalars['String']['input'];
};

export type CreateVirtualDeviceInput = {
  accountId: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: VirtualDeviceType;
};

export type CreateWebhookDestinationInput = {
  deviceType: DeviceTypeScope;
  eventTypes: Array<EventType>;
  headers?: InputMaybe<Scalars['JSON']['input']>;
  includeWeather?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  secret?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

/** Input for creating a new workflow */
export type CreateWorkflowInput = {
  /** JSON configuration conforming to workflow schema */
  config: Scalars['JSON']['input'];
  /** Description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the workflow is enabled */
  enabled?: Scalars['Boolean']['input'];
  /** Name of the workflow */
  name: Scalars['String']['input'];
  /** ID of the workspace this workflow belongs to */
  workspaceId: Scalars['String']['input'];
};

export type CreateWorkspaceInput = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type CreateWorkspaceProgramEventInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  type: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
  workspaceProgramId: Scalars['ID']['input'];
};

export type CreateWorkspaceProgramInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibilityCriteria?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  programSlug: Scalars['String']['input'];
  programTerms?: InputMaybe<Scalars['String']['input']>;
  programVariantId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};

/** Input type for cursor-based pagination. */
export type CursorPagination = {
  /** Returns items after this cursor. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Returns items before this cursor. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** The number of items to return from the beginning of the list. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** The number of items to return from the end of the list. */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CursorPaginationInfo = {
  __typename?: 'CursorPaginationInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  startCursor: Maybe<Scalars['String']['output']>;
};

export type Customer = {
  __typename?: 'Customer';
  /** Device ids that the customer is connected to. */
  connectedDeviceIds: Array<Scalars['ID']['output']>;
  /** Devices that the customer is connected to. */
  connectedDevices: Maybe<Array<Device>>;
  /** Site ids that the customer is connected to. */
  connectedSiteIds: Array<Scalars['ID']['output']>;
  /** Sites that the customer is connected to. */
  connectedSites: Maybe<Array<Site>>;
  /** The timestamp the customer was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Optional email address for the customer. */
  email: Maybe<Scalars['String']['output']>;
  enrollments: Maybe<EnrollmentPaginatedQueryPayload>;
  events: Array<Event>;
  /** Optional name for the customer. */
  firstName: Maybe<Scalars['String']['output']>;
  /** Optional full name for the customer. */
  fullName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Optional name for the customer. */
  lastName: Maybe<Scalars['String']['output']>;
  /** The Organization ID this customer belongs to. */
  organizationId: Scalars['String']['output'];
  /** Optional phone number for the customer. */
  phone: Maybe<Scalars['String']['output']>;
  /** An external ID to link the Customer to an external system. This is unique per Workspace. */
  referenceId: Scalars['String']['output'];
  /** The timestamp the customer was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The Workspace ID this customer belongs to. */
  workspaceId: Scalars['String']['output'];
};


export type CustomerEnrollmentsArgs = {
  input: InputMaybe<EnrollmentInput>;
};


export type CustomerEventsArgs = {
  input: EventInput;
};

/**
 * Type holding information related to a customer connection (manufacturer account)
 * (debating on adjusting name)
 *
 * Note that this connection type, while tied to a customer, is not
 * necessarily tied to a single customer. A customer may have multiple
 * connections, and a connection may be shared across multiple customers.
 *
 * This is the case if a customer has signed in with multiple manufacturer accounts
 * or a separate customer has signed in with the same manufacturer account.
 *
 * In the case that a connection is shared with multiple customers, the
 * identifier for the connection will be the same across all customers.
 */
export type CustomerConnection = {
  __typename?: 'CustomerConnection';
  /** Access token for the connection */
  accessToken: Scalars['String']['output'];
  /** Identifier of the customer this connection is associated with */
  customerId: Maybe<Scalars['ID']['output']>;
  /**
   * The unique identifier for the connection
   * This is the same across all customers that share the connection
   */
  id: Scalars['ID']['output'];
  /** The manufacturer this connection is associated with */
  manufacturer: Scalars['String']['output'];
  /** Identifier assigned to the user account by the manufacturer */
  manufacturerUserId: Scalars['String']['output'];
  /** Identifier of the organization this connection is associated with */
  organizationId: Scalars['ID']['output'];
  /** Identifier provided by the external user/developer for this connection */
  referenceId: Scalars['String']['output'];
  /** Identifier of the scoped key this connection is associated with */
  scopedKeyId: Scalars['ID']['output'];
  /** Identifier of the site this connection is associated with */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Tags associated with the connection */
  tags: Maybe<Array<Scalars['String']['output']>>;
  /** Identifier of the workspace this connection is associated with */
  workspaceId: Scalars['ID']['output'];
};

export type CustomerEnrollmentResult = {
  __typename?: 'CustomerEnrollmentResult';
  customerId: Scalars['ID']['output'];
  enrollment: Maybe<Enrollment>;
  error: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CustomerInfoInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Error returned when attempting to associate a Device record with Customer record
 * that does not exist
 */
export type CustomerNotFoundError = IMutationError & {
  __typename?: 'CustomerNotFoundError';
  message: Scalars['String']['output'];
};

export type CustomerOrderByInput = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
};

export type CustomerPaginatedQueryPayload = {
  __typename?: 'CustomerPaginatedQueryPayload';
  data: Maybe<Array<Customer>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type CustomersFilter = {
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
};

export type CustomersForWorkspaceFilter = {
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
};

export type CustomersForWorkspaceFilterInput = {
  referenceId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type CustomersForWorkspaceInput = {
  filter: CustomersForWorkspaceFilter;
  orderBy?: InputMaybe<CustomerOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<CustomersForWorkspaceSearch>;
};

export type CustomersForWorkspaceSearch = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type CustomersInput = {
  filter: CustomersFilter;
  orderBy?: InputMaybe<CustomerOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<CustomersSearch>;
};

export type CustomersSearch = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type DataPoint = {
  __typename?: 'DataPoint';
  customerId: Maybe<Scalars['ID']['output']>;
  /**
   * Number of devices that contributed data to this data point.
   * Only populated when aggregation.includeDeviceCounts is true.
   */
  deviceCount: Maybe<Scalars['Int']['output']>;
  deviceId: Maybe<Scalars['ID']['output']>;
  siteId: Maybe<Scalars['ID']['output']>;
  tags: Maybe<Array<Scalars['String']['output']>>;
  ts: Scalars['DateTime']['output'];
  v: Scalars['Float']['output'];
  workspaceId: Maybe<Scalars['ID']['output']>;
};

export type DateRangeInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type DateRangeMeta = {
  __typename?: 'DateRangeMeta';
  from: Scalars['DateTime']['output'];
  to: Scalars['DateTime']['output'];
};

export type DateRequirementConfig = RequirementConfig & {
  __typename?: 'DateRequirementConfig';
  _type: Scalars['String']['output'];
  max: Maybe<Scalars['String']['output']>;
  min: Maybe<Scalars['String']['output']>;
};

export type DeclineWorkspaceInvitationInput = {
  invitationId: Scalars['ID']['input'];
};

export type DeleteBatchInput = {
  batchId: Scalars['ID']['input'];
};

/** Response type for deleting a collection */
export type DeleteCollectionMutationResponse = {
  __typename?: 'DeleteCollectionMutationResponse';
  /** Any errors that occurred during the operation */
  errors: Maybe<Array<CollectionError>>;
  /** The id of the collection that was deleted, if successful */
  id: Maybe<Scalars['ID']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type DeleteCustomerInput = {
  deleteRelatedDevices?: InputMaybe<Scalars['Boolean']['input']>;
  deleteRelatedSites?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteDestinationMutationResponse = {
  __typename?: 'DeleteDestinationMutationResponse';
  error: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteDeviceInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDeviceSchedulesPayload = {
  __typename?: 'DeleteDeviceSchedulesPayload';
  data: Array<DeviceSchedule>;
};

export type DeleteDevicesInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteDevicesMutationResponse = IMutationResponse & {
  __typename?: 'DeleteDevicesMutationResponse';
  failureCount: Scalars['Int']['output'];
  results: Array<DeleteDevicesResult>;
  success: Scalars['Boolean']['output'];
  successCount: Scalars['Int']['output'];
};

export type DeleteDevicesResult = {
  __typename?: 'DeleteDevicesResult';
  error: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteEnrollmentMutationResponse = {
  __typename?: 'DeleteEnrollmentMutationResponse';
  id: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteGrantResponse = {
  __typename?: 'DeleteGrantResponse';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteInvitationInput = {
  id: Scalars['String']['input'];
};

/** Error when attempting to delete a model with existing devices */
export type DeleteManufacturerDeviceModelError = {
  __typename?: 'DeleteManufacturerDeviceModelError';
  /** Number of devices using this model */
  deviceCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

/** Result of attempting to delete a manufacturer device model */
export type DeleteManufacturerDeviceModelResult = DeleteManufacturerDeviceModelError | DeleteManufacturerDeviceModelSuccess;

/** Successful deletion of a manufacturer device model */
export type DeleteManufacturerDeviceModelSuccess = {
  __typename?: 'DeleteManufacturerDeviceModelSuccess';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteMembershipInput = {
  id: Scalars['String']['input'];
};

export type DeleteOAuthApplicationResponse = {
  __typename?: 'DeleteOAuthApplicationResponse';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input type for deleting a site and optionally its related resources */
export type DeleteSiteInput = {
  /** Whether to also delete customers associated with this site. If false, customers will be preserved. */
  deleteRelatedCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to also delete devices associated with this site. If false, devices will be preserved. */
  deleteRelatedDevices?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique identifier of the site to delete */
  id: Scalars['ID']['input'];
};

/** Input type for bulk deleting sites */
export type DeleteSitesInputForWorkspaceInput = {
  /** Workspace ID to delete all sites from */
  workspaceId: Scalars['ID']['input'];
};

/** Response type for bulk site deletion */
export type DeleteSitesMutationResponse = {
  __typename?: 'DeleteSitesMutationResponse';
  /** Number of failed site deletions */
  failureCount: Scalars['Int']['output'];
  /** Detailed results for each site deletion */
  results: Array<DeleteSitesResult>;
  /** Whether all deletions succeeded */
  success: Scalars['Boolean']['output'];
  /** Number of successfully deleted sites */
  successCount: Scalars['Int']['output'];
};

/** Result for a single site deletion in bulk operation */
export type DeleteSitesResult = {
  __typename?: 'DeleteSitesResult';
  /** Error message if deletion failed */
  error: Maybe<Scalars['String']['output']>;
  /** The site ID that was processed */
  id: Scalars['ID']['output'];
  /** Whether this specific deletion succeeded */
  success: Scalars['Boolean']['output'];
};

export type DeleteTagSchedulesByTagInput = {
  tag: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type DeleteTagSchedulesPayload = {
  __typename?: 'DeleteTagSchedulesPayload';
  data: Array<TagSchedule>;
};

export type DeleteWorkspaceProgramEventInput = {
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
  workspaceProgramEventId: Scalars['ID']['input'];
};

export type DeleteWorkspaceSystemConnectionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkspaceSystemConnectionResponse = {
  __typename?: 'DeleteWorkspaceSystemConnectionResponse';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input for denying an organization access request */
export type DenyOrganizationAccessRequestInput = {
  /** The token of the request to deny */
  token: Scalars['String']['input'];
};

export type Destination = {
  __typename?: 'Destination';
  createdAt: Scalars['DateTime']['output'];
  deactivated: Maybe<Scalars['Boolean']['output']>;
  deactivatedAt: Maybe<Scalars['DateTime']['output']>;
  deactivatedReason: Maybe<Scalars['String']['output']>;
  destinationType: Maybe<DestinationType>;
  deviceType: Maybe<DeviceTypeScope>;
  email: Maybe<Scalars['String']['output']>;
  eventTypes: Array<EventType>;
  headers: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  includeWeather: Maybe<Scalars['Boolean']['output']>;
  kafkaConfig: Maybe<Scalars['JSON']['output']>;
  label: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  secret: Maybe<Scalars['String']['output']>;
  unsubscribeToken: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type DestinationListPayload = {
  __typename?: 'DestinationListPayload';
  data: Array<Maybe<Destination>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type DestinationMutationResponse = {
  __typename?: 'DestinationMutationResponse';
  data: Maybe<Destination>;
  error: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DestinationType =
  | 'EMAIL'
  | 'KAFKA'
  | 'MANUFACTURER_COMMAND'
  | 'SMS'
  | 'WEBHOOK';

export type DestinationsInput = {
  filter: DestinationsInputFilter;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<DestinationsInputSearchInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type DestinationsInputFilter = {
  destinationType?: InputMaybe<DestinationType>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type DestinationsInputSearchInput = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  operator?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type DetermineEligibilityForEnrollmentInput = {
  enrollmentId: Scalars['ID']['input'];
  requirements?: InputMaybe<Array<Requirement>>;
};

export type DetermineEligibilityForEnrollmentPayload = {
  __typename?: 'DetermineEligibilityForEnrollmentPayload';
  reason: Maybe<Scalars['String']['output']>;
  results: Array<EligibilityCheckResult>;
  status: EligibilityCheckStatus;
};

export type Device = {
  __typename?: 'Device';
  alerts: Maybe<Array<Alert>>;
  availableCommands: Array<CommandType>;
  /** @deprecated Use collectionMembershipV2 instead */
  collectionMembership: Array<Collection>;
  collectionMembershipV2: Array<CollectionV2>;
  connectedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The collection of Customers that have registered the Device. */
  customers: Array<Customer>;
  deviceManufacturer: Maybe<DeviceManufacturer>;
  deviceModel: Maybe<DeviceModel>;
  disconnectedAt: Maybe<Scalars['DateTime']['output']>;
  displayModelName: Maybe<Scalars['String']['output']>;
  enrollments: Array<Enrollment>;
  events: Array<Event>;
  id: Scalars['ID']['output'];
  location: Maybe<ILocation>;
  /** @deprecated Use location */
  locationId: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use deviceManufacturer instead */
  manufacturer: Scalars['String']['output'];
  /** @deprecated Use serialNumber */
  manufacturerDeviceId: Scalars['String']['output'];
  /** @deprecated Use deviceManufacturer instead */
  manufacturerProfile: DeviceManufacturerProfile;
  manufacturerUserId: Scalars['String']['output'];
  metrics: Maybe<DeviceMetrics>;
  /** @deprecated Use deviceModel instead */
  model: Scalars['String']['output'];
  /** @deprecated Use deviceModel instead */
  modelProfile: DeviceModelProfile;
  name: Scalars['String']['output'];
  /** The customer that first connected the device. */
  owner: Maybe<Customer>;
  rawManufacturer: Scalars['String']['output'];
  rawModel: Maybe<Scalars['String']['output']>;
  rawType: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['ID']['output'];
  schedules: DeviceSchedulesForDeviceQueryPayload;
  serialNumber: Maybe<Scalars['String']['output']>;
  site: Maybe<Site>;
  state: Maybe<DeviceState>;
  staticState: Maybe<DeviceStaticState>;
  tags: Array<Scalars['String']['output']>;
  type: DeviceType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  year: Maybe<Scalars['Int']['output']>;
};


export type DeviceEventsArgs = {
  input: EventInput;
};

/**
 * A lightweight pairing of a Texture device ID and its meter ID,
 * returned by devicesByMeterIds for use by the location domain when
 * partitioning GridElement consumers into Texture-tracked and untracked groups.
 */
export type DeviceByMeterIdResult = {
  __typename?: 'DeviceByMeterIdResult';
  /** The Texture device ID */
  id: Scalars['ID']['output'];
  /** The meter ID that matched (from MeterStaticState) */
  meterId: Scalars['String']['output'];
};

export type DeviceCommandPaginatedQueryPayload = {
  __typename?: 'DeviceCommandPaginatedQueryPayload';
  data: Maybe<Array<Command>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type DeviceCommandsFilter = {
  id: Scalars['ID']['input'];
  status?: InputMaybe<Array<CommandStatus>>;
  workspaceId: Scalars['ID']['input'];
};

export type DeviceCommandsInput = {
  filter: DeviceCommandsFilter;
  pagination?: InputMaybe<ListPagination>;
};

export type DeviceConsumptionMetrics = {
  __typename?: 'DeviceConsumptionMetrics';
  energyConsumptionWhrLast1hr: Maybe<Scalars['Float']['output']>;
};

export type DeviceGrowthDataPoint = {
  __typename?: 'DeviceGrowthDataPoint';
  count: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
};

export type DeviceLocationFilter = {
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCode?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeviceManufacturer = {
  __typename?: 'DeviceManufacturer';
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type DeviceManufacturerProfile = {
  __typename?: 'DeviceManufacturerProfile';
  availableInTextureConnect: Maybe<Scalars['Boolean']['output']>;
  deviceTypes: Array<DeviceType>;
  icon: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  logo: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  supportLevel: Maybe<SupportLevel>;
  supportsGridServices: Maybe<Scalars['Boolean']['output']>;
  vectorIcon: Maybe<Scalars['String']['output']>;
};

export type DeviceMetrics = {
  __typename?: 'DeviceMetrics';
  consumption: Maybe<DeviceConsumptionMetrics>;
  production: Maybe<DeviceProductionMetrics>;
};

export type DeviceModel = {
  __typename?: 'DeviceModel';
  manufacturer: DeviceManufacturer;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type DeviceModelProfile = {
  __typename?: 'DeviceModelProfile';
  availableCommands: Maybe<Array<ModelAvailableCommand>>;
  id: Maybe<Scalars['ID']['output']>;
  logo: Maybe<Scalars['String']['output']>;
  manufacturerId: Maybe<Scalars['ID']['output']>;
  manufacturerName: Maybe<Scalars['String']['output']>;
  manufacturerSlug: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  supportLevel: Maybe<SupportLevel>;
  type: Maybe<DeviceType>;
};

/**
 * Error returned when attempting to associate a Customer with a Device record that
 * does not exist
 */
export type DeviceNotFoundError = IMutationError & {
  __typename?: 'DeviceNotFoundError';
  message: Scalars['String']['output'];
};

export type DeviceOrderByInput = {
  connectedAt?: InputMaybe<PaginatedQueryOrderBy>;
  displayModelName?: InputMaybe<PaginatedQueryOrderBy>;
  manufacturer?: InputMaybe<PaginatedQueryOrderBy>;
  model?: InputMaybe<PaginatedQueryOrderBy>;
  name?: InputMaybe<PaginatedQueryOrderBy>;
  type?: InputMaybe<PaginatedQueryOrderBy>;
};

export type DevicePaginatedQueryPayload = {
  __typename?: 'DevicePaginatedQueryPayload';
  data: Maybe<Array<Device>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type DeviceParticipationReport = {
  __typename?: 'DeviceParticipationReport';
  /** Device participation rows */
  devices: Array<DeviceParticipationRow>;
  /** Metadata about the query */
  meta: ProgramReportMeta;
  /** Summary KPI metrics */
  summary: ParticipationSummary;
};

export type DeviceParticipationRow = {
  __typename?: 'DeviceParticipationRow';
  /** Device ID */
  deviceId: Scalars['ID']['output'];
  /** Device display name */
  deviceName: Scalars['String']['output'];
  /** Device type for display */
  deviceType: ReportDeviceDisplayType;
  /**
   * Energy delivered (kWh) during discharge-mode batch windows only - null if didn't participate.
   * Battery-only; needs modification for other device types.
   */
  dischargeEnergyKwh: Maybe<Scalars['Float']['output']>;
  /** Clean model display name (e.g., "Powerwall 2", "IQ Battery") */
  displayModelName: Maybe<Scalars['String']['output']>;
  /** Energy delivered (kWh) across all batch windows - null if didn't participate */
  energyKwh: Maybe<Scalars['Float']['output']>;
  /** Device manufacturer slug (e.g., "tesla", "enphase") */
  manufacturer: Scalars['String']['output'];
  /** Clean manufacturer display name (e.g., "Tesla", "Enphase") */
  manufacturerDisplayName: Maybe<Scalars['String']['output']>;
  /** Manufacturer logo URL */
  manufacturerLogoUrl: Maybe<Scalars['String']['output']>;
  /** Owner/member name */
  memberName: Maybe<Scalars['String']['output']>;
  /** Device model slug (e.g., "powerwall-2", "iq-battery") */
  model: Scalars['String']['output'];
  /** Response time in seconds - null if didn't participate */
  responseTimeSeconds: Maybe<Scalars['Int']['output']>;
  /** Participation status */
  status: ReportParticipationStatus;
};

export type DeviceProductionMetrics = {
  __typename?: 'DeviceProductionMetrics';
  energyProductionWhrLast1hr: Maybe<Scalars['Float']['output']>;
};

export type DeviceRule = {
  __typename?: 'DeviceRule';
  createdAt: Scalars['DateTime']['output'];
  daysOfWeek: Array<Scalars['Int']['output']>;
  deviceOperatingMode: Scalars['JSON']['output'];
  deviceScheduleId: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  startTime: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type DeviceSchedule = {
  __typename?: 'DeviceSchedule';
  cleanupDeviceOperatingMode: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultDeviceOperatingMode: Scalars['JSON']['output'];
  deviceId: Scalars['String']['output'];
  deviceTimezone: Scalars['String']['output'];
  deviceType: ScheduleSupportedDeviceType;
  endsAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  rules: Array<DeviceRule>;
  startsAt: Scalars['DateTime']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type DeviceScheduleForDeviceInput = {
  deviceId: Scalars['String']['input'];
};

export type DeviceSchedulesForDeviceQueryPayload = {
  __typename?: 'DeviceSchedulesForDeviceQueryPayload';
  data: Array<DeviceSchedule>;
  meta: Maybe<ListPayloadMeta>;
};

export type DeviceSearchInput = {
  displayModelName?: InputMaybe<PaginatedQuerySearchInput>;
  manufacturer?: InputMaybe<PaginatedQuerySearchInput>;
  name?: InputMaybe<PaginatedQuerySearchInput>;
  referenceId?: InputMaybe<PaginatedQuerySearchInput>;
};

export type DeviceState = BatteryState | ChargerState | InverterState | MeterState | ThermostatState | VehicleState;

export type DeviceStateFilter = {
  ambientTemperature?: InputMaybe<ArithmeticFilter>;
  backupReserve?: InputMaybe<ArithmeticFilter>;
  charge?: InputMaybe<ArithmeticFilter>;
  chargeLimit?: InputMaybe<ArithmeticFilter>;
  chargePercentage?: InputMaybe<ArithmeticFilter>;
  chargeRate?: InputMaybe<ArithmeticFilter>;
  chargerCurrent?: InputMaybe<ArithmeticFilter>;
  chargerVoltage?: InputMaybe<ArithmeticFilter>;
  chargerWattage?: InputMaybe<ArithmeticFilter>;
  chargingState?: InputMaybe<Array<BatteryChargingState>>;
  coolTarget?: InputMaybe<ArithmeticFilter>;
  gridEnergy?: InputMaybe<ArithmeticFilter>;
  gridPower?: InputMaybe<ArithmeticFilter>;
  gridStatus?: InputMaybe<Array<GridStatus>>;
  heatTarget?: InputMaybe<ArithmeticFilter>;
  power?: InputMaybe<ArithmeticFilter>;
  range?: InputMaybe<ArithmeticFilter>;
};

export type DeviceStateHistoryFilter = {
  from: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeviceStateHistoryInput = {
  filter: DeviceStateHistoryFilter;
  pagination?: InputMaybe<ListPagination>;
};

export type DeviceStatePaginatedQueryPayload = {
  __typename?: 'DeviceStatePaginatedQueryPayload';
  data: Maybe<Array<DeviceState>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type DeviceStaticState = BatteryStaticState | InverterStaticState | MeterStaticState | ThermostatStaticState | VehicleStaticState;

/**
 * Static state input for device configuration.
 * Fields are used based on device type:
 * - Battery: capacity, maxChargeRate, maxDischargeRate, numberOfBatteries
 * - Inverter: power
 */
export type DeviceStaticStateInput = {
  /** Battery capacity in watt-hours (Wh). Required for battery devices. */
  capacity?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum charge rate in watts (W). Optional for battery devices. */
  maxChargeRate?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum discharge rate in watts (W). Optional for battery devices. */
  maxDischargeRate?: InputMaybe<Scalars['Float']['input']>;
  /** Number of battery units in the system. Optional for battery devices. */
  numberOfBatteries?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum power output in watts (W). Required for inverter devices. */
  power?: InputMaybe<Scalars['Float']['input']>;
};

export type DeviceType =
  | 'battery'
  | 'charger'
  | 'inverter'
  | 'meter'
  | 'other'
  | 'thermostat'
  | 'unknown'
  | 'vehicle';

/** Count of devices by type. */
export type DeviceTypeCount = {
  __typename?: 'DeviceTypeCount';
  /** Number of devices of this type */
  count: Scalars['Int']['output'];
  /** The device type */
  type: DeviceType;
};

export type DeviceTypeScope =
  | 'ALL'
  | 'BATTERIES'
  | 'CHARGERS'
  | 'OTHER'
  | 'SOLAR_INVERTERS'
  | 'THERMOSTATS'
  | 'UNKNOWN'
  | 'VEHICLES';

export type DevicesFilter = {
  collectionMembership?: InputMaybe<Array<Scalars['ID']['input']>>;
  connected?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Filter by device IDs (DeviceOnWorkspace IDs) */
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<DeviceLocationFilter>;
  manufacturer?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturerDeviceId?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturerUserId?: InputMaybe<Array<Scalars['String']['input']>>;
  model?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<DeviceStateFilter>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<DeviceType>>;
  workspaceId: Scalars['ID']['input'];
};

export type DevicesInput = {
  filter: DevicesFilter;
  orderBy?: InputMaybe<DeviceOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<DeviceSearchInput>;
  /** Data source override. Pass "db" to query Postgres directly instead of Elasticsearch. */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type DisableEnrollmentReportInput = {
  workspaceProgramId: Scalars['ID']['input'];
};

/** Input for disabling a dashboard pack for an organization */
export type DisablePackInput = {
  /** The ID of the organization to disable the pack for */
  organizationId: Scalars['ID']['input'];
  /** The type of pack to disable */
  pack: PackType;
};

export type DispatchMutationResponse = {
  __typename?: 'DispatchMutationResponse';
  data: Maybe<Batch>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DomainMeta = {
  __typename?: 'DomainMeta';
  label: Scalars['String']['output'];
  rate: MetricRate;
  sparse: Scalars['Boolean']['output'];
};

export type DownloadUrlResult = {
  __typename?: 'DownloadUrlResult';
  expiresAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

/**
 * Connection wrapper for CONSUMER-type GridElements downstream of a grid
 * element that are NOT matched to a Texture device.
 *
 * Note: `totalConsumerSubtreeCount` mirrors the field on
 * `DownstreamDeviceConnection` — it is the total number of CONSUMER
 * GridElements in the subtree, tracked AND untracked combined. The
 * frontend is expected to compare `consumers.length + downstreamDevices.devices.length`
 * against this total to decide whether the returned page covered the full
 * subtree. A dedicated `untrackedCount` would require a second COUNT
 * query and is deliberately deferred.
 */
export type DownstreamConsumerConnection = {
  __typename?: 'DownstreamConsumerConnection';
  consumers: Array<GridElement>;
  totalConsumerSubtreeCount: Scalars['Int']['output'];
};

/**
 * Connection wrapper for Texture devices (matched meters) downstream of a grid
 * element.
 *
 * Note: `totalConsumerSubtreeCount` is the number of CONSUMER GridElements
 * in the subtree, NOT the number of matched Texture devices. It is returned
 * so the frontend can sum `devices` + `downstreamConsumers.consumers`
 * (untracked) and compare against this total to decide whether a page was
 * fully loaded or an overflow link is needed. The true matched-device count
 * in the subtree would require a second query and is deliberately deferred.
 */
export type DownstreamDeviceConnection = {
  __typename?: 'DownstreamDeviceConnection';
  devices: Array<Device>;
  totalConsumerSubtreeCount: Scalars['Int']['output'];
};

/** Input for checking duplicate devices by manufacturerUserId. */
export type DuplicateDeviceCheckInput = {
  /** The manufacturer's unique identifier for the user (e.g., Tesla account ID) */
  manufacturerUserId: Scalars['String']['input'];
  /** The workspace to check for duplicate devices */
  workspaceId: Scalars['ID']['input'];
};

/**
 * Result of checking for duplicate devices by manufacturerUserId within a workspace.
 * Used for duplicate detection during device connection flows.
 */
export type DuplicateDeviceCheckResult = {
  __typename?: 'DuplicateDeviceCheckResult';
  /** Number of currently connected devices matching the manufacturerUserId */
  connectedCount: Scalars['Int']['output'];
  /** Number of disconnected devices matching the manufacturerUserId */
  disconnectedCount: Scalars['Int']['output'];
  /** Total number of devices (connected + disconnected) matching the manufacturerUserId */
  totalCount: Scalars['Int']['output'];
};

export type EligibilityCheck = {
  __typename?: 'EligibilityCheck';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reason: Maybe<Scalars['String']['output']>;
  requirement: Requirement;
  status: EligibilityCheckStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type EligibilityCheckResult = {
  __typename?: 'EligibilityCheckResult';
  customData: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  reason: Maybe<Scalars['String']['output']>;
  status: EligibilityCheckStatus;
};

export type EligibilityCheckStatus =
  | 'failure'
  | 'pending'
  | 'success';

export type EligibilityStatus =
  | 'approved'
  | 'candidate'
  | 'eligible'
  | 'ineligible'
  | 'rejected'
  | 'submitted'
  | 'unenrolled'
  | 'unenrolling';

export type Email = {
  __typename?: 'Email';
  createdAt: Scalars['DateTime']['output'];
  domain: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPersonalEmailDomain: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

/** Error returned when the email is already verified */
export type EmailAlreadyVerifiedError = IMutationError & {
  __typename?: 'EmailAlreadyVerifiedError';
  message: Scalars['String']['output'];
};

export type EmailRequirementConfig = RequirementConfig & {
  __typename?: 'EmailRequirementConfig';
  _type: Scalars['String']['output'];
  placeholder: Maybe<Scalars['String']['output']>;
};

export type EmailV2 = {
  __typename?: 'EmailV2';
  createdAt: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isVerified: Maybe<Scalars['Boolean']['output']>;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type EnableEnrollmentReportInput = {
  manufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceProgramId: Scalars['ID']['input'];
};

/** Input for enabling a dashboard pack for an organization */
export type EnablePackInput = {
  /** The ID of the organization to enable the pack for */
  organizationId: Scalars['ID']['input'];
  /** The type of pack to enable */
  pack: PackType;
};

/** Usage data for a specific endpoint */
export type EndpointUsage = {
  __typename?: 'EndpointUsage';
  /** Average latency for this endpoint */
  averageLatencyMs: Scalars['Float']['output'];
  /** Number of calls to this endpoint */
  calls: Scalars['Int']['output'];
  /** The endpoint path */
  endpoint: Scalars['String']['output'];
};

export type EnergyModeling = {
  __typename?: 'EnergyModeling';
  consumption: Maybe<EnergyModelingConsumption>;
  costs: Maybe<EnergyModelingCosts>;
  intervals: Array<EnergyModelingInterval>;
};

export type EnergyModelingBuildingCharacteristics = {
  __typename?: 'EnergyModelingBuildingCharacteristics';
  floorArea: Maybe<Scalars['Float']['output']>;
  numBedrooms: Maybe<Scalars['Int']['output']>;
  numOccupants: Maybe<Scalars['Int']['output']>;
  numStories: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type EnergyModelingConsumption = {
  __typename?: 'EnergyModelingConsumption';
  buildingCharacteristics: Maybe<EnergyModelingBuildingCharacteristics>;
};

export type EnergyModelingCosts = {
  __typename?: 'EnergyModelingCosts';
  emissionRates: Maybe<EnergyModelingEmissionRates>;
  utilityRates: Maybe<EnergyModelingUtilityRates>;
};

export type EnergyModelingEmissionRates = {
  __typename?: 'EnergyModelingEmissionRates';
  electricity: Maybe<EnergyModelingUnit>;
  fossilFuel: Maybe<EnergyModelingUnit>;
};

export type EnergyModelingGridImport = {
  __typename?: 'EnergyModelingGridImport';
  electricity: Maybe<EnergyModelingUnit>;
  fossilFuel: Maybe<EnergyModelingUnit>;
};

export type EnergyModelingGridMetrics = {
  __typename?: 'EnergyModelingGridMetrics';
  import: Maybe<EnergyModelingGridImport>;
};

export type EnergyModelingInterval = {
  __typename?: 'EnergyModelingInterval';
  consumption: Maybe<EnergyModelingIntervalConsumption>;
  costs: Maybe<EnergyModelingIntervalCosts>;
  emissions: Maybe<EnergyModelingIntervalEmissions>;
  from: Scalars['DateTime']['output'];
  grid: Maybe<EnergyModelingGridMetrics>;
  to: Scalars['DateTime']['output'];
};

export type EnergyModelingIntervalConsumption = {
  __typename?: 'EnergyModelingIntervalConsumption';
  electricity: Maybe<EnergyModelingUnit>;
  fossilFuel: Maybe<EnergyModelingUnit>;
};

export type EnergyModelingIntervalCosts = {
  __typename?: 'EnergyModelingIntervalCosts';
  electricity: Maybe<EnergyModelingUnit>;
  fossilFuel: Maybe<EnergyModelingUnit>;
};

export type EnergyModelingIntervalEmissions = {
  __typename?: 'EnergyModelingIntervalEmissions';
  electricity: Maybe<EnergyModelingUnit>;
  fossilFuel: Maybe<EnergyModelingUnit>;
};

export type EnergyModelingUnit = {
  __typename?: 'EnergyModelingUnit';
  units: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['Float']['output']>;
};

export type EnergyModelingUsageMetrics = {
  __typename?: 'EnergyModelingUsageMetrics';
  consumption: Maybe<Scalars['Float']['output']>;
  costs: Maybe<Scalars['Float']['output']>;
  emissions: Maybe<Scalars['Float']['output']>;
};

export type EnergyModelingUtilityRates = {
  __typename?: 'EnergyModelingUtilityRates';
  electricity: Maybe<EnergyModelingUnit>;
  fossilFuel: Maybe<EnergyModelingUnit>;
};

export type EnergyRange = {
  __typename?: 'EnergyRange';
  /** Maximum energy value (for color scaling) */
  max: Scalars['Float']['output'];
  /** Minimum energy value (for color scaling) */
  min: Scalars['Float']['output'];
};

export type EnergyUsageInput = {
  /** The end date of the period. */
  endDate: Scalars['DateTime']['input'];
  /** The start date of the period. */
  startDate: Scalars['DateTime']['input'];
  /** The workspace this Meter belongs to. */
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Container to hold additional metadata about the energy usage period. */
export type EnergyUsageMeta = {
  __typename?: 'EnergyUsageMeta';
  /** Billing specific metadata about the energy usage period. */
  billing: Maybe<BillingMeta>;
};

export type EnergyUsagePeriod = {
  __typename?: 'EnergyUsagePeriod';
  /** Total energy consumed at the site during the period. */
  consumption: Scalars['Float']['output'];
  /** Total cost of the energy consumed at the site during the period. */
  cost: Maybe<MonetaryAmount>;
  /** The emissions for the site in pounds of CO2 for the period. */
  emissions: Maybe<Scalars['Float']['output']>;
  /** The end date of the period. */
  endDate: Scalars['DateTime']['output'];
  /**
   * Additional metadata about the energy usage period.
   * Primarily for billing/statements. But could also include
   * additional information about the energy usage period.
   */
  meta: Maybe<EnergyUsageMeta>;
  /** Average price of energy consumed in local currency (e.g. USD) per kWh. */
  price: Maybe<Scalars['Float']['output']>;
  /** The start date of the period. */
  startDate: Scalars['DateTime']['output'];
};

export type EnodeGrant = {
  __typename?: 'EnodeGrant';
  credentialId: Maybe<Scalars['ID']['output']>;
  credentials: Maybe<ClientSecretCredentials>;
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EnphaseGridServicesEnrollment = {
  __typename?: 'EnphaseGridServicesEnrollment';
  createdAt: Scalars['DateTime']['output'];
  customerId: Maybe<Scalars['ID']['output']>;
  enrollmentApplicationStatus: Maybe<Scalars['JSON']['output']>;
  enrollmentApprovedAt: Maybe<Scalars['DateTime']['output']>;
  enrollmentAuthorizationData: Scalars['JSON']['output'];
  enrollmentProgramId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  manufacturerSiteId: Scalars['String']['output'];
  manufacturerUserId: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  referenceId: Maybe<Scalars['String']['output']>;
  siteId: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['ID']['output'];
};

export type EnphaseGridServicesEnrollmentsInput = {
  manufacturerSiteId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type EnphaseGridServicesEnrollmentsResponse = {
  __typename?: 'EnphaseGridServicesEnrollmentsResponse';
  enrollments: Array<EnphaseGridServicesEnrollment>;
};

export type Enrollment = {
  __typename?: 'Enrollment';
  address: Maybe<Scalars['JSON']['output']>;
  connectLink: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customer: Maybe<Customer>;
  customerId: Maybe<Scalars['ID']['output']>;
  deletedAt: Maybe<Scalars['DateTime']['output']>;
  deviceIds: Array<Scalars['ID']['output']>;
  devices: Array<Device>;
  eligibilityChecks: Array<EligibilityCheck>;
  eligibilityReason: Maybe<Scalars['String']['output']>;
  eligibilityStatus: EligibilityStatus;
  eligibilityStatusUpdatedAt: Maybe<Scalars['DateTime']['output']>;
  email: Maybe<Scalars['String']['output']>;
  enrollmentId: Maybe<Scalars['ID']['output']>;
  enrollmentStartDate: Maybe<Scalars['DateTime']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  group: Maybe<EnrollmentGroup>;
  id: Scalars['ID']['output'];
  identificationType: IdentificationType;
  lastName: Maybe<Scalars['String']['output']>;
  lead: Maybe<Lead>;
  leadId: Maybe<Scalars['ID']['output']>;
  lifecycleInstance: Maybe<LifecycleInstance>;
  manufacturerSlugs: Array<Scalars['String']['output']>;
  metadata: Maybe<Scalars['JSON']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  programSpecificFields: Maybe<Scalars['JSON']['output']>;
  referenceDescription: Maybe<Scalars['String']['output']>;
  referenceId: Maybe<Scalars['String']['output']>;
  serialNumber: Maybe<Scalars['String']['output']>;
  site: Maybe<Site>;
  siteId: Maybe<Scalars['ID']['output']>;
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploads: Array<EnrollmentUpload>;
  workspaceProgram: WorkspaceProgram;
  workspaceProgramId: Scalars['ID']['output'];
};

export type EnrollmentDocumentStatus =
  | 'pending_review'
  | 'rejected'
  | 'verified';

export type EnrollmentDocumentType =
  | 'other'
  | 'proof_of_purchase'
  | 'utility_bill'
  | 'vehicle_registration';

export type EnrollmentGroup = {
  __typename?: 'EnrollmentGroup';
  enrollments: Maybe<EnrollmentPaginatedQueryPayload>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type EnrollmentGroupEnrollmentsArgs = {
  input: EnrollmentInput;
};

export type EnrollmentGrowthDataPoint = {
  __typename?: 'EnrollmentGrowthDataPoint';
  count: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
};

export type EnrollmentInput = {
  pagination?: InputMaybe<OffsetPagination>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type EnrollmentPaginatedQueryPayload = {
  __typename?: 'EnrollmentPaginatedQueryPayload';
  data: Array<Enrollment>;
  meta: ListPayloadMeta;
};

export type EnrollmentReportConfig = {
  __typename?: 'EnrollmentReportConfig';
  createdAt: Scalars['DateTime']['output'];
  cronExpression: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSentAt: Maybe<Scalars['DateTime']['output']>;
  lastSentCount: Maybe<Scalars['Int']['output']>;
  manufacturerSlugs: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recipientEmails: Array<Scalars['String']['output']>;
  timeWindowDays: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceProgramId: Scalars['ID']['output'];
};

export type EnrollmentUpload = {
  __typename?: 'EnrollmentUpload';
  documentType: EnrollmentDocumentType;
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  rejectedAt: Maybe<Scalars['DateTime']['output']>;
  rejectedReason: Maybe<Scalars['String']['output']>;
  sizeBytes: Maybe<Scalars['Int']['output']>;
  status: EnrollmentDocumentStatus;
  uploadId: Scalars['ID']['output'];
  uploadedAt: Maybe<Scalars['DateTime']['output']>;
  verifiedAt: Maybe<Scalars['DateTime']['output']>;
  verifiedById: Maybe<Scalars['ID']['output']>;
};

export type ErcotDayAheadMarketSettlementPointPrice = {
  __typename?: 'ErcotDayAheadMarketSettlementPointPrice';
  daylightSavingsTimeFlag: Scalars['Boolean']['output'];
  deliveryDate: Scalars['String']['output'];
  hourEnding: Scalars['String']['output'];
  settlementPoint: Scalars['String']['output'];
  settlementPointPrice: Scalars['Float']['output'];
};

export type ErcotDayAheadMarketSettlementPointPriceResponse = {
  __typename?: 'ErcotDayAheadMarketSettlementPointPriceResponse';
  data: Array<Maybe<ErcotDayAheadMarketSettlementPointPrice>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ErrorCode =
  | 'INVALID_INPUT';

export type EvaluateLifecycleInstanceInput = {
  lifecycleInstanceId: Scalars['String']['input'];
};

export type EvaluateLifecycleInstanceResult = {
  __typename?: 'EvaluateLifecycleInstanceResult';
  error: Maybe<Scalars['String']['output']>;
  instance: LifecycleInstance;
  missingRequirements: Maybe<Array<Scalars['String']['output']>>;
  outcome: EvaluationOutcome;
  transitions: Array<EvaluationTransitionStep>;
};

/** Why evaluation stopped. */
export type EvaluationOutcome =
  | 'ADVANCED'
  | 'ALREADY_TERMINAL'
  | 'LOOP_GUARD'
  | 'NO_PASSING_TRANSITION'
  | 'PARTIAL'
  | 'REQUIREMENTS_NOT_MET'
  | 'TERMINAL';

export type EvaluationTransitionStep = {
  __typename?: 'EvaluationTransitionStep';
  fromStageId: Scalars['String']['output'];
  fromStageSlug: Scalars['String']['output'];
  toStageId: Scalars['String']['output'];
  toStageSlug: Scalars['String']['output'];
};

export type Event = {
  __typename?: 'Event';
  eventType: EventType;
  id: Scalars['ID']['output'];
  payload: Scalars['JSON']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type EventInput = {
  eventTypes?: InputMaybe<Array<InputMaybe<EventType>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type EventPerformanceReport = {
  __typename?: 'EventPerformanceReport';
  /** Energy range for color scaling */
  energyRange: EnergyRange;
  /** Event rows for heatmap display (pre-aggregated by hour) */
  events: Array<EventPerformanceRow>;
  /** Metadata about the query */
  meta: ProgramReportMeta;
  /** Summary KPI metrics (pre-calculated) */
  summary: EventPerformanceSummary;
};

export type EventPerformanceRow = {
  __typename?: 'EventPerformanceRow';
  /** Average participation rate across hours (0-100) */
  avgParticipationRate: Scalars['Float']['output'];
  /** Batch metrics for this event */
  batchMetrics: ReportBatchMetrics;
  /** Duration in hours */
  durationHours: Scalars['Int']['output'];
  /** Event end time */
  endsAt: Maybe<Scalars['DateTime']['output']>;
  /** Hourly breakdown data */
  hourlyBuckets: Array<HourlyEnergyBucket>;
  /** Event ID */
  id: Scalars['ID']['output'];
  /** Formatted label for display (e.g., "Jan 15, 2024") */
  label: Scalars['String']['output'];
  /** Starting hour of the event (0-23) */
  startHour: Scalars['Int']['output'];
  /** Event start time */
  startsAt: Scalars['DateTime']['output'];
  /** Total energy for this event (kWh) */
  totalEnergyKwh: Scalars['Float']['output'];
};

export type EventPerformanceSummary = {
  __typename?: 'EventPerformanceSummary';
  /** Average peak kW across events */
  avgPeakKw: Scalars['Float']['output'];
  /** Unique devices enrolled across all events */
  devicesEnrolled: Scalars['Int']['output'];
  /** Unique devices that participated (had successful command) */
  devicesParticipated: Scalars['Int']['output'];
  /** Success rate: succeeded commands / issued commands (0-100) */
  successRate: Scalars['Float']['output'];
  /** Total energy delivered across all events (kWh) */
  totalEnergyKwh: Scalars['Float']['output'];
  /** Total number of events in the report */
  totalEvents: Scalars['Int']['output'];
};

export type EventType =
  | 'ALERT_CREATED'
  | 'ALERT_UPDATED'
  | 'COMMAND_FAILED'
  | 'COMMAND_OVERRIDDEN'
  | 'COMMAND_SCHEDULED'
  | 'COMMAND_SUCCEEDED'
  | 'CONNECTION_FAILED'
  | 'CUSTOMER_CREATED'
  | 'CUSTOMER_DELETED'
  | 'CUSTOMER_UPDATED'
  | 'DEVICE_CONNECTED'
  | 'DEVICE_DISCONNECTED'
  | 'DEVICE_DISCOVERED'
  | 'DEVICE_UPDATED'
  | 'ENROLLMENT_APPROVED'
  | 'ENROLLMENT_REJECTED'
  | 'ENROLLMENT_SUBMITTED'
  | 'SITE_CREATED'
  | 'SITE_DELETED'
  | 'SITE_UPDATED';

export type ExchangeApiKeyForOwnerTokenInput = {
  apiKey: Scalars['String']['input'];
};

export type ExecuteBatchInput = {
  batchId: Scalars['ID']['input'];
};

/** Input for executing a workflow with parameters */
export type ExecuteWorkflowInput = {
  /** Runtime parameters to pass to the workflow execution */
  parameters?: InputMaybe<Scalars['JSON']['input']>;
  /** Trigger context information */
  triggerContext?: InputMaybe<Scalars['JSON']['input']>;
};

export type ExpirationInput = {
  /** The iso8601 date time string that the session should expire at. */
  at?: InputMaybe<Scalars['DateTime']['input']>;
  /** The duration in seconds that the session should be valid for. */
  in?: InputMaybe<Scalars['Int']['input']>;
};

/** The type of entity a lifecycle field collects data about */
export type FactEntity =
  /** A customer contact */
  | 'CONTACT'
  /** A connected device */
  | 'DEVICE'
  /** A program enrollment */
  | 'ENROLLMENT'
  /** A physical site/location */
  | 'SITE';

export type FetchOrCreateScopedApiKeyForCustomerInput = {
  customerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type FieldConfiguration = {
  __typename?: 'FieldConfiguration';
  configSchema: Scalars['JSON']['output'];
  contexts: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  entityType: Scalars['String']['output'];
  factKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FieldSearchInput = {
  query: Scalars['String']['input'];
  type: PaginatedQuerySearchTypeEnum;
};

/** Whether a field is defined by the platform registry or by an operator */
export type FieldSource =
  /** Operator-defined custom field scoped to a lifecycle definition */
  | 'CUSTOM'
  /** Built-in field from the Texture platform field registry */
  | 'PLATFORM';

export type FilterMeta = {
  __typename?: 'FilterMeta';
  field: Scalars['String']['output'];
  options: Maybe<Array<Maybe<FilterMetaOption>>>;
  stats: Maybe<FilterMetaStats>;
  type: Scalars['String']['output'];
};

export type FilterMetaOption = {
  __typename?: 'FilterMetaOption';
  count: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type FilterMetaStats = {
  __typename?: 'FilterMetaStats';
  avg: Scalars['Float']['output'];
  count: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  sum: Scalars['Float']['output'];
};

export type FleetHealthDeviceFilterInput = {
  /** Filter by device type */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /** Filter by health status */
  status?: InputMaybe<FleetHealthStatusFilter>;
};

export type FleetHealthDeviceRow = {
  __typename?: 'FleetHealthDeviceRow';
  /**
   * Average response time in seconds over the selected time window.
   * Defaults to 30 days if no timeScope provided. Null if no completed commands in period.
   */
  avgResponseSeconds: Maybe<Scalars['Float']['output']>;
  /** Device ID (DeviceOnWorkspace ID) */
  deviceId: Scalars['ID']['output'];
  /** Device display name */
  deviceName: Scalars['String']['output'];
  /** Device type for display */
  deviceType: ReportDeviceDisplayType;
  /** Clean model display name */
  displayModelName: Maybe<Scalars['String']['output']>;
  /** List of issues (empty if healthy) */
  issues: Array<FleetHealthIssue>;
  /** Device manufacturer slug */
  manufacturer: Scalars['String']['output'];
  /** Clean manufacturer display name */
  manufacturerDisplayName: Maybe<Scalars['String']['output']>;
  /** Manufacturer logo URL */
  manufacturerLogoUrl: Maybe<Scalars['String']['output']>;
  /** Owner/member name (from identity domain) */
  memberName: Maybe<Scalars['String']['output']>;
  /** Device model slug */
  model: Scalars['String']['output'];
  /**
   * Program enrollments - only populated in portfolio view.
   * Displayed as comma-separated links.
   */
  programEnrollments: Maybe<Array<ProgramEnrollmentRef>>;
  /** Current connection status */
  status: FleetHealthStatus;
  /**
   * Command success rate over the selected time window (0-100).
   * Defaults to 30 days if no timeScope provided. Null if no commands in period.
   */
  successPercent: Maybe<Scalars['Float']['output']>;
  /**
   * Uptime percentage over the selected time window (defaults to 30 days).
   * NOTE: Returns null - historical connectivity tracking not yet implemented.
   */
  uptimePercent: Maybe<Scalars['Float']['output']>;
};

/**
 * Filter input for fleet health report.
 * Supports configurable time windows (30, 60, 90 days or custom date range).
 */
export type FleetHealthFilterInput = {
  /** Device-level filters (optional) */
  deviceFilters?: InputMaybe<FleetHealthDeviceFilterInput>;
  /** Program scope determines which programs to include */
  programScope: ProgramScopeInput;
  /** Time scope for metrics calculation (optional - defaults to 30 days) */
  timeScope?: InputMaybe<TimeScopeInput>;
  /** Workspace context for authorization and data scoping */
  workspaceId: Scalars['ID']['input'];
};

export type FleetHealthIssue =
  | 'LONG_RESPONSE_TIMES'
  | 'LOW_SUCCESS'
  | 'OFFLINE_OVER_7_DAYS';

export type FleetHealthMeta = {
  __typename?: 'FleetHealthMeta';
  /** Timestamp of data freshness */
  dataAsOf: Scalars['DateTime']['output'];
  /** Number of devices in report */
  deviceCount: Scalars['Int']['output'];
  /** Time window label for display (e.g., "Last 30 days") */
  timeWindowLabel: Scalars['String']['output'];
};

export type FleetHealthReport = {
  __typename?: 'FleetHealthReport';
  /** Device health rows */
  devices: Array<FleetHealthDeviceRow>;
  /** Metadata about the report */
  meta: FleetHealthMeta;
  /** Summary KPI metrics */
  summary: FleetHealthSummary;
};

export type FleetHealthStatus =
  | 'OFFLINE'
  | 'ONLINE';

export type FleetHealthStatusFilter =
  | 'ALL'
  | 'NEEDS_ATTENTION'
  | 'OFFLINE'
  | 'ONLINE';

export type FleetHealthSummary = {
  __typename?: 'FleetHealthSummary';
  /** Devices needing attention (any issue) */
  needsAttention: Scalars['Int']['output'];
  /** Devices currently offline */
  offline: Scalars['Int']['output'];
  /** Percentage of devices offline (0-100) */
  offlinePercent: Scalars['Float']['output'];
  /** Devices currently online */
  online: Scalars['Int']['output'];
  /** Percentage of devices online (0-100) */
  onlinePercent: Scalars['Float']['output'];
  /** Total enrolled devices */
  total: Scalars['Int']['output'];
};

export type FranklinWhCredentials = {
  __typename?: 'FranklinWHCredentials';
  ck: Scalars['String']['output'];
  cp: Scalars['String']['output'];
  environment: Maybe<Scalars['String']['output']>;
};

export type FranklinWhGrant = {
  __typename?: 'FranklinWHGrant';
  credentialId: Maybe<Scalars['ID']['output']>;
  credentials: Maybe<FranklinWhCredentials>;
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * Holds all information about the full grid element hierarchy for a given Site.
 * In this model, the Site is the bottom of the hierarchy. This is an inversion
 * of typical GraphQL convention where a type's fields represent it's children
 * and it's containing type it's parent. In this case, the Site is the "child" of
 * the Grid Elements above it.
 */
export type FullGridElementHierarchyForSite = {
  __typename?: 'FullGridElementHierarchyForSite';
  /**
   * Array representation of the full ancestor hierarchy for the Site's Grid
   * Elements up to a substation (source). Line segments are collapsed.
   */
  fullAncestorArray: Array<GridElement>;
  /** Nested JSON representation with parent references (bottom-up structure). */
  fullAncestorJsonPath: Scalars['JSON']['output'];
  site: Site;
};

export type GenerateConnectLinkForCredentialInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerInfo?: InputMaybe<CustomerInfoInput>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateStatementDownloadUrlInput = {
  provider: Scalars['String']['input'];
  statementId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type GenerateStatementDownloadUrlResponse = {
  __typename?: 'GenerateStatementDownloadUrlResponse';
  message: Maybe<Scalars['String']['output']>;
  statementUrl: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Generic error for other verification issues */
export type GenericError = IMutationError & {
  __typename?: 'GenericError';
  message: Scalars['String']['output'];
};

/** Input for getting collections for a workspace */
export type GetCollectionsForWorkspaceInput = {
  /** Filter criteria for collections */
  filter: CollectionsFilter;
  /** Optional pagination parameters */
  pagination?: InputMaybe<ListPagination>;
};

export type GetEntitiesByCollectionIdInput = {
  /** Optional pagination parameters */
  pagination?: InputMaybe<ListPagination>;
};

export type Grant = {
  __typename?: 'Grant';
  credentials: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  pollingCronPattern: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  workspaceId: Scalars['ID']['output'];
};

/** Input for granting super admin access */
export type GrantSuperAdminInput = {
  /** Optional expiration date for the grant. If not provided, the grant is indefinite. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional reason for granting access */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user to grant super admin access to */
  userId: Scalars['ID']['input'];
};

/**
 * Represents a grid element in the hierarchy. For overhead/underground line
 * elements, this returns a virtual collapsed representation where consecutive
 * line sections are aggregated into a single logical element. Non-line elements
 * are returned as-is from the database.
 */
export type GridElement = {
  __typename?: 'GridElement';
  /** Reference to the child GridElement(s) */
  children: Array<GridElement>;
  /**
   * Number of underlying elements. 1 for equipment, >1 for collapsed line
   * segments.
   */
  collapsedCount: Scalars['Int']['output'];
  /**
   * IDs of all underlying elements that were collapsed together. Only populated
   * if isCollapsed is true. For single elements, this is null.
   */
  collapsedElementIds: Maybe<Array<Scalars['ID']['output']>>;
  /**
   * Names of all underlying elements that were collapsed together. Only
   * populated if isCollapsed is true. For single elements, this is null.
   */
  collapsedElementNames: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  /**
   * Display-oriented metadata for this grid element, suitable for rendering in
   * a UI (e.g. icon hints, label overrides, colour coding).
   */
  displayMetadata: Scalars['JSON']['output'];
  /**
   * Human-readable display name. For equipment: same as elementName. For
   * collapsed line segments: "Overhead Line Segment (X sections)".
   */
  displayName: Scalars['String']['output'];
  /**
   * Consumer-type grid elements directly downstream of this grid element
   * that are NOT matched to a Texture device, up to the given limit. Returns
   * a connection object with totalConsumerSubtreeCount and the consumer list.
   */
  downstreamConsumers: DownstreamConsumerConnection;
  /**
   * Devices (DERs) directly downstream of this grid element, up to the given
   * limit. Returns a connection object with totalConsumerSubtreeCount and the device list.
   */
  downstreamDevices: DownstreamDeviceConnection;
  /**
   * Name of this grid element. For collapsed line segments, this is the name of
   * the first (head) element in the segment.
   */
  elementName: Scalars['String']['output'];
  elementType: GridElementType;
  elementTypeName: Scalars['String']['output'];
  /**
   * Unique identifier for the GridElement. For collapsed line segments, this is
   * the firstElementId.
   */
  id: Scalars['ID']['output'];
  /** Indicates if this element represents multiple collapsed underlying elements. */
  isCollapsed: Scalars['Boolean']['output'];
  /** Latitude coordinate. For collapsed segments, uses the first element's location. */
  latitude: Scalars['Float']['output'];
  /** Longitude coordinate. For collapsed segments, uses the first element's location. */
  longitude: Scalars['Float']['output'];
  /**
   * Element-specific metadata stored as JSON. For collapsed segments, includes
   * collapse information. For equipment, includes type-specific attributes.
   */
  metadata: Scalars['JSON']['output'];
  /** Reference to the logical parent GridElement */
  parent: Maybe<GridElement>;
  /**
   * Identifier for the logical parent GridElement (parent segment's
   * firstElementId for lines)
   */
  parentId: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * Represents a grid element in the hierarchy. For overhead/underground line
 * elements, this returns a virtual collapsed representation where consecutive
 * line sections are aggregated into a single logical element. Non-line elements
 * are returned as-is from the database.
 */
export type GridElementDownstreamConsumersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Represents a grid element in the hierarchy. For overhead/underground line
 * elements, this returns a virtual collapsed representation where consecutive
 * line sections are aggregated into a single logical element. Non-line elements
 * are returned as-is from the database.
 */
export type GridElementDownstreamDevicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GridElementType =
  | 'CAPACITOR'
  /**
   * Consumers represent meters and will always be at the bottom of the
   * hierarchy, connecting to a Site.
   */
  | 'CONSUMER'
  | 'GENERATOR'
  | 'MOTOR'
  | 'NODE'
  | 'OVERCURRENT_DEVICE'
  | 'OVERHEAD_LINE'
  | 'REGULATOR'
  /**
   * Sources represent substations and will always be at the top of the
   * hierarchy.
   */
  | 'SOURCE'
  | 'SWITCH'
  | 'TRANSFORMER'
  | 'UNDERGROUND_LINE';

export type GridStatus =
  | 'exporting'
  | 'idle'
  | 'importing'
  | 'unknown';

/** A data point in the growth statistics time series */
export type GrowthDataPoint = {
  __typename?: 'GrowthDataPoint';
  /** The cumulative count at this date */
  count: Scalars['Int']['output'];
  /** The date for this data point */
  date: Scalars['DateTime']['output'];
};

/** Input type for growth statistics queries */
export type GrowthStatsInput = {
  /** End date for the growth stats period */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Start date for the growth stats period */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The workspace ID to fetch growth stats for */
  workspaceId: Scalars['ID']['input'];
};

/** Health status indicators */
export type HealthStatus =
  | 'DEGRADED'
  | 'HEALTHY'
  | 'UNHEALTHY'
  | 'UNKNOWN';

/**
 * Which level of the SCADA hierarchy to group results by when rolling up.
 * SOURCE = no rollup, one series per source.
 * SCADA_PARENT = aggregate children to their immediate parent node.
 * SCADA_ANCESTOR = aggregate all the way up to the subtree root.
 */
export type HierarchyGroupBy =
  | 'SCADA_ANCESTOR'
  | 'SCADA_PARENT'
  | 'SOURCE';

/**
 * How to combine values from multiple sources when rolling up a hierarchy.
 * Applied when multiple child nodes are aggregated to a parent — e.g.,
 * summing meter loads to get total transformer load, or taking the max
 * voltage across phases.
 * Example: SUM the real_power of 3 meters to get the transformer's total load;
 * AVG voltage readings across child nodes; MAX to find the worst-case value.
 */
export type HierarchyReducer =
  | 'AVG'
  | 'MAX'
  | 'SUM';

export type HourlyEnergyBucket = {
  __typename?: 'HourlyEnergyBucket';
  /** Timestamp for this hourly bucket */
  bucket: Scalars['DateTime']['output'];
  /** Number of devices that reported data this hour */
  deviceCount: Scalars['Int']['output'];
  /** Energy for this hour (kWh) */
  energyKwh: Scalars['Float']['output'];
  /** Participation rate for this hour (0-100) */
  participationRate: Scalars['Float']['output'];
};

export type ILocation = {
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
};

export type IMutationError = {
  message: Scalars['String']['output'];
};

/** Interface for mutation responses */
export type IMutationResponse = {
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type IdentificationType =
  | 'customerId'
  | 'customerInfo'
  | 'enrollmentId'
  | 'leadId';

export type IdentityCredentials = {
  __typename?: 'IdentityCredentials';
  bearerToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type InitLifecycleInstanceInput = {
  workspaceProgramId: Scalars['ID']['input'];
};

/** Input for initiating authentication */
export type InitiateAuthenticationInput = {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type InverterState = {
  __typename?: 'InverterState';
  batteryState: Maybe<BatteryState>;
  createdAt: Scalars['DateTime']['output'];
  generatedEnergy: Maybe<Scalars['Float']['output']>;
  gridEnergy: Maybe<Scalars['Int']['output']>;
  gridPower: Maybe<Scalars['Int']['output']>;
  gridStatus: GridStatus;
  id: Scalars['ID']['output'];
  lifetimeEnergyGenerated: Maybe<Scalars['Float']['output']>;
  loadEnergy: Maybe<Scalars['Float']['output']>;
  loadPower: Maybe<Scalars['Float']['output']>;
  power: Scalars['Float']['output'];
};

/** Inverter state input. Matches InverterState DB schema. */
export type InverterStateInput = {
  createdAt: Scalars['DateTime']['input'];
  gridEnergy?: InputMaybe<Scalars['Int']['input']>;
  gridPower?: InputMaybe<Scalars['Int']['input']>;
  gridStatus?: InputMaybe<GridStatus>;
  power: Scalars['Int']['input'];
};

export type InverterStaticState = {
  __typename?: 'InverterStaticState';
  power: Scalars['Float']['output'];
};

export type Invitation = {
  __typename?: 'Invitation';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Use invitedByProfile instead */
  invitedBy: Maybe<User>;
  /** The profile of the user who invited the invitee. */
  invitedByProfile: Maybe<UserProfile>;
  invitedToOrganization: Maybe<Organization>;
  organization: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  role: Role;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  status: InvitationStatus;
  updatedAt: Scalars['DateTime']['output'];
  userExists: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type InvitationPaginatedQueryPayload = {
  __typename?: 'InvitationPaginatedQueryPayload';
  data: Maybe<Array<Invitation>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type InvitationStatus =
  | 'ACCEPTED'
  | 'PENDING'
  | 'REVOKED';

export type JoinOrganizationInput = {
  userId: Scalars['String']['input'];
};

export type Lead = {
  __typename?: 'Lead';
  address1: Maybe<Scalars['String']['output']>;
  address2: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields: Maybe<Scalars['JSON']['output']>;
  email: Scalars['String']['output'];
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  metadata: Maybe<Scalars['JSON']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeadEvent = {
  __typename?: 'LeadEvent';
  createdAt: Scalars['DateTime']['output'];
  data: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lead: Lead;
  leadId: Scalars['String']['output'];
  type: LeadEventType;
};

export type LeadEventType =
  | 'ENROLLMENT_SUBMITTED'
  | 'IP_ADDRESS_CAPTURED'
  | 'TERMS_AGREED';

export type LeadForWorkspaceOrderByInput = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
};

export type LeadSource =
  | 'COLD_CALL'
  | 'EVENT'
  | 'PROGRAM'
  | 'REFERRAL'
  | 'WEBSITE';

export type LeadStatus =
  | 'CONTACTED'
  | 'CONVERTED'
  | 'LOST'
  | 'NEW'
  | 'QUALIFIED';

export type LeadWithEligibilityCheck = {
  __typename?: 'LeadWithEligibilityCheck';
  address1: Scalars['String']['output'];
  address2: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  connectLink: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields: Maybe<Scalars['JSON']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEligible: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  metadata: Maybe<Scalars['JSON']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LeadsForWorkspaceFilter = {
  workspaceId: Scalars['String']['input'];
};

export type LeadsForWorkspaceInput = {
  filter: LeadsForWorkspaceFilter;
  orderBy?: InputMaybe<LeadForWorkspaceOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<LeadsForWorkspaceSearch>;
};

export type LeadsForWorkspaceSearch = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type LeadsPaginatedQueryPayload = {
  __typename?: 'LeadsPaginatedQueryPayload';
  data: Array<Lead>;
  meta: ListPayloadMeta;
};

export type LifecycleConnectAuthorization = {
  __typename?: 'LifecycleConnectAuthorization';
  type: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
};

/** An operator-defined custom field scoped to a lifecycle definition. */
export type LifecycleCustomField = {
  __typename?: 'LifecycleCustomField';
  /** Optional type-specific configuration (e.g., select options) */
  config: Maybe<Scalars['JSON']['output']>;
  /** When this field was created */
  createdAt: Scalars['DateTime']['output'];
  /** Human-readable label */
  displayName: Scalars['String']['output'];
  /** Which entity this field collects data about (CONTACT, SITE, DEVICE, ENROLLMENT) */
  entityType: Scalars['String']['output'];
  /** The data bag key for this field (must be unique per definition) */
  factKey: Scalars['String']['output'];
  /** The data type (text, email, phone, boolean, number, date, select, etc.) */
  fieldType: Scalars['String']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** The lifecycle definition this field belongs to */
  lifecycleDefinitionId: Scalars['ID']['output'];
  /** When this field was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * A lifecycle definition defines the stages that an entity moves through.
 * For programs, each Program has one LifecycleDefinition once configured.
 */
export type LifecycleDefinition = {
  __typename?: 'LifecycleDefinition';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  entityId: Scalars['String']['output'];
  entityType: LifecycleDefinitionEntityType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Known attribute keys for building transition rules. Combines requirement slugs and system-written keys. */
  ruleAttributes: Array<RuleAttribute>;
  stages: Array<StageDefinition>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LifecycleDefinitionEntityType =
  | 'PROGRAM';

export type LifecycleEventRecord = {
  __typename?: 'LifecycleEventRecord';
  actor: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payload: Scalars['JSON']['output'];
  sequence: Scalars['Int']['output'];
};

/**
 * The runtime state of a single entity's journey through the lifecycle.
 * For enrollments, tracks current stage, collected data, and evaluation results.
 */
export type LifecycleInstance = {
  __typename?: 'LifecycleInstance';
  /** What the client needs to do to advance this instance */
  actionRequired: ActionRequired;
  checkResults: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentStage: StageDefinition;
  data: Scalars['JSON']['output'];
  entityId: Maybe<Scalars['String']['output']>;
  entityType: LifecycleInstanceEntityType;
  /** Full event log for debugging. Optional eventTypes filter. */
  eventLog: Array<LifecycleEventRecord>;
  id: Scalars['ID']['output'];
  /** Timestamp of the most recent lifecycle event (fact write, transition, or evaluation) */
  lastActivityAt: Maybe<Scalars['DateTime']['output']>;
  lifecycleDefinition: LifecycleDefinition;
  /** Computed state status: requirement satisfaction and transition readiness */
  stateStatus: LifecycleStateStatus;
  /** Transition history from audit events, ordered chronologically */
  transitionHistory: Array<LifecycleTransitionRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/**
 * The runtime state of a single entity's journey through the lifecycle.
 * For enrollments, tracks current stage, collected data, and evaluation results.
 */
export type LifecycleInstanceEventLogArgs = {
  eventTypes: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LifecycleInstanceEntityType =
  | 'ENROLLMENT';

export type LifecycleInstancePaginatedPayload = {
  __typename?: 'LifecycleInstancePaginatedPayload';
  data: Array<LifecycleInstance>;
  meta: ListPayloadMeta;
};

/** Aggregated state status for a lifecycle instance's current stage. */
export type LifecycleStateStatus = {
  __typename?: 'LifecycleStateStatus';
  /** True if all applicable required requirements are satisfied */
  allRequirementsMet: Scalars['Boolean']['output'];
  /** The first transition (by array order) that is ready, or null */
  readyTransition: Maybe<TransitionStatus>;
  requirements: Array<RequirementStatus>;
  transitions: Array<TransitionStatus>;
};

export type LifecycleTransitionRecord = {
  __typename?: 'LifecycleTransitionRecord';
  actor: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fromStage: Maybe<StageDefinition>;
  id: Scalars['ID']['output'];
  reason: Maybe<Scalars['String']['output']>;
  toStage: Maybe<StageDefinition>;
};

export type LinkSessionConfigDefaults = {
  __typename?: 'LinkSessionConfigDefaults';
  clientName: Maybe<Scalars['String']['output']>;
  manufacturerFilters: Maybe<ManufacturerFilters>;
  params: Maybe<Scalars['JSON']['output']>;
  redirectUrl: Maybe<Scalars['String']['output']>;
  source: Maybe<Scalars['String']['output']>;
  tags: Maybe<Array<Scalars['String']['output']>>;
};

export type LinkSessionConfigDefaultsInput = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  manufacturerFilters?: InputMaybe<ManufacturerFiltersInput>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input type for specifying pagination using either offset or cursor-based strategies. */
export type ListPagination = {
  /** Cursor-based pagination options. */
  cursor?: InputMaybe<CursorPagination>;
  /** Offset-based pagination options. */
  offset?: InputMaybe<OffsetPagination>;
};

export type ListPayloadMeta = {
  __typename?: 'ListPayloadMeta';
  count: Scalars['Int']['output'];
  filters: Maybe<ListPayloadMetaFilters>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  pagination: Maybe<ListPayloadMetaPagination>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ListPayloadMetaFilters = {
  __typename?: 'ListPayloadMetaFilters';
  current: Maybe<Array<FilterMeta>>;
  default: Maybe<Array<FilterMeta>>;
};

export type ListPayloadMetaPagination = {
  __typename?: 'ListPayloadMetaPagination';
  cursor: Maybe<CursorPaginationInfo>;
  offset: Maybe<OffsetPaginationInfo>;
};

export type LoadZone = {
  __typename?: 'LoadZone';
  externalName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Location = ILocation & {
  __typename?: 'Location';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fullAddress: Scalars['String']['output'];
  hashedAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  postalCode: Scalars['String']['output'];
  state: Maybe<Scalars['String']['output']>;
  streetOne: Maybe<Scalars['String']['output']>;
  streetTwo: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LocationInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetOne: Scalars['String']['input'];
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type LoggedUser = UserFields & {
  __typename?: 'LoggedUser';
  /** Whether the user's email addresses are verified. */
  areEmailsVerified: Scalars['Boolean']['output'];
  /** User's logs from Texture's auth provider */
  authProviderLogs: AuthProviderLogPaginatedQueryPayload;
  /** Organization to which user is currently authenticated */
  authenticatedOrganization: Maybe<Organization>;
  /** The timestamp the user was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The email address that the user is currently authenticated with. */
  email: Maybe<Email>;
  /** The user's email addresses. */
  emails: Maybe<Array<Maybe<Email>>>;
  /** The unique identifier for the user issued by the external identity provider. */
  externalUserId: Scalars['String']['output'];
  /** @deprecated This field is accessed on the UserProfile type */
  firstName: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is accessed on the UserProfile type */
  fullName: Maybe<Scalars['String']['output']>;
  /**
   * The unique identifier for the user issued by Texture. This is the primary key for the user record.
   * It is a [CUID](https://github.com/paralleldrive/cuid?tab=readme-ov-file#motivation) generated by Prisma.
   */
  id: Scalars['String']['output'];
  /** Logged user loggedUser invitations */
  invitations: Maybe<Array<LoggedUserInvitation>>;
  /** Whether the user is a Texture employee. */
  isTextureEmployee: Scalars['Boolean']['output'];
  /** The ID of the organization the user most recently authenticated to. */
  lastAuthenticatedOrganizationId: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is accessed on the UserProfile type */
  lastName: Maybe<Scalars['String']['output']>;
  /** The memberships to organizations the user is a part of. */
  memberships: Maybe<Array<Maybe<Membership>>>;
  profile: UserProfile;
  /** @deprecated This field is accessed on the UserProfile type */
  profilePhoto: Maybe<Scalars['String']['output']>;
  /** User's login sessions for tracking authentication history */
  sessions: SessionPaginatedQueryPayload;
  /** @deprecated We use auth0 */
  supertokensId: Scalars['String']['output'];
  /** The timestamp the user was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The workspace invitations the logged user has received. */
  workspaceInvitations: Maybe<Array<WorkspaceInvitation>>;
};


export type LoggedUserAuthProviderLogsArgs = {
  input: InputMaybe<AuthProviderLogsInput>;
};


export type LoggedUserInvitationsArgs = {
  input: InputMaybe<LoggedUserInvitationsInput>;
};


export type LoggedUserSessionsArgs = {
  input: InputMaybe<SessionsInput>;
};

export type LoggedUserInvitation = {
  __typename?: 'LoggedUserInvitation';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The profile of the user who invited the invitee. */
  invitedByProfile: Maybe<UserProfile>;
  invitedToOrganization: Maybe<Organization>;
  organization: Maybe<LoggedUserInvitationOrganization>;
  role: Role;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  status: InvitationStatus;
  updatedAt: Scalars['DateTime']['output'];
  userExists: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type LoggedUserInvitationOrganization = {
  __typename?: 'LoggedUserInvitationOrganization';
  id: Scalars['String']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
};

export type LoggedUserInvitationsInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<InvitationStatus>;
};

/** A management API audit log entry recording a mutation performed via the Management API. */
export type ManagementAuditLog = {
  __typename?: 'ManagementAuditLog';
  action: Scalars['String']['output'];
  /** Resolved actor details (name, email). Null fields if the actor record was deleted. */
  actor: Maybe<AuditLogActor>;
  actorId: Scalars['String']['output'];
  actorType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata: Maybe<Scalars['JSON']['output']>;
  organizationId: Scalars['String']['output'];
  /** Resolved resource details (label). Null fields if the resource was deleted. */
  resource: Maybe<AuditLogResource>;
  resourceId: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  workspaceId: Maybe<Scalars['String']['output']>;
};

/** Paginated response for management audit logs. */
export type ManagementAuditLogPaginatedPayload = {
  __typename?: 'ManagementAuditLogPaginatedPayload';
  data: Array<ManagementAuditLog>;
  meta: ListPayloadMeta;
};

/** Input for querying management audit logs with optional filters and pagination. */
export type ManagementAuditLogsInput = {
  /** Filter by action type (e.g., 'workspace.create', 'apiKey.revoke'). */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Filter by actor ID (userId or apiKeyId). */
  actorId?: InputMaybe<Scalars['String']['input']>;
  /** Only return logs created on or before this date (ISO 8601). */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The organization to query audit logs for. */
  organizationId: Scalars['String']['input'];
  /** Page number (1-indexed). Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Results per page. Defaults to 50, max 100. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by specific resource ID. */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by resource type (e.g., 'Workspace', 'ApiKey'). */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Only return logs created on or after this date (ISO 8601). */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * Represents an organization's assignment to manage a manufacturer.
 * This is created by Texture admins to grant OEM dashboard access.
 */
export type ManufacturerAssignment = {
  __typename?: 'ManufacturerAssignment';
  createdAt: Scalars['DateTime']['output'];
  /** The admin who created this assignment. */
  createdBy: Maybe<ManufacturerAssignmentCreatedBy>;
  createdById: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  manufacturer: DeviceManufacturerProfile;
  organizationId: Scalars['String']['output'];
};

/** Basic user profile information for the admin who created a manufacturer assignment. */
export type ManufacturerAssignmentCreatedBy = {
  __typename?: 'ManufacturerAssignmentCreatedBy';
  firstName: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  profilePhoto: Maybe<Scalars['String']['output']>;
};

export type ManufacturerCredential = {
  __typename?: 'ManufacturerCredential';
  clientId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  manufacturer: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  params: Maybe<ManufacturerCredentialParams>;
  status: ManufacturerCredentialStatus;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
};

export type ManufacturerCredentialParams = {
  __typename?: 'ManufacturerCredentialParams';
  allowedSystemIds: Maybe<Array<Scalars['String']['output']>>;
  apiKey: Maybe<Scalars['String']['output']>;
  pollingInterval: Maybe<PollingInterval>;
  rateLimitPerMin: Maybe<Scalars['Int']['output']>;
};

export type ManufacturerCredentialParamsInput = {
  allowedSystemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  pollingInterval?: InputMaybe<PollingInterval>;
  rateLimitPerMin?: InputMaybe<Scalars['Int']['input']>;
};

export type ManufacturerCredentialStatus =
  | 'ACTIVE'
  | 'EXHAUSTED';

export type ManufacturerCredentialsInput = {
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type ManufacturerCredentialsResponse = {
  __typename?: 'ManufacturerCredentialsResponse';
  credentials: Array<ManufacturerCredential>;
  error: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

/** A device managed by a manufacturer organization */
export type ManufacturerDevice = {
  __typename?: 'ManufacturerDevice';
  /** When the device was created */
  createdAt: Scalars['DateTime']['output'];
  /** The device model */
  deviceModel: Maybe<ManufacturerDeviceModelInfo>;
  id: Scalars['ID']['output'];
  /** Last time telemetry was received from this device */
  lastSeenAt: Maybe<Scalars['DateTime']['output']>;
  /** The manufacturer's unique identifier for this device */
  manufacturerDeviceId: Scalars['String']['output'];
  /** Friendly name for the device */
  name: Maybe<Scalars['String']['output']>;
  /** Device serial number */
  serialNumber: Maybe<Scalars['String']['output']>;
  /** The site ID where the device is installed (use federation to resolve full site details) */
  siteId: Maybe<Scalars['ID']['output']>;
  /** Device status based on telemetry activity */
  status: ManufacturerDeviceStatus;
};

/**
 * Device model managed by a manufacturer organization.
 * Includes device count for display purposes.
 */
export type ManufacturerDeviceModel = {
  __typename?: 'ManufacturerDeviceModel';
  createdAt: Scalars['DateTime']['output'];
  /** Number of devices using this model */
  deviceCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  manufacturerId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  supportLevel: SupportLevel;
  type: DeviceType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Device model information for manufacturer devices */
export type ManufacturerDeviceModelInfo = {
  __typename?: 'ManufacturerDeviceModelInfo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Input for filtering manufacturer device models */
export type ManufacturerDeviceModelsFilter = {
  /** Search by name or slug (partial match) */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by support level */
  supportLevel?: InputMaybe<SupportLevel>;
  /** Filter by device type */
  type?: InputMaybe<DeviceType>;
};

/** Status of a manufacturer device based on telemetry activity */
export type ManufacturerDeviceStatus =
  /** Telemetry received within the last 24 hours */
  | 'ACTIVE'
  /** Has telemetry history, but not within the last 24 hours */
  | 'INACTIVE'
  /** No telemetry has ever been received */
  | 'NEVER_CONNECTED';

/** Input for filtering manufacturer devices */
export type ManufacturerDevicesFilter = {
  /** Filter by device model ID */
  deviceModelId?: InputMaybe<Scalars['ID']['input']>;
  /** Search by manufacturerDeviceId, serialNumber, or device name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by device status */
  status?: InputMaybe<ManufacturerDeviceStatus>;
};

/** Paginated response for manufacturer devices */
export type ManufacturerDevicesPaginatedPayload = {
  __typename?: 'ManufacturerDevicesPaginatedPayload';
  data: Array<ManufacturerDevice>;
  meta: ManufacturerDevicesPaginationMeta;
};

/** Pagination info for manufacturer devices */
export type ManufacturerDevicesPaginationMeta = {
  __typename?: 'ManufacturerDevicesPaginationMeta';
  count: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ManufacturerFilters = {
  __typename?: 'ManufacturerFilters';
  deviceTypes: Maybe<Array<Scalars['String']['output']>>;
  manufacturers: Maybe<Array<Scalars['String']['output']>>;
};

export type ManufacturerFiltersInput = {
  deviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ManufacturerIntegrationFilters = {
  /** Filter by whether the integration has configuration fields (is configurable) */
  isConfigurable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by manufacturer IDs */
  manufacturerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by manufacturer slugs */
  manufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search query for name, description, or slug */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Filter by specific integration slugs */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by support level */
  supportLevel?: InputMaybe<SupportLevel>;
};

export type ManufacturerIntegrationProfile = {
  __typename?: 'ManufacturerIntegrationProfile';
  configurationFields: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  documentationBlocks: Maybe<Scalars['JSON']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  learnMoreUrl: Maybe<Scalars['String']['output']>;
  logo: Scalars['String']['output'];
  manufacturer: DeviceManufacturerProfile;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  supportLevel: SupportLevel;
  updatedAt: Scalars['DateTime']['output'];
};

export type ManufacturerPollingInterval = {
  __typename?: 'ManufacturerPollingInterval';
  manufacturer: Scalars['String']['output'];
  pollingInterval: PollingInterval;
};

/** Input for querying recent telemetry events. */
export type ManufacturerRecentTelemetryInput = {
  /** Maximum number of events to return (default 20) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The manufacturer ID to get recent telemetry for */
  manufacturerId: Scalars['ID']['input'];
};

/** Aggregated telemetry statistics for a manufacturer. */
export type ManufacturerTelemetryStats = {
  __typename?: 'ManufacturerTelemetryStats';
  /** Number of devices that have sent telemetry (within date range if specified) */
  activeDeviceCount: Scalars['Int']['output'];
  /** Breakdown of devices by type */
  deviceTypeBreakdown: Array<DeviceTypeCount>;
  /** The manufacturer ID */
  manufacturerId: Scalars['ID']['output'];
  /** The manufacturer name */
  manufacturerName: Scalars['String']['output'];
  /** Total number of OEM devices */
  totalDeviceCount: Scalars['Int']['output'];
  /** Total number of telemetry updates received */
  totalTelemetryUpdateCount: Scalars['BigInt']['output'];
};

/** Input for querying manufacturer telemetry statistics. */
export type ManufacturerTelemetryStatsInput = {
  /** End date for filtering active devices and telemetry counts */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The manufacturer ID to get stats for */
  manufacturerId: Scalars['ID']['input'];
  /** Start date for filtering active devices and telemetry counts */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Input for querying manufacturer telemetry time series. */
export type ManufacturerTelemetryTimeSeriesInput = {
  /** Number of days to include (default 7) */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** The manufacturer ID to get time series data for */
  manufacturerId: Scalars['ID']['input'];
};

export type ManufacturerUserConnectionInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Look up by ID directly */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Look up by unique key — all three required together if id is not provided */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type Membership = {
  __typename?: 'Membership';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  organization: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  owner: Scalars['Boolean']['output'];
  role: Role;
  updatedAt: Scalars['DateTime']['output'];
  /** @deprecated Use userProfile instead */
  user: Maybe<User>;
  userId: Scalars['String']['output'];
  userProfile: Maybe<UserProfile>;
};

export type MembershipPaginatedQueryPayload = {
  __typename?: 'MembershipPaginatedQueryPayload';
  data: Maybe<Array<Membership>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type MeterInterval = {
  __typename?: 'MeterInterval';
  /** The consumption from the meter for the period. */
  consumption: Maybe<Scalars['Float']['output']>;
  /** The end date of the period. */
  endDate: Scalars['DateTime']['output'];
  /** The start date of the period. */
  startDate: Scalars['DateTime']['output'];
};

export type MeterIntervalInput = {
  /** The end date of the period. */
  endDate: Scalars['DateTime']['input'];
  /** The start date of the period. */
  startDate: Scalars['DateTime']['input'];
  /** The size which the intervals period should be grouped by. */
  timeFrame?: InputMaybe<Scalars['String']['input']>;
};

/** Interval length for meter data collection */
export type MeterIntervalLength =
  | 'FIFTEEN_MINUTE'
  | 'FIVE_MINUTE'
  | 'ONE_HOUR'
  | 'ONE_MINUTE'
  | 'THIRTY_MINUTE'
  | 'TWENTY_FOUR_HOUR';

export type MeterState = {
  __typename?: 'MeterState';
  createdAt: Scalars['DateTime']['output'];
  /** Current total harmonic distortion */
  currentTHD: Maybe<Scalars['Float']['output']>;
  /** Current unbalance percentage */
  currentUnbalance: Maybe<Scalars['Float']['output']>;
  /** Line frequency in Hz */
  frequency: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** Cost for the last interval */
  lastIntervalCost: Maybe<Scalars['Float']['output']>;
  /** Timestamp of the last interval reading end */
  lastIntervalEndAt: Maybe<Scalars['DateTime']['output']>;
  /** Apparent energy usage in kVAh for the last interval */
  lastIntervalKvahUsage: Maybe<Scalars['Float']['output']>;
  /** Reactive energy usage in kVARh for the last interval */
  lastIntervalKvarhUsage: Maybe<Scalars['Float']['output']>;
  /** Energy usage in kWh for the last interval */
  lastIntervalKwhUsage: Maybe<Scalars['Float']['output']>;
  /** Timestamp of the last interval reading start */
  lastIntervalStartAt: Maybe<Scalars['DateTime']['output']>;
  lastReadingAt: Maybe<Scalars['DateTime']['output']>;
  /** Phase A current in amps */
  phaseACurrent: Maybe<Scalars['Float']['output']>;
  /** Phase A power factor */
  phaseAPowerFactor: Maybe<Scalars['Float']['output']>;
  /** Phase A reactive power in VAR */
  phaseAReactivePower: Maybe<Scalars['Float']['output']>;
  /** Phase A real power in watts */
  phaseARealPower: Maybe<Scalars['Float']['output']>;
  /** Phase A voltage in volts */
  phaseAVoltage: Maybe<Scalars['Float']['output']>;
  /** Phase B current in amps */
  phaseBCurrent: Maybe<Scalars['Float']['output']>;
  /** Phase B power factor */
  phaseBPowerFactor: Maybe<Scalars['Float']['output']>;
  /** Phase B reactive power in VAR */
  phaseBReactivePower: Maybe<Scalars['Float']['output']>;
  /** Phase B real power in watts */
  phaseBRealPower: Maybe<Scalars['Float']['output']>;
  /** Phase B voltage in volts (optional - split-phase and three-phase) */
  phaseBVoltage: Maybe<Scalars['Float']['output']>;
  /** Phase C current in amps */
  phaseCCurrent: Maybe<Scalars['Float']['output']>;
  /** Phase C power factor */
  phaseCPowerFactor: Maybe<Scalars['Float']['output']>;
  /** Phase C reactive power in VAR */
  phaseCReactivePower: Maybe<Scalars['Float']['output']>;
  /** Phase C real power in watts */
  phaseCRealPower: Maybe<Scalars['Float']['output']>;
  /** Phase C voltage in volts (optional - three-phase only) */
  phaseCVoltage: Maybe<Scalars['Float']['output']>;
  /** Displacement power factor */
  powerFactorDisplacement: Maybe<Scalars['Float']['output']>;
  /** Total power factor */
  totalPowerFactor: Maybe<Scalars['Float']['output']>;
  /** Voltage total harmonic distortion */
  voltageTHD: Maybe<Scalars['Float']['output']>;
  /** Voltage unbalance percentage */
  voltageUnbalance: Maybe<Scalars['Float']['output']>;
};

export type MeterStaticState = {
  __typename?: 'MeterStaticState';
  /** The meter's data collection interval length */
  intervalLength: MeterIntervalLength;
  /** The meter manufacturer */
  manufacturer: Scalars['String']['output'];
  /** The unique meter identifier */
  meterId: Scalars['String']['output'];
  /** The owner of the meter (e.g., utility company) */
  owner: Scalars['String']['output'];
  /** The meter's serial number */
  serialNumber: Scalars['String']['output'];
};

export type MetricPayloadResponse = {
  __typename?: 'MetricPayloadResponse';
  data: Array<DataPoint>;
  meta: MetricQueryResponseMeta;
};

export type MetricQueryFilter = {
  deviceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  range?: InputMaybe<MetricQueryRange>;
  siteId?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<Array<DeviceType>>;
  workspaceId: Scalars['ID']['input'];
};

export type MetricQueryInput = {
  /**
   * Options for aggregating metric data across devices.
   * When specified, data will be aggregated according to these options.
   */
  aggregation?: InputMaybe<AggregationOptions>;
  filter: MetricQueryFilter;
  groupBy?: InputMaybe<MetricsQueryGroupByFacet>;
  window?: InputMaybe<MetricsQueryWindow>;
};

export type MetricQueryRange = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  relative?: InputMaybe<Scalars['String']['input']>;
};

export type MetricQueryResponseMeta = {
  __typename?: 'MetricQueryResponseMeta';
  displayUnit: Scalars['String']['output'];
  domainMeta: DomainMeta;
  label: Scalars['String']['output'];
  series: Maybe<Array<Scalars['String']['output']>>;
  sparse: Scalars['Boolean']['output'];
  unit: MetricUnit;
};

export type MetricRate = {
  __typename?: 'MetricRate';
  displayUnit: Scalars['String']['output'];
  scaleFactor: Scalars['Float']['output'];
  unit: MetricUnit;
};

export type MetricSchema = {
  __typename?: 'MetricSchema';
  displayUnit: Scalars['String']['output'];
  max: Maybe<Scalars['Float']['output']>;
  metric: Scalars['String']['output'];
  min: Maybe<Scalars['Float']['output']>;
  rate: Maybe<MetricRate>;
  unit: MetricUnit;
};

export type MetricUnit =
  | 'AMPERE'
  | 'CELSIUS'
  | 'DAY'
  | 'FAHRENHEIT'
  | 'HOUR'
  | 'KILOMETER'
  | 'KILOMETER_PER_HOUR'
  | 'METER'
  | 'MILE'
  | 'MILE_PER_HOUR'
  | 'MINUTE'
  | 'MONTH'
  | 'PERCENT'
  | 'POUNDS_CO2'
  | 'SECOND'
  | 'STRING'
  | 'TIMESTAMP'
  | 'UNIT'
  | 'VOLT'
  | 'WATT'
  | 'WATT_HOURS'
  | 'WEEK'
  | 'YEAR';

export type MetricsQueryGroupByFacet =
  | 'CUSTOMER'
  | 'SITE';

export type MetricsQueryWindow = {
  size?: InputMaybe<WindowSize>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type MetricsSchema = {
  __typename?: 'MetricsSchema';
  deviceType: DeviceType;
  metrics: Array<MetricSchema>;
};

/** Response for MFA verification */
export type MfaVerificationResponse = {
  __typename?: 'MfaVerificationResponse';
  credentials: Maybe<IdentityCredentials>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  remainingAttempts: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ModelAvailableCommand = {
  __typename?: 'ModelAvailableCommand';
  slug: Scalars['String']['output'];
  supportLevel: SupportLevel;
};

export type ModelInput = {
  manufacturerSlug?: InputMaybe<Scalars['String']['input']>;
};

export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  /**
   * The amount in the smallest unit of the currency (e.g. cents for USD).
   * Scale is determined by the currency. (e.g. 100 for USD)
   */
  amount: Scalars['Int']['output'];
  currencyCode: Scalars['String']['output'];
  formatted: Scalars['String']['output'];
};

export type MultiSelectRequirementConfig = RequirementConfig & {
  __typename?: 'MultiSelectRequirementConfig';
  _type: Scalars['String']['output'];
  maxSelections: Maybe<Scalars['Int']['output']>;
  minSelections: Maybe<Scalars['Int']['output']>;
  options: Maybe<Array<RequirementSelectOption>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _: Maybe<Scalars['Boolean']['output']>;
  acceptInvitation: Invitation;
  acceptWorkspaceInvitation: WorkspaceAccessGrant;
  /**
   * Acknowledge command execution by a manufacturer.
   * Reports command as COMPLETED or FAILED with optional reason and execution timestamp.
   * Requires MANUFACTURER API key authentication with scope for the device's manufacturer.
   */
  acknowledgeCommand: AcknowledgeCommandResponse;
  /**
   * Creates a custom field scoped to a lifecycle definition.
   * Rejects if the factKey collides with a platform registry field.
   */
  addCustomField: LifecycleCustomField;
  /**
   * Associates a Customer with a Device and creates a Customer's claim for the
   * Device.
   */
  addCustomerToDevice: AddCustomerToDeviceResponse;
  addCustomerToSite: Customer;
  addCustomersToWorkspaceProgram: AddCustomersToWorkspaceProgramResponse;
  /** Add an existing canonical device to a workspace */
  addDeviceToWorkspace: AddDeviceToWorkspaceMutationResponse;
  addRequirement: StageDefinition;
  addRequirements: StageDefinition;
  addStage: StageDefinition;
  addTagToEnrollments: Array<Enrollment>;
  addTransition: StageDefinition;
  addUploadToEnrollment: EnrollmentUpload;
  /**
   * Add a new system connection to a workspace
   *
   * A system connection may be slightly poortly named, but basically associates a set of manufacturer identifiers
   * with a customer and site within a given workspace. The typical identifier is a serial number. Like referring to this
   * moreso as a system identifier though, even though it is stored typically under a serialNumber JSON property as of now.
   *
   * Idea is to allow other services.domains to add system connections to a workspace
   * centralizing this logic here in the connect domain.
   *
   * You can then look up the system connection for the workspace by providing the manufacturer and system identifier
   *
   * Few entry points as of now:
   * - Connect itself (does not use this mutation)
   * - Program enrollment (would need to start creating customer and site records within their respective domains)
   */
  addWorkspaceSystemConnection: AddWorkspaceSystemConnectionResponse;
  advanceStage: LifecycleInstance;
  /** Approve an organization access request. The reviewer must be an admin of the organization. */
  approveOrganizationAccessRequest: OrganizationAccessRequest;
  /**
   * Assign a manufacturer to an organization, granting them OEM dashboard access.
   * Only Texture super admins can perform this action.
   *
   * Note: To enable the manufacturer pack for this organization, you must also call
   * the enablePack mutation from the identity domain with pack: MANUFACTURER.
   */
  assignManufacturer: ManufacturerAssignment;
  authenticateByApiKey: IdentityCredentials;
  authenticateByEmailPassword: IdentityCredentials;
  /**
   * Backfill device state data for a specific device.
   *
   * Provide exactly one of: batteryStates (battery devices), inverterStates (inverter devices), or thermostatStates (thermostat devices).
   * The device type is validated against the provided data.
   *
   * This mutation:
   * 1. Archives existing DeviceState/BatteryState/InverterState/ThermostatState records
   * 2. Deletes the original records from live tables
   * 3. Inserts new backfill data with ingestType = 'backfill'
   * 4. Optionally refreshes affected continuous aggregates
   *
   * Device is identified by manufacturer + manufacturerDeviceId (unique constraint).
   */
  backfillDeviceState: BackfillDeviceStateResponse;
  cancelBatchCommand: CancelBatchCommandResponse;
  cancelWorkspaceInvitation: WorkspaceInvitation;
  captureLifecycleData: LifecycleInstance;
  changeAlertStatus: ChangeAlertStatusResponse;
  changePassword: Maybe<Scalars['Void']['output']>;
  /** Clears all devices, sites, and customers from a workspace. Requires deletionProtection to be false. */
  clearWorkspace: ClearWorkspaceResponse;
  confirmUpload: ConfirmUploadResult;
  createAlert: CreateAlertResponse;
  createApiKey: ApiKey;
  /** Creates an authentication session for a customer to use an app. Requires client authentication as this should only be done by authorized services */
  createAppAuthenticationSession: CreateAppAuthenticationSessionResponse;
  createBatch: Batch;
  /**
   * Create a new collection
   * @deprecated Use createCollectionV2
   */
  createCollection: CollectionMutationResponse;
  createCollectionV2: CollectionMutationResponseV2;
  createCommandWebhook: CommandWebhookWithSecretResponse;
  createConnectLink: CreateConnectLinkResponse;
  createConnectLinkForEnrollment: CreateConnectLinkForEnrollmentResponse;
  createConnectLinkForLifecycleInstance: CreateConnectLinkForLifecycleInstanceResponse;
  createCustomer: Customer;
  /** Create a new device manufacturer. Only accessible by super admins. */
  createDeviceManufacturer: DeviceManufacturerProfile;
  /** Create a new device model. Only accessible by super admins. */
  createDeviceModel: DeviceModelProfile;
  createDeviceSchedule: DeviceSchedule;
  createEmailDestination: DestinationMutationResponse;
  createEnrollment: Enrollment;
  createEnrollmentGroup: EnrollmentGroup;
  createGrant: CreateGrantResponse;
  createInvitation: Invitation;
  createKafkaDestination: DestinationMutationResponse;
  createLead: Lead;
  createLeadAndCheckProgramEligibility: LeadWithEligibilityCheck;
  /** Create a management audit log entry. Only accessible by client credentials (API service). */
  createManagementAuditLog: ManagementAuditLog;
  createManufacturerCredential: CreateManufacturerCredentialResponse;
  /**
   * Create a manufacturer device via dashboard.
   * Requires the calling organization to have a ManufacturerAssignment for the given manufacturer.
   * This is different from createOemDevice which requires an API key context.
   */
  createManufacturerDevice: CreateManufacturerDeviceMutationResponse;
  /**
   * Create a new device model for a manufacturer.
   * Requires the calling organization to have a ManufacturerAssignment for the given manufacturer.
   */
  createManufacturerDeviceModel: ManufacturerDeviceModel;
  /**
   * Create a new manufacturer integration. Only accessible by super admins.
   * Validates configurationFields and documentationBlocks with Zod schemas.
   */
  createManufacturerIntegration: ManufacturerIntegrationProfile;
  /** Create a new OAuth application for the workspace */
  createOAuthApplication: OAuthApplication;
  /** Create an OEM-provisioned device. This is used by MANUFACTURER API keys. */
  createOemDevice: CreateOemDeviceMutationResponse;
  createOrganization: Organization;
  /** Create a request to join an organization. The organization must match the user's email domain. */
  createOrganizationAccessRequest: OrganizationAccessRequest;
  /** Create an affiliation between two organizations. */
  createOrganizationAffiliation: OrganizationAffiliation;
  createProgram: Program;
  createProgramVariant: ProgramVariant;
  createProgram_Old: Program_Old;
  createScopedApiKey: ApiKey;
  createSite: SiteCreateMutationResponse;
  createSmsDestination: DestinationMutationResponse;
  createTagSchedule: TagSchedule;
  createVirtualAccount: VirtualAccount;
  createVirtualDevice: VirtualDevice;
  createWebhookDestination: DestinationMutationResponse;
  /** Create a new workflow [Auth: requires_client_or_user_authentication] */
  createWorkflow: Workflow;
  createWorkspace: Workspace;
  createWorkspaceProgram: WorkspaceProgram;
  createWorkspaceProgramEvent: WorkspaceProgramEvent;
  createWorkspaceProgramEventForItron: WorkspaceProgramEvent;
  declineWorkspaceInvitation: WorkspaceInvitation;
  deleteBatch: Batch;
  /** Delete a collection */
  deleteCollection: DeleteCollectionMutationResponse;
  deleteCommandWebhook: DeleteDestinationMutationResponse;
  deleteCustomer: Scalars['Boolean']['output'];
  deleteDestination: DeleteDestinationMutationResponse;
  deleteDevice: MutationResponse;
  /**
   * Delete a device manufacturer. Only accessible by super admins.
   * Returns true if successful, throws an error if the manufacturer has associated models.
   */
  deleteDeviceManufacturer: Scalars['Boolean']['output'];
  /**
   * Delete a device model. Only accessible by super admins.
   * Returns true if successful, throws an error if the model has associated devices.
   */
  deleteDeviceModel: Scalars['Boolean']['output'];
  /** @deprecated Use deleteDeviceSchedulesByDeviceId instead */
  deleteDeviceSchedule: Maybe<DeviceSchedule>;
  deleteDeviceScheduleById: Maybe<DeviceSchedule>;
  deleteDeviceSchedulesByDeviceId: DeleteDeviceSchedulesPayload;
  deleteDevices: DeleteDevicesMutationResponse;
  deleteEnrollment: DeleteEnrollmentMutationResponse;
  deleteGrant: DeleteGrantResponse;
  deleteInvitation: Scalars['Boolean']['output'];
  deleteLead: Lead;
  /**
   * Delete a device model.
   * Requires the calling organization to have a ManufacturerAssignment for the model's manufacturer.
   * Returns an error result if the model has associated devices.
   */
  deleteManufacturerDeviceModel: DeleteManufacturerDeviceModelResult;
  /**
   * Delete a manufacturer integration. Only accessible by super admins.
   * Returns true if successful.
   */
  deleteManufacturerIntegration: Scalars['Boolean']['output'];
  deleteMembership: Scalars['Boolean']['output'];
  /** Delete an OAuth application */
  deleteOAuthApplication: DeleteOAuthApplicationResponse;
  deleteOrganization: Organization;
  deleteSite: Scalars['Boolean']['output'];
  deleteSitesForWorkspace: DeleteSitesMutationResponse;
  deleteTagScheduleById: Maybe<TagSchedule>;
  deleteTagSchedulesByTag: DeleteTagSchedulesPayload;
  deleteVirtualAccount: Scalars['Boolean']['output'];
  deleteVirtualDevice: Scalars['Boolean']['output'];
  /** Delete a workflow [Auth: requires_client_or_user_authentication] */
  deleteWorkflow: Scalars['Boolean']['output'];
  deleteWorkspaceProgramEvent: WorkspaceProgramEvent;
  /**
   * Soft delete a workspace system connection by ID.
   * The record is not physically removed — it is marked with a deletedAt timestamp
   * and excluded from all queries.
   */
  deleteWorkspaceSystemConnection: DeleteWorkspaceSystemConnectionResponse;
  /** Deny an organization access request. The reviewer must be an admin of the organization. */
  denyOrganizationAccessRequest: OrganizationAccessRequest;
  determineEligibilityForEnrollment: DetermineEligibilityForEnrollmentPayload;
  disableEnrollmentReport: EnrollmentReportConfig;
  /** Disable a dashboard pack for an organization. Only accessible by super admins. */
  disablePack: Scalars['Boolean']['output'];
  disconnectVirtualDevice: Scalars['Boolean']['output'];
  dispatchBatchForWorkspaceProgramEvent: DispatchMutationResponse;
  enableEnrollmentReport: EnrollmentReportConfig;
  /** Enable a dashboard pack for an organization. Only accessible by super admins. */
  enablePack: OrganizationPack;
  /** Enable a workflow (activate from draft) [Auth: requires_client_or_user_authentication] */
  enableWorkflow: Workflow;
  /** Evaluate a lifecycle instance against its current stage's transition rules and advance if conditions are met. */
  evaluateLifecycleInstance: EvaluateLifecycleInstanceResult;
  /**
   * Exchange an API key for a JWT bearing the key owner's user identity.
   * Used by apps/api to propagate real user identity on Management API calls.
   * Requires the API key to have an owner (ownerId). Returns IdentityCredentials
   * with subjectScope "user" and subjectId set to the owner's user ID.
   */
  exchangeApiKeyForOwnerToken: IdentityCredentials;
  executeBatch: Batch;
  /** Execute a workflow [Auth: requires_client_or_user_authentication] */
  executeWorkflow: WorkflowExecution;
  fetchOrCreateScopedApiKeyForCustomer: ApiKey;
  generateBillingPortalUrl: Scalars['String']['output'];
  generateStatementDownloadUrl: GenerateStatementDownloadUrlResponse;
  /** Grant super admin access to a user. The user must be a Texture employee. Only accessible by super admins. */
  grantSuperAdmin: SuperAdminGrant;
  /** Create a lifecycle instance for a workspace program without an existing enrollment. Returns the instance positioned at its first non-terminal stage. */
  initLifecycleInstance: LifecycleInstance;
  /** Initiates authentication and returns either credentials or MFA challenge */
  initiateAuthentication: AuthenticationInitiationResponse;
  /** @deprecated Use acceptInvitation instead */
  joinOrganization: Organization;
  publishWorkspaceProgramEvent: WorkspaceProgramEvent;
  reconnectVirtualDevice: Scalars['Boolean']['output'];
  refreshAuthenticationSession: IdentityCredentials;
  /** Regenerate the client secret for a confidential OAuth application */
  regenerateOAuthApplicationSecret: OAuthApplicationSecretResponse;
  registerCanonicalDevice: Maybe<RegisterCDeviceMutationResponse>;
  removeCustomerFromSite: Customer;
  /** Remove an organization affiliation by ID. */
  removeOrganizationAffiliation: Scalars['Boolean']['output'];
  removeRequirement: StageDefinition;
  removeStage: Scalars['Boolean']['output'];
  removeTagFromEnrollments: Array<Enrollment>;
  removeTransition: StageDefinition;
  reorderStages: Array<StageDefinition>;
  reorderTransitions: StageDefinition;
  requestPasswordReset: Maybe<Scalars['Void']['output']>;
  requestUpload: RequestUploadResult;
  requeueAlerts: RequeueAlertsResponse;
  resendInvitationEmail: Maybe<Scalars['Void']['output']>;
  /** Resends MFA code with rate limiting */
  resendMfaCode: ResendMfaCodeResponse;
  resendVerificationEmail: Maybe<Scalars['Void']['output']>;
  resetPassword: ResetPasswordResponse;
  restoreVirtualAccount: Scalars['Boolean']['output'];
  restoreVirtualDevice: Scalars['Boolean']['output'];
  /**
   * Re-trigger provider.grant.created events for recovery purposes.
   * Pass ["*"] as providerGrantIds to re-trigger for all non-deleted grants.
   */
  retriggerGrantEvents: RetriggerGrantEventsResponse;
  retryCommand: SendCommandResponse;
  revokeApiKey: ApiKey;
  revokeInvitation: Maybe<Invitation>;
  /**
   * Revoke a manufacturer assignment, removing OEM dashboard access.
   * Only Texture super admins can perform this action.
   */
  revokeManufacturerAssignment: Scalars['Boolean']['output'];
  /** Revoke super admin access from a user. Only accessible by super admins. */
  revokeSuperAdmin: SuperAdminGrant;
  revokeWorkspaceAccessGrant: WorkspaceAccessGrant;
  rotateCommandWebhookSecret: CommandWebhookWithSecretResponse;
  /** Save a workflow draft (auto-save functionality) [Auth: requires_client_or_user_authentication] */
  saveWorkflowDraft: WorkflowDraft;
  /** @deprecated Use createBatch and executeBatch instead */
  sendBatchCommand: Batch;
  /** @deprecated Use sendUnifiedCommand instead */
  sendCommand: SendCommandResponse;
  sendUnifiedCommand: SendCommandResponse;
  sendWorkspaceInvitation: WorkspaceInvitation;
  setWebhookDestinationEnabled: DestinationMutationResponse;
  setWorkspaceConnectConfig: SetWorkspaceConnectConfigResponse;
  /** Share a collection with an invitee by email */
  shareCollectionByEmail: ShareCollectionByEmailResponse;
  /** Share a collection with an organization by setting its visibility to SHARED and granting the organization access */
  shareCollectionWithOrg: ShareCollectionWithOrgResponse;
  signUp: UserProfile;
  /** Submit an enrollment: resolves customer and site, creates enrollment and lifecycle instance, and writes facts. Idempotent by natural key (workspaceProgramId + email or customerId). */
  submitEnrollment: SubmitEnrollmentPayload;
  /**
   * Sync the ConnectionEstablishedEvent table from Kafka.
   * Consumes all connection.established events from the beginning through
   * the current high-water offset. Idempotent — duplicate events are
   * skipped via the unique eventId (topic:partition:offset).
   */
  syncConnectionEstablishedEvents: SyncConnectionEstablishedEventsResponse;
  /**
   * Terminate an active connection by its internal Texture ManufacturerUserConnection ID.
   * Marks all associated tokens as expired, removes polling jobs, creates an audit log entry,
   * and publishes a connection.terminated event. Returns terminatedCount: 0 if already expired.
   */
  terminateConnection: TerminateConnectionResponse;
  /** Terminate a connection for a manufacturer account identified by manufacturer + manufacturerUserId + clientId. */
  terminateManufacturerConnections: TerminateConnectionResponse;
  testCommandWebhook: WebhookTestResult;
  transitionToStage: LifecycleInstance;
  /**
   * Admin mutation to manually trigger a connection.poll event.
   * Useful for debugging and testing polling behavior.
   * Requires connection details from connect-scheduler's Connection table.
   */
  triggerConnectionPoll: TriggerConnectionPollResponse;
  updateApiKey: ApiKey;
  /**
   * Set or clear the BullMQ scheduler cron pattern for an app provider grant (OEM poll-provider job).
   * Omit pollingCronPattern or pass null to use the provider default from code.
   */
  updateAppProviderGrantPollingCronPattern: UpdateAppProviderGrantPollingCronPatternResponse;
  updateBatch: Batch;
  updateBatchSource: Batch;
  /**
   * Update an existing collection
   * @deprecated Use updateCollectionV2
   */
  updateCollection: CollectionMutationResponse;
  updateCollectionV2: CollectionMutationResponseV2;
  updateCommandWebhook: CommandWebhookResponse;
  updateCustomer: Customer;
  updateDevice: Device;
  /** Update an existing device manufacturer. Only accessible by super admins. */
  updateDeviceManufacturer: DeviceManufacturerProfile;
  /** Update an existing device model. Only accessible by super admins. */
  updateDeviceModel: DeviceModelProfile;
  updateDeviceSchedule: DeviceSchedule;
  updateEmailDestination: DestinationMutationResponse;
  updateEnrollment: Enrollment;
  updateEnrollmentReportConfig: EnrollmentReportConfig;
  updateEnrollmentUploadStatus: EnrollmentUpload;
  updateKafkaDestination: DestinationMutationResponse;
  updateLead: Lead;
  updateManufacturerCredential: UpdateManufacturerCredentialResponse;
  /**
   * Update an existing device model.
   * Requires the calling organization to have a ManufacturerAssignment for the model's manufacturer.
   */
  updateManufacturerDeviceModel: ManufacturerDeviceModel;
  /**
   * Update an existing manufacturer integration. Only accessible by super admins.
   * Validates JSON fields before update.
   */
  updateManufacturerIntegration: ManufacturerIntegrationProfile;
  /**
   * Update a manufacturer's logo URL. This overrides the CDN-generated logo.
   * Pass null to remove the override and use the CDN-generated logo.
   * Only Texture super admins can perform this action.
   */
  updateManufacturerLogo: DeviceManufacturerProfile;
  updateMembership: Membership;
  /** Update an existing OAuth application */
  updateOAuthApplication: OAuthApplication;
  updateOrganization: Organization;
  updateOrganizationLocation: Organization;
  updateProgram: Program;
  updateProgramVariant: ProgramVariant;
  updateProgram_Old: Program_Old;
  updateRequirement: StageDefinition;
  updateSite: SiteUpdateMutationResponse;
  updateSmsDestination: DestinationMutationResponse;
  updateStage: StageDefinition;
  updateTransition: StageDefinition;
  /** @deprecated Use updateUserProfile instead */
  updateUser: User;
  updateUserEmail: Maybe<Scalars['Void']['output']>;
  updateUserProfile: UserProfile;
  /** Update the current user's settings. Creates a new settings record (append-only). */
  updateUserSettings: UserSettings;
  updateWebhookDestination: DestinationMutationResponse;
  /** Update an existing workflow [Auth: requires_client_or_user_authentication] */
  updateWorkflow: Workflow;
  updateWorkspace: Workspace;
  updateWorkspaceAlertConfig: WorkspaceAlertConfig;
  updateWorkspaceDeletionProtection: Workspace;
  updateWorkspaceProgram: WorkspaceProgram;
  updateWorkspaceProgramEvent: WorkspaceProgramEvent;
  /** Upsert a device: find or create the canonical device, then add to workspace */
  upsertDevice: UpsertDeviceMutationResponse;
  upsertFieldConfiguration: FieldConfiguration;
  upsertSite: SiteUpsertMutationResponse;
  /** Verifies an email address using the token sent in the verification email. */
  verifyEmail: VerifyEmailResponse;
  /** Verifies MFA code and completes authentication */
  verifyMfaCode: MfaVerificationResponse;
  /**
   * Retrieve the full API key value. This is the ONLY way to access a full key
   * after creation (once Phase 2C locks down the key field resolver).
   * Writes an audit log entry (apiKey.view) recording which user retrieved the key.
   */
  viewKey: ViewKeyPayload;
  /** Write enrollment lifecycle facts by merging new key-value pairs into the instance data. */
  writeLifecycleFact: LifecycleInstance;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAcceptWorkspaceInvitationArgs = {
  input: AcceptWorkspaceInvitationInput;
};


export type MutationAcknowledgeCommandArgs = {
  input: AcknowledgeCommandInput;
};


export type MutationAddCustomFieldArgs = {
  input: AddCustomFieldInput;
};


export type MutationAddCustomerToDeviceArgs = {
  input: AddCustomerToDeviceInput;
};


export type MutationAddCustomerToSiteArgs = {
  customerId: Scalars['ID']['input'];
  site: InputMaybe<CreateSiteInput>;
  siteId: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddCustomersToWorkspaceProgramArgs = {
  input: AddCustomersToWorkspaceProgramInput;
};


export type MutationAddDeviceToWorkspaceArgs = {
  input: AddDeviceToWorkspaceInput;
};


export type MutationAddRequirementArgs = {
  input: AddRequirementInput;
};


export type MutationAddRequirementsArgs = {
  input: AddRequirementsInput;
};


export type MutationAddStageArgs = {
  input: AddStageInput;
};


export type MutationAddTagToEnrollmentsArgs = {
  input: AddTagToEnrollmentsInput;
};


export type MutationAddTransitionArgs = {
  input: AddTransitionInput;
};


export type MutationAddUploadToEnrollmentArgs = {
  input: AddUploadToEnrollmentInput;
};


export type MutationAddWorkspaceSystemConnectionArgs = {
  input: AddWorkspaceSystemConnectionInput;
};


export type MutationAdvanceStageArgs = {
  input: AdvanceStageInput;
};


export type MutationApproveOrganizationAccessRequestArgs = {
  input: ApproveOrganizationAccessRequestInput;
};


export type MutationAssignManufacturerArgs = {
  enablePack: InputMaybe<Scalars['Boolean']['input']>;
  manufacturerId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type MutationAuthenticateByApiKeyArgs = {
  input: AuthenticateByApiKeyInput;
};


export type MutationAuthenticateByEmailPasswordArgs = {
  input: AuthenticateByEmailPasswordInput;
};


export type MutationBackfillDeviceStateArgs = {
  input: BackfillDeviceStateInput;
};


export type MutationCancelBatchCommandArgs = {
  input: CancelBatchCommandInput;
};


export type MutationCancelWorkspaceInvitationArgs = {
  input: CancelWorkspaceInvitationInput;
};


export type MutationCaptureLifecycleDataArgs = {
  input: CaptureLifecycleDataInput;
};


export type MutationChangeAlertStatusArgs = {
  input: ChangeAlertStatusInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationClearWorkspaceArgs = {
  input: ClearWorkspaceInput;
};


export type MutationConfirmUploadArgs = {
  uploadId: Scalars['ID']['input'];
};


export type MutationCreateAlertArgs = {
  input: CreateAlertInput;
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationCreateAppAuthenticationSessionArgs = {
  input: CreateAppAuthenticationSessionInput;
};


export type MutationCreateBatchArgs = {
  input: CreateBatchInput;
  source: InputMaybe<BatchSourceInput>;
};


export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput;
};


export type MutationCreateCollectionV2Args = {
  input: CreateCollectionInputV2;
};


export type MutationCreateCommandWebhookArgs = {
  manufacturerId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};


export type MutationCreateConnectLinkArgs = {
  input: CreateConnectLinkInput;
};


export type MutationCreateConnectLinkForEnrollmentArgs = {
  input: CreateConnectLinkForEnrollmentInput;
};


export type MutationCreateConnectLinkForLifecycleInstanceArgs = {
  input: CreateConnectLinkForLifecycleInstanceInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateDeviceManufacturerArgs = {
  input: CreateDeviceManufacturerInput;
};


export type MutationCreateDeviceModelArgs = {
  input: CreateDeviceModelInput;
};


export type MutationCreateDeviceScheduleArgs = {
  input: CreateDeviceScheduleInput;
};


export type MutationCreateEmailDestinationArgs = {
  input: CreateEmailDestinationInput;
};


export type MutationCreateEnrollmentArgs = {
  input: CreateEnrollmentInput;
};


export type MutationCreateEnrollmentGroupArgs = {
  input: CreateEnrollmentGroupInput;
};


export type MutationCreateGrantArgs = {
  input: CreateGrantInput;
};


export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};


export type MutationCreateKafkaDestinationArgs = {
  input: CreateKafkaDestinationInput;
};


export type MutationCreateLeadArgs = {
  input: CreateLeadInput;
};


export type MutationCreateLeadAndCheckProgramEligibilityArgs = {
  input: CreateLeadAndCheckProgramEligibilityInput;
};


export type MutationCreateManagementAuditLogArgs = {
  input: CreateManagementAuditLogInput;
};


export type MutationCreateManufacturerCredentialArgs = {
  input: CreateManufacturerCredentialInput;
};


export type MutationCreateManufacturerDeviceArgs = {
  input: CreateManufacturerDeviceInput;
};


export type MutationCreateManufacturerDeviceModelArgs = {
  input: CreateManufacturerDeviceModelInput;
};


export type MutationCreateManufacturerIntegrationArgs = {
  input: CreateManufacturerIntegrationInput;
};


export type MutationCreateOAuthApplicationArgs = {
  input: CreateOAuthApplicationInput;
};


export type MutationCreateOemDeviceArgs = {
  input: CreateOemDeviceInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationAccessRequestArgs = {
  input: CreateOrganizationAccessRequestInput;
};


export type MutationCreateOrganizationAffiliationArgs = {
  input: CreateOrganizationAffiliationInput;
};


export type MutationCreateProgramArgs = {
  input: CreateProgramInput;
};


export type MutationCreateProgramVariantArgs = {
  input: CreateProgramVariantInput;
};


export type MutationCreateProgram_OldArgs = {
  input: CreateProgramInput_Old;
};


export type MutationCreateScopedApiKeyArgs = {
  input: CreateScopedApiKeyInput;
};


export type MutationCreateSiteArgs = {
  input: SiteCreateInput;
};


export type MutationCreateSmsDestinationArgs = {
  input: CreateSmsDestinationInput;
};


export type MutationCreateTagScheduleArgs = {
  input: CreateTagScheduleInput;
};


export type MutationCreateVirtualAccountArgs = {
  input: CreateVirtualAccountInput;
};


export type MutationCreateVirtualDeviceArgs = {
  input: CreateVirtualDeviceInput;
};


export type MutationCreateWebhookDestinationArgs = {
  input: CreateWebhookDestinationInput;
};


export type MutationCreateWorkflowArgs = {
  workflowInput: CreateWorkflowInput;
};


export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceInput;
};


export type MutationCreateWorkspaceProgramArgs = {
  input: CreateWorkspaceProgramInput;
};


export type MutationCreateWorkspaceProgramEventArgs = {
  input: CreateWorkspaceProgramEventInput;
};


export type MutationCreateWorkspaceProgramEventForItronArgs = {
  input: CreateWorkspaceProgramEventInput;
};


export type MutationDeclineWorkspaceInvitationArgs = {
  input: DeclineWorkspaceInvitationInput;
};


export type MutationDeleteBatchArgs = {
  input: DeleteBatchInput;
};


export type MutationDeleteCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommandWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput;
};


export type MutationDeleteDestinationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDeviceArgs = {
  input: DeleteDeviceInput;
};


export type MutationDeleteDeviceManufacturerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDeviceModelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDeviceScheduleArgs = {
  deviceId: Scalars['ID']['input'];
};


export type MutationDeleteDeviceScheduleByIdArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type MutationDeleteDeviceSchedulesByDeviceIdArgs = {
  deviceId: Scalars['ID']['input'];
};


export type MutationDeleteDevicesArgs = {
  input: DeleteDevicesInput;
};


export type MutationDeleteEnrollmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGrantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInvitationArgs = {
  input: DeleteInvitationInput;
};


export type MutationDeleteLeadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteManufacturerDeviceModelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteManufacturerIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMembershipArgs = {
  input: DeleteMembershipInput;
};


export type MutationDeleteOAuthApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteSiteArgs = {
  input: DeleteSiteInput;
};


export type MutationDeleteSitesForWorkspaceArgs = {
  input: DeleteSitesInputForWorkspaceInput;
};


export type MutationDeleteTagScheduleByIdArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type MutationDeleteTagSchedulesByTagArgs = {
  input: DeleteTagSchedulesByTagInput;
};


export type MutationDeleteVirtualAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVirtualDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWorkspaceProgramEventArgs = {
  input: DeleteWorkspaceProgramEventInput;
};


export type MutationDeleteWorkspaceSystemConnectionArgs = {
  input: DeleteWorkspaceSystemConnectionInput;
};


export type MutationDenyOrganizationAccessRequestArgs = {
  input: DenyOrganizationAccessRequestInput;
};


export type MutationDetermineEligibilityForEnrollmentArgs = {
  input: DetermineEligibilityForEnrollmentInput;
};


export type MutationDisableEnrollmentReportArgs = {
  input: DisableEnrollmentReportInput;
};


export type MutationDisablePackArgs = {
  input: DisablePackInput;
};


export type MutationDisconnectVirtualDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDispatchBatchForWorkspaceProgramEventArgs = {
  workspaceProgramEventId: Scalars['String']['input'];
};


export type MutationEnableEnrollmentReportArgs = {
  input: EnableEnrollmentReportInput;
};


export type MutationEnablePackArgs = {
  input: EnablePackInput;
};


export type MutationEnableWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEvaluateLifecycleInstanceArgs = {
  input: EvaluateLifecycleInstanceInput;
};


export type MutationExchangeApiKeyForOwnerTokenArgs = {
  input: ExchangeApiKeyForOwnerTokenInput;
};


export type MutationExecuteBatchArgs = {
  input: ExecuteBatchInput;
};


export type MutationExecuteWorkflowArgs = {
  id: Scalars['ID']['input'];
  input: ExecuteWorkflowInput;
};


export type MutationFetchOrCreateScopedApiKeyForCustomerArgs = {
  input: FetchOrCreateScopedApiKeyForCustomerInput;
};


export type MutationGenerateBillingPortalUrlArgs = {
  input: BillingPortalSessionInput;
};


export type MutationGenerateStatementDownloadUrlArgs = {
  input: GenerateStatementDownloadUrlInput;
};


export type MutationGrantSuperAdminArgs = {
  input: GrantSuperAdminInput;
};


export type MutationInitLifecycleInstanceArgs = {
  input: InitLifecycleInstanceInput;
};


export type MutationInitiateAuthenticationArgs = {
  input: InitiateAuthenticationInput;
};


export type MutationJoinOrganizationArgs = {
  id: Scalars['String']['input'];
  input: JoinOrganizationInput;
};


export type MutationPublishWorkspaceProgramEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReconnectVirtualDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRefreshAuthenticationSessionArgs = {
  input: RefreshAuthenticationSessionInput;
};


export type MutationRegenerateOAuthApplicationSecretArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegisterCanonicalDeviceArgs = {
  input: RegisterCDeviceInput;
};


export type MutationRemoveCustomerFromSiteArgs = {
  customerId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};


export type MutationRemoveOrganizationAffiliationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveRequirementArgs = {
  input: RemoveRequirementInput;
};


export type MutationRemoveStageArgs = {
  stageId: Scalars['ID']['input'];
};


export type MutationRemoveTagFromEnrollmentsArgs = {
  input: RemoveTagFromEnrollmentsInput;
};


export type MutationRemoveTransitionArgs = {
  input: RemoveTransitionInput;
};


export type MutationReorderStagesArgs = {
  input: ReorderStagesInput;
};


export type MutationReorderTransitionsArgs = {
  input: ReorderTransitionsInput;
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationRequestUploadArgs = {
  input: RequestUploadInput;
};


export type MutationRequeueAlertsArgs = {
  input: RequeueAlertsInput;
};


export type MutationResendInvitationEmailArgs = {
  input: ResendInvitationInput;
};


export type MutationResendMfaCodeArgs = {
  input: ResendMfaCodeInput;
};


export type MutationResendVerificationEmailArgs = {
  input: ResendVerificationEmailInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRestoreVirtualAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreVirtualDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetriggerGrantEventsArgs = {
  input: RetriggerGrantEventsInput;
};


export type MutationRetryCommandArgs = {
  input: RetryCommandInput;
};


export type MutationRevokeApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeInvitationArgs = {
  input: RevokeInvitationInput;
};


export type MutationRevokeManufacturerAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeSuperAdminArgs = {
  input: RevokeSuperAdminInput;
};


export type MutationRevokeWorkspaceAccessGrantArgs = {
  input: RevokeWorkspaceAccessGrantInput;
};


export type MutationRotateCommandWebhookSecretArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveWorkflowDraftArgs = {
  draftInput: SaveWorkflowDraftInput;
  workflowId: Scalars['ID']['input'];
};


export type MutationSendBatchCommandArgs = {
  input: SendBatchCommandInput;
  source: InputMaybe<BatchSourceInput>;
};


export type MutationSendCommandArgs = {
  input: SendCommandInput;
};


export type MutationSendUnifiedCommandArgs = {
  input: UnifiedCommandInput;
};


export type MutationSendWorkspaceInvitationArgs = {
  input: SendWorkspaceInvitationInput;
};


export type MutationSetWebhookDestinationEnabledArgs = {
  input: SetWebhookDestinationEnabledInput;
};


export type MutationSetWorkspaceConnectConfigArgs = {
  input: SetWorkspaceConnectConfigInput;
};


export type MutationShareCollectionByEmailArgs = {
  input: ShareCollectionByEmailInput;
};


export type MutationShareCollectionWithOrgArgs = {
  input: ShareCollectionWithOrgInput;
};


export type MutationSignUpArgs = {
  input: SignUpUserInput;
};


export type MutationSubmitEnrollmentArgs = {
  input: SubmitEnrollmentInput;
};


export type MutationTerminateConnectionArgs = {
  input: TerminateConnectionInput;
};


export type MutationTerminateManufacturerConnectionsArgs = {
  input: TerminateManufacturerConnectionsInput;
};


export type MutationTestCommandWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTransitionToStageArgs = {
  input: TransitionToStageInput;
};


export type MutationTriggerConnectionPollArgs = {
  input: TriggerConnectionPollInput;
};


export type MutationUpdateApiKeyArgs = {
  id: Scalars['String']['input'];
  input: UpdateApiKeyInput;
};


export type MutationUpdateAppProviderGrantPollingCronPatternArgs = {
  input: UpdateAppProviderGrantPollingCronPatternInput;
};


export type MutationUpdateBatchArgs = {
  input: UpdateBatchInput;
};


export type MutationUpdateBatchSourceArgs = {
  batchId: Scalars['ID']['input'];
  source: BatchSourceInput;
};


export type MutationUpdateCollectionArgs = {
  input: UpdateCollectionInput;
};


export type MutationUpdateCollectionV2Args = {
  input: UpdateCollectionInputV2;
};


export type MutationUpdateCommandWebhookArgs = {
  id: Scalars['ID']['input'];
  url: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCustomerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCustomerInput;
};


export type MutationUpdateDeviceArgs = {
  input: UpdateDeviceInput;
};


export type MutationUpdateDeviceManufacturerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceManufacturerInput;
};


export type MutationUpdateDeviceModelArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDeviceModelInput;
};


export type MutationUpdateDeviceScheduleArgs = {
  deviceId: Scalars['ID']['input'];
  input: UpdateDeviceScheduleInput;
};


export type MutationUpdateEmailDestinationArgs = {
  input: UpdateEmailDestinationInput;
};


export type MutationUpdateEnrollmentArgs = {
  input: UpdateEnrollmentInput;
};


export type MutationUpdateEnrollmentReportConfigArgs = {
  input: UpdateEnrollmentReportConfigInput;
};


export type MutationUpdateEnrollmentUploadStatusArgs = {
  input: UpdateEnrollmentUploadStatusInput;
};


export type MutationUpdateKafkaDestinationArgs = {
  input: UpdateKafkaDestinationInput;
};


export type MutationUpdateLeadArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLeadInput;
};


export type MutationUpdateManufacturerCredentialArgs = {
  input: UpdateManufacturerCredentialInput;
};


export type MutationUpdateManufacturerDeviceModelArgs = {
  id: Scalars['ID']['input'];
  input: UpdateManufacturerDeviceModelInput;
};


export type MutationUpdateManufacturerIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateManufacturerIntegrationInput;
};


export type MutationUpdateManufacturerLogoArgs = {
  logoUrl: InputMaybe<Scalars['String']['input']>;
  manufacturerId: Scalars['ID']['input'];
};


export type MutationUpdateMembershipArgs = {
  input: UpdateMembershipInput;
};


export type MutationUpdateOAuthApplicationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOAuthApplicationInput;
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['String']['input'];
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationLocationArgs = {
  id: Scalars['String']['input'];
  input: UpdateLocationInput;
};


export type MutationUpdateProgramArgs = {
  input: UpdateProgramInput;
};


export type MutationUpdateProgramVariantArgs = {
  input: UpdateProgramVariantInput;
};


export type MutationUpdateProgram_OldArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProgramInput_Old;
};


export type MutationUpdateRequirementArgs = {
  input: UpdateRequirementInput;
};


export type MutationUpdateSiteArgs = {
  input: UpdateSiteInput;
};


export type MutationUpdateSmsDestinationArgs = {
  input: UpdateSmsDestinationInput;
};


export type MutationUpdateStageArgs = {
  input: UpdateStageInput;
};


export type MutationUpdateTransitionArgs = {
  input: UpdateTransitionInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['String']['input'];
  input: UpdateUserInput;
};


export type MutationUpdateUserEmailArgs = {
  input: UpdateUserEmailInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};


export type MutationUpdateWebhookDestinationArgs = {
  input: UpdateWebhookDestinationInput;
};


export type MutationUpdateWorkflowArgs = {
  id: Scalars['ID']['input'];
  workflowInput: UpdateWorkflowInput;
};


export type MutationUpdateWorkspaceArgs = {
  id: Scalars['String']['input'];
  input: UpdateWorkspaceInput;
};


export type MutationUpdateWorkspaceAlertConfigArgs = {
  input: WorkspaceAlertConfigInput;
  workspaceId: Scalars['String']['input'];
};


export type MutationUpdateWorkspaceDeletionProtectionArgs = {
  deletionProtection: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateWorkspaceProgramArgs = {
  input: UpdateWorkspaceProgramInput;
};


export type MutationUpdateWorkspaceProgramEventArgs = {
  input: UpdateWorkspaceProgramEventInput;
};


export type MutationUpsertDeviceArgs = {
  input: UpsertDeviceInput;
};


export type MutationUpsertFieldConfigurationArgs = {
  input: UpsertFieldConfigurationInput;
};


export type MutationUpsertSiteArgs = {
  input: UpsertSiteInput;
};


export type MutationVerifyEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyMfaCodeArgs = {
  input: VerifyMfaCodeInput;
};


export type MutationViewKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationWriteLifecycleFactArgs = {
  input: WriteLifecycleFactInput;
};

export type MutationResponse = IMutationResponse & {
  __typename?: 'MutationResponse';
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type NiscCredentials = {
  __typename?: 'NISCCredentials';
  createdAt: Maybe<Scalars['DateTime']['output']>;
  password: Scalars['String']['output'];
  url: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type NiscGrant = {
  __typename?: 'NISCGrant';
  credentialId: Maybe<Scalars['ID']['output']>;
  credentials: Maybe<NiscCredentials>;
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NumberAttributeConfig = {
  __typename?: 'NumberAttributeConfig';
  max: Maybe<Scalars['Float']['output']>;
  min: Maybe<Scalars['Float']['output']>;
};

export type NumberRequirementConfig = RequirementConfig & {
  __typename?: 'NumberRequirementConfig';
  _type: Scalars['String']['output'];
  max: Maybe<Scalars['Float']['output']>;
  min: Maybe<Scalars['Float']['output']>;
  placeholder: Maybe<Scalars['String']['output']>;
};

export type OAuthApplication = {
  __typename?: 'OAuthApplication';
  allowedScopes: Array<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  clientSecret: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFirstParty: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  redirectUris: Array<Scalars['String']['output']>;
  type: OAuthApplicationType;
  updatedAt: Scalars['DateTime']['output'];
  workspace: Workspace;
};

export type OAuthApplicationEdge = {
  __typename?: 'OAuthApplicationEdge';
  cursor: Scalars['String']['output'];
  node: OAuthApplication;
};

export type OAuthApplicationPaginatedQueryPayload = {
  __typename?: 'OAuthApplicationPaginatedQueryPayload';
  edges: Array<OAuthApplicationEdge>;
  pageInfo: PageInfo;
};

export type OAuthApplicationSecretResponse = {
  __typename?: 'OAuthApplicationSecretResponse';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  message: Maybe<Scalars['String']['output']>;
};

export type OAuthApplicationType =
  | 'CONFIDENTIAL'
  | 'PUBLIC';

export type OAuthApplicationsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<OrderDirection>;
  workspaceId: Scalars['ID']['input'];
};

/** OAuth configuration for apps supporting OAuth flow */
export type OAuthConfig = {
  __typename?: 'OAuthConfig';
  /** OAuth authorization URL */
  authorizationUrl: Scalars['String']['output'];
  /** Custom parameters for OAuth flow */
  customParams: Maybe<Scalars['JSON']['output']>;
  /** OAuth provider name */
  provider: Scalars['String']['output'];
  /** Whether PKCE is required */
  requiresPKCE: Scalars['Boolean']['output'];
  /** Required OAuth scopes */
  scopes: Array<Scalars['String']['output']>;
  /** OAuth token URL */
  tokenUrl: Scalars['String']['output'];
};

/** An OEM device record with telemetry information. */
export type OemDevice = {
  __typename?: 'OemDevice';
  /** When the device was created */
  createdAt: Scalars['DateTime']['output'];
  /** The unique device ID */
  id: Scalars['ID']['output'];
  /** When the device last sent telemetry */
  lastTelemetryAt: Maybe<Scalars['DateTime']['output']>;
  /** The manufacturer's unique identifier for this device */
  manufacturerDeviceId: Scalars['String']['output'];
  /** The device model slug */
  model: Scalars['String']['output'];
  /** The device model display name */
  modelName: Maybe<Scalars['String']['output']>;
  /** The device name */
  name: Maybe<Scalars['String']['output']>;
  /** The device serial number */
  serialNumber: Maybe<Scalars['String']['output']>;
  /** Total number of telemetry updates received */
  telemetryUpdateCount: Scalars['Int']['output'];
  /** The device type */
  type: DeviceType;
  /** When the device was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

/** Error type for OEM device creation */
export type OemDeviceError = {
  __typename?: 'OemDeviceError';
  code: OemDeviceErrorCode;
  message: Scalars['String']['output'];
  mismatchedFields: Maybe<Array<Scalars['String']['output']>>;
};

/** Error codes for OEM device creation */
export type OemDeviceErrorCode =
  | 'DEVICE_MODEL_MANUFACTURER_MISMATCH'
  | 'DEVICE_MODEL_NOT_FOUND'
  | 'PARAMETER_MISMATCH'
  | 'SITE_NOT_FOUND';

/** Input for getting OEM device info for telemetry ingestion. */
export type OemDeviceForTelemetryInput = {
  /** List of manufacturer IDs the caller is allowed to access */
  allowedManufacturerIds: Array<Scalars['ID']['input']>;
  /** The device ID to get info for */
  deviceId: Scalars['ID']['input'];
};

/** OEM device information needed for telemetry event publishing. */
export type OemDeviceForTelemetryResult = {
  __typename?: 'OemDeviceForTelemetryResult';
  /** The device information if successful */
  device: Maybe<OemDeviceTelemetryInfo>;
  /** Error information if unsuccessful */
  error: Maybe<OemDeviceTelemetryError>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Error information for OEM device telemetry lookup. */
export type OemDeviceTelemetryError = {
  __typename?: 'OemDeviceTelemetryError';
  /** Error code */
  code: OemDeviceTelemetryErrorCode;
  /** Error message */
  message: Scalars['String']['output'];
};

/** Error codes for OEM device telemetry lookup. */
export type OemDeviceTelemetryErrorCode =
  | 'DEVICE_NOT_ASSOCIATED'
  | 'DEVICE_NOT_FOUND'
  | 'DEVICE_NOT_OEM_DIRECT'
  | 'MANUFACTURER_NOT_ALLOWED';

/** Device information needed for telemetry event publishing. */
export type OemDeviceTelemetryInfo = {
  __typename?: 'OemDeviceTelemetryInfo';
  /** The unique device ID */
  deviceId: Scalars['ID']['output'];
  /** The device model slug */
  deviceModel: Scalars['String']['output'];
  /** The device type (battery, inverter, etc.) */
  deviceType: Scalars['String']['output'];
  /** The manufacturer slug */
  manufacturer: Scalars['String']['output'];
  /** The manufacturer's unique identifier for this device */
  manufacturerDeviceId: Scalars['String']['output'];
  /** The manufacturer ID */
  manufacturerId: Scalars['ID']['output'];
  /** The device name if available */
  name: Maybe<Scalars['String']['output']>;
  /** The organization ID */
  organizationId: Scalars['ID']['output'];
  /** The reference ID for the device in the workspace */
  referenceId: Scalars['String']['output'];
  /** The device serial number if available */
  serialNumber: Maybe<Scalars['String']['output']>;
  /** The site ID if assigned */
  siteId: Maybe<Scalars['ID']['output']>;
  /** The workspace ID the device is associated with */
  workspaceId: Scalars['ID']['output'];
};

/** Input for querying OEM devices for a manufacturer. */
export type OemDevicesInput = {
  /** Filter by device model slugs */
  deviceModel?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by device types */
  deviceType?: InputMaybe<Array<DeviceType>>;
  /** The manufacturer ID to get devices for */
  manufacturerId: Scalars['ID']['input'];
  /** Pagination options */
  pagination?: InputMaybe<ListPagination>;
  /** Search by name, serial number, or manufacturer device ID */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated response for OEM devices query. */
export type OemDevicesPaginatedPayload = {
  __typename?: 'OemDevicesPaginatedPayload';
  /** The list of OEM devices */
  data: Array<OemDevice>;
  /** Pagination metadata */
  meta: ListPayloadMeta;
};

export type OemOverride = {
  __typename?: 'OemOverride';
  oemId: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type OemOverrideInput = {
  oemId: Scalars['String']['input'];
  visible: Scalars['Boolean']['input'];
};

/** Input type for offset-based pagination. */
export type OffsetPagination = {
  /** The page number to retrieve (1-based). */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** The number of items per page. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type OffsetPaginationInfo = {
  __typename?: 'OffsetPaginationInfo';
  page: Maybe<Scalars['Int']['output']>;
  perPage: Maybe<Scalars['Int']['output']>;
};

export type OrderByInput = {
  direction: SortOrder;
  field: Scalars['String']['input'];
};

export type OrderDirection =
  | 'ASC'
  | 'DESC';

export type Organization = {
  __typename?: 'Organization';
  /** Organizations that have affiliated with this organization (reverse direction). */
  affiliatedByOrganizations: Array<OrganizationAffiliation>;
  /** Organizations affiliated with this organization. */
  affiliatedOrganizations: Array<OrganizationAffiliation>;
  /** Auth0 Organization ID for SAML/SCIM integration. */
  auth0OrganizationId: Maybe<Scalars['String']['output']>;
  /** Cached Auth0 Organization name for performance. */
  auth0OrganizationName: Maybe<Scalars['String']['output']>;
  /** Hourly battery charge time series, in kWh. */
  batteryChargeKwhSeries: Array<BatteryChargeDataPoint>;
  billingId: Maybe<Scalars['String']['output']>;
  /** Monthly cumulative inverter capacity time series, in kilowatts. */
  capacityKwSeries: Array<CapacityGrowthDataPoint>;
  createdAt: Scalars['DateTime']['output'];
  /** Total current battery charge across all batteries, in kWh. */
  currentBatteryChargeKwh: Maybe<Scalars['Float']['output']>;
  /** Total number of devices across all workspaces in this organization. */
  deviceCount: Scalars['Int']['output'];
  /** Monthly cumulative device count time series. */
  deviceCountSeries: Array<DeviceGrowthDataPoint>;
  domain: Maybe<Scalars['String']['output']>;
  /** Dashboard packs enabled for this organization. */
  enabledPacks: Array<OrganizationPack>;
  /** Token utilized for Enphase Grid Services API enrollment. */
  enphaseGridServicesOrganizationToken: Maybe<Scalars['String']['output']>;
  /** Total enrolled enrollments (including legacy approved) across all workspace programs. */
  enrollmentCount: Scalars['Int']['output'];
  /** Monthly cumulative enrolled (including legacy approved) enrollment count series. */
  enrollmentCountSeries: Array<EnrollmentGrowthDataPoint>;
  id: Scalars['ID']['output'];
  industry: Maybe<Scalars['String']['output']>;
  invitations: Maybe<Array<Invitation>>;
  location: Maybe<OrganizationLocation>;
  logo: Maybe<Scalars['String']['output']>;
  memberships: Maybe<Array<Membership>>;
  /** Total number of meters across all workspaces in this organization. */
  meterCount: Scalars['Int']['output'];
  /** Monthly cumulative meter count time series across all workspaces. */
  meterCountSeries: Array<GrowthDataPoint>;
  /** Whether MFA email OTP is enabled for this organization. */
  mfaEmailOtpEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** @deprecated Use ownerProfile instead */
  owner: Maybe<User>;
  /** The profile of the owner of the organization. */
  ownerProfile: Maybe<UserProfile>;
  personal: Scalars['Boolean']['output'];
  /** Preferred temperature unit for the user. */
  preferredTemperatureUnit: PreferredTemperatureUnit;
  /** Total number of sites across all workspaces in this organization. */
  siteCount: Scalars['Int']['output'];
  /** Monthly cumulative site count time series across all workspaces. */
  siteCountSeries: Array<GrowthDataPoint>;
  /** Whether SSO is enabled for this organization. */
  ssoEnabled: Scalars['Boolean']['output'];
  /** SAML/OIDC configuration metadata. */
  ssoMetadata: Maybe<Scalars['JSON']['output']>;
  /** SSO provider type (e.g., 'auth0-saml', 'auth0-oidc'). */
  ssoProvider: Maybe<Scalars['String']['output']>;
  /** Total rated battery capacity across all batteries, in kWh. */
  totalBatteryCapacityKwh: Maybe<Scalars['Float']['output']>;
  /** Total nameplate capacity of inverters in this organization, in kilowatts. */
  totalCapacityKw: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Maybe<Scalars['String']['output']>;
  workspaceAccessGrants: Maybe<Array<WorkspaceAccessGrant>>;
  workspaces: Maybe<Array<Workspace>>;
};


export type OrganizationBatteryChargeKwhSeriesArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};


export type OrganizationCapacityKwSeriesArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};


export type OrganizationDeviceCountSeriesArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};


export type OrganizationEnrollmentCountSeriesArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};


export type OrganizationMeterCountSeriesArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};


export type OrganizationSiteCountSeriesArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};

/** An organization access request from a user wanting to join an organization */
export type OrganizationAccessRequest = {
  __typename?: 'OrganizationAccessRequest';
  /** The role assigned to the user upon approval */
  assignedRole: Maybe<Role>;
  /** When the request was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for the request */
  id: Scalars['ID']['output'];
  /** The organization being requested to join */
  organization: Organization;
  /** The ID of the organization being requested to join */
  organizationId: Scalars['ID']['output'];
  /** When the request was reviewed */
  reviewedAt: Maybe<Scalars['DateTime']['output']>;
  /** The admin who reviewed the request (if reviewed) */
  reviewer: Maybe<User>;
  /** The ID of the reviewer (if reviewed) */
  reviewerId: Maybe<Scalars['ID']['output']>;
  /** Current status of the request */
  status: OrganizationAccessRequestStatus;
  /** Unique token for the request (used in email links) */
  token: Scalars['String']['output'];
  /** When the request was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The user requesting access */
  user: User;
  /** The ID of the user requesting access */
  userId: Scalars['ID']['output'];
};

/** Status of an organization access request */
export type OrganizationAccessRequestStatus =
  | 'APPROVED'
  | 'DENIED'
  | 'PENDING';

/** Represents an affiliation between two organizations. */
export type OrganizationAffiliation = {
  __typename?: 'OrganizationAffiliation';
  affiliatedOrganization: Organization;
  affiliatedOrganizationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Maybe<UserProfile>;
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationId: Scalars['String']['output'];
};

export type OrganizationInvitationsFilter = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationInvitationsInput = {
  filter: OrganizationInvitationsFilter;
  pagination?: InputMaybe<ListPagination>;
};

export type OrganizationLocation = {
  __typename?: 'OrganizationLocation';
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  streetOne: Maybe<Scalars['String']['output']>;
  streetTwo: Maybe<Scalars['String']['output']>;
};

export type OrganizationMembersFilter = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationMembersInput = {
  filter: OrganizationMembersFilter;
  pagination?: InputMaybe<ListPagination>;
};

/** Error returned when an organization is not found */
export type OrganizationNotFoundError = IMutationError & {
  __typename?: 'OrganizationNotFoundError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Represents a dashboard pack that has been enabled for an organization. */
export type OrganizationPack = {
  __typename?: 'OrganizationPack';
  enabledAt: Scalars['DateTime']['output'];
  /** The admin who enabled this pack. Null if auto-enabled during onboarding. */
  enabledBy: Maybe<UserProfile>;
  id: Scalars['ID']['output'];
  pack: PackType;
};

/** Paginated response for organizations query */
export type OrganizationPaginatedQueryPayload = {
  __typename?: 'OrganizationPaginatedQueryPayload';
  data: Maybe<Array<Organization>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type OrganizationWorkspacesFilter = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationWorkspacesInput = {
  filter: OrganizationWorkspacesFilter;
  pagination?: InputMaybe<ListPagination>;
};

/** Filter options for organizations query */
export type OrganizationsFilter = {
  /** Filter by organization domain */
  domain?: InputMaybe<Scalars['String']['input']>;
  /** Filter by organization industry */
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Filter by organization name (partial match) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter by personal organization flag */
  personal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for querying organizations */
export type OrganizationsInput = {
  filter?: InputMaybe<OrganizationsFilter>;
  orderBy?: InputMaybe<OrganizationsOrderBy>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<OrganizationsSearch>;
};

/** Sort options for organizations query */
export type OrganizationsOrderBy = {
  /** Sort by creation date */
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
  /** Sort by name */
  name?: InputMaybe<PaginatedQueryOrderBy>;
  /** Sort by updated date */
  updatedAt?: InputMaybe<PaginatedQueryOrderBy>;
};

/** Search options for organizations query */
export type OrganizationsSearch = {
  /** Search across name and domain */
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Types of dashboard packs that can be enabled for an organization. */
export type PackType =
  /** Device Cloud dashboard for OEM device management. */
  | 'DEVICE_CLOUD'
  /** Program Cloud for accessing utility programs. */
  | 'PROGRAM_CLOUD'
  /** Program operations dashboard for utility program operators. */
  | 'PROGRAM_OPERATIONS'
  /** Texture Direct for direct program enrollment. */
  | 'TEXTURE_DIRECT';

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PaginatedQueryOrderBy =
  | 'asc'
  | 'desc';

export type PaginatedQuerySearchInput = {
  query: Scalars['String']['input'];
  type: PaginatedQuerySearchTypeEnum;
};

export type PaginatedQuerySearchTypeEnum =
  | 'fullText'
  | 'partial';

export type PaginationType =
  | 'cursor'
  | 'offset';

export type ParticipationStatusFilter =
  | 'ALL'
  | 'DID_NOT_PARTICIPATE'
  | 'PARTICIPATED';

export type ParticipationSummary = {
  __typename?: 'ParticipationSummary';
  /** Devices that did not participate */
  didNotParticipate: Scalars['Int']['output'];
  /** Non-participation percentage (0-100) */
  didNotParticipatePercentage: Scalars['Float']['output'];
  /** Total devices enrolled */
  enrolled: Scalars['Int']['output'];
  /** Devices that participated */
  participated: Scalars['Int']['output'];
  /** Participation percentage (0-100) */
  participatedPercentage: Scalars['Float']['output'];
};

export type PauseThermostatScheduleInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Permit = {
  __typename?: 'Permit';
  description: Maybe<Scalars['String']['output']>;
  fileDate: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobValue: Maybe<Scalars['Int']['output']>;
  jurisdiction: Scalars['String']['output'];
  number: Scalars['String']['output'];
  status: Maybe<Scalars['String']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Maybe<Scalars['String']['output']>;
};

export type PhoneRequirementConfig = RequirementConfig & {
  __typename?: 'PhoneRequirementConfig';
  _type: Scalars['String']['output'];
  placeholder: Maybe<Scalars['String']['output']>;
};

/**
 * A platform field from the field registry. Unlike AvailableField, entityType is
 * a free-form string to support all registry entities (device, site, contact,
 * enrollment, location, program, customer).
 */
export type PlatformField = {
  __typename?: 'PlatformField';
  /** Field description from the registry */
  description: Maybe<Scalars['String']['output']>;
  /** Human-readable label */
  displayName: Scalars['String']['output'];
  /** Which entity this field belongs to (e.g., DEVICE, SITE, CONTACT, LOCATION) */
  entityType: Scalars['String']['output'];
  /** The field key in the registry */
  factKey: Scalars['String']['output'];
  /** The data type (string, number, boolean, date, enum, composite, etc.) */
  fieldType: Scalars['String']['output'];
  /** Always PLATFORM for registry fields */
  source: Scalars['String']['output'];
};

export type PollableConnection = {
  __typename?: 'PollableConnection';
  clientId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  linkSessionId: Maybe<Scalars['String']['output']>;
  manufacturer: Scalars['String']['output'];
  manufacturerUserId: Scalars['String']['output'];
};

export type PollableConnectionsInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  manufacturer: Scalars['String']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PollableConnectionsPage = {
  __typename?: 'PollableConnectionsPage';
  items: Array<PollableConnection>;
  nextCursor: Maybe<Scalars['String']['output']>;
};

export type PollingInterval =
  | 'FIFTEEN_MINUTES'
  | 'FIVE_MINUTES'
  | 'ONE_DAY'
  | 'ONE_HOUR'
  | 'ONE_MINUTE'
  | 'SIX_HOURS'
  | 'TEN_MINUTES'
  | 'THIRTY_MINUTES'
  | 'TWELVE_HOURS';

export type PreferredTemperatureUnit =
  | 'CELSIUS'
  | 'FAHRENHEIT';

export type Program = {
  __typename?: 'Program';
  active: Scalars['Boolean']['output'];
  color: Maybe<Scalars['String']['output']>;
  config: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  eligibilityCriteria: Maybe<Scalars['String']['output']>;
  endDate: Maybe<Scalars['DateTime']['output']>;
  /** The enrollment lifecycle definition for this program */
  enrollment: Maybe<LifecycleDefinition>;
  id: Scalars['ID']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Maybe<Scalars['String']['output']>;
  programTerms: Maybe<Scalars['String']['output']>;
  public: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  states: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variants: Array<ProgramVariant>;
  workspacePrograms: Array<WorkspaceProgram>;
  year: Maybe<Scalars['Int']['output']>;
};

export type ProgramEnrollmentRef = {
  __typename?: 'ProgramEnrollmentRef';
  /** WorkspaceProgram ID */
  programId: Scalars['ID']['output'];
  /** Program title/name */
  programName: Scalars['String']['output'];
};

export type ProgramLead_Old = {
  __typename?: 'ProgramLead_Old';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lead: Lead;
  leadId: Scalars['String']['output'];
  program: Program_Old;
  programId: Scalars['String']['output'];
};

/**
 * Unified filter input for all program reporting queries.
 * Replaces the need for separate portfolio/single-program/single-event queries.
 */
export type ProgramReportFilterInput = {
  /** Device-level filters (optional) */
  deviceFilters?: InputMaybe<ReportDeviceFilterInput>;
  /** Maximum number of events to return (default: 15) */
  maxEvents?: InputMaybe<Scalars['Int']['input']>;
  /** Program scope determines which programs/events to include */
  programScope: ProgramScopeInput;
  /** Time scope for filtering events (optional - defaults to all matching events) */
  timeScope?: InputMaybe<TimeScopeInput>;
  /** Workspace context for authorization and data scoping */
  workspaceId: Scalars['ID']['input'];
};

export type ProgramReportMeta = {
  __typename?: 'ProgramReportMeta';
  /** Number of unique devices */
  deviceCount: Scalars['Int']['output'];
  /** Number of events included */
  eventCount: Scalars['Int']['output'];
  /** Time range of the data */
  timeRange: ReportTimeRange;
};

export type ProgramScopeInput = {
  /** Required when type is SINGLE_EVENT */
  eventId?: InputMaybe<Scalars['ID']['input']>;
  /** Required when type is SINGLE_PROGRAM */
  programId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * PORTFOLIO: All programs in workspace
   * SINGLE_PROGRAM: Specific program by ID
   * SINGLE_EVENT: Specific event by ID
   */
  type: ProgramScopeType;
};

export type ProgramScopeType =
  | 'PORTFOLIO'
  | 'SINGLE_EVENT'
  | 'SINGLE_PROGRAM';

export type ProgramType_Old = {
  __typename?: 'ProgramType_Old';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

/**
 * A variant of a canonical program that can have different configurations.
 * Used to create different tiers or flavors of a program (e.g., basic vs premium).
 */
export type ProgramVariant = {
  __typename?: 'ProgramVariant';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  program: Program;
  programId: Scalars['ID']['output'];
  programTerms: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspacePrograms: Array<WorkspaceProgram>;
};

export type Program_Old = {
  __typename?: 'Program_Old';
  createdAt: Scalars['DateTime']['output'];
  customFields: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  eligibilityCriteria: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  programTerms: Scalars['String']['output'];
  programType: ProgramType_Old;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramsForWorkspaceFilter_Old = {
  workspaceId: Scalars['String']['input'];
};

export type ProgramsForWorkspaceInput_Old = {
  filter: ProgramsForWorkspaceFilter_Old;
  orderBy?: InputMaybe<ProgramsForWorkspaceOrderByInput_Old>;
  pagination?: InputMaybe<ListPagination>;
};

export type ProgramsForWorkspaceOrderByInput_Old = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
};

export type ProgramsPaginatedQueryPayload_Old = {
  __typename?: 'ProgramsPaginatedQueryPayload_Old';
  data: Array<Program_Old>;
  meta: ListPayloadMeta;
};

/** Provisioning type distinguishes how devices were created */
export type ProvisioningType =
  | 'OEM_DIRECT'
  | 'TEXTURE_MANAGED';

export type Query = {
  __typename?: 'Query';
  /**
   * Execute an AI-powered device query using Elasticsearch Query DSL.
   * The query is automatically scoped to the specified workspace.
   */
  aiDeviceQuery: AiDeviceQueryResult;
  /**
   * Get the device schema metadata for AI-powered query generation.
   * This provides field information, valid values, and query guidelines.
   */
  aiDeviceQuerySchema: AiDeviceSchemaResult;
  alerts: AlertsResponse;
  /** List all users (cross-tenant). Only accessible by super admins. */
  allUsers: UserPaginatedQueryPayload;
  apiKey: ApiKey;
  apiKeys: ApiKeyPaginatedQueryPayload;
  appByKey: Maybe<App>;
  /** Get a specific app grant by ID */
  appGrant: Maybe<AppGrant>;
  /** Get all app grants for the current workspace */
  appGrants: Array<AppGrant>;
  appProviderGrant: Grant;
  appProviders: AppProvidersResponse;
  appProvidersForWorkspaces: AppProvidersForWorkspacesResponse;
  /** Get usage statistics for a specific grant */
  appUsageStats: Maybe<AppUsageStats>;
  /** Get all available apps */
  apps: Array<App>;
  /**
   * Get all manufacturers assigned to the current organization.
   * Returns an empty list if no manufacturers are assigned.
   * Requires authentication.
   */
  assignedManufacturers: Array<ManufacturerAssignment>;
  /**
   * Get paginated audit logs for the authenticated user's organization.
   * Requires user JWT authentication and admin role within the organization.
   */
  auditLogs: ManagementAuditLogPaginatedPayload;
  /**
   * Returns all available fields for a lifecycle definition: platform fields from
   * the registry + custom fields from the database. If no lifecycleDefinitionId
   * is provided, returns only platform fields.
   */
  availableFields: Array<AvailableField>;
  batch: Maybe<Batch>;
  batchFetchLocationsById: Array<Location>;
  checkApiKey: ApiKey;
  checkAppAuthenticationSession: CheckAppAuthenticationSessionResponse;
  /**
   * Check for existing devices in a workspace by manufacturerUserId.
   * Used during connection flows to detect if a user has already connected devices.
   */
  checkDuplicateDevices: DuplicateDeviceCheckResult;
  checkEmailVerificationStatus: Maybe<Scalars['Boolean']['output']>;
  command: Maybe<Command>;
  commandWebhook: Maybe<CommandWebhook>;
  commandWebhookDeliveries: Array<WebhookDelivery>;
  connectSession: Maybe<ConnectSession>;
  connectSessions: ConnectSessionsResponse;
  /** Get a contact by its ID */
  contact: Contact;
  /** Returns a list of all contacts. */
  contacts: Array<Contact>;
  customer: Customer;
  customerConnection: CustomerConnection;
  customerFilter: FilterMeta;
  customers: CustomerPaginatedQueryPayload;
  /** @deprecated Use customers query instead */
  customersForWorkspace: CustomerPaginatedQueryPayload;
  destinations: DestinationListPayload;
  device: Device;
  deviceCommands: DeviceCommandPaginatedQueryPayload;
  deviceFilter: FilterMeta;
  deviceFilters: Array<FilterMeta>;
  deviceGrowthStats: Array<GrowthDataPoint>;
  /**
   * Device participation report with energy data.
   * Returns device-level participation metrics with optional energy.
   * Single query replaces 5+ current frontend queries.
   */
  deviceParticipationReport: DeviceParticipationReport;
  deviceSchedule: DeviceSchedule;
  /** @deprecated Use deviceSchedulesForDevice instead */
  deviceScheduleForDevice: DeviceSchedule;
  deviceSchedulesForDevice: DeviceSchedulesForDeviceQueryPayload;
  deviceStateHistory: DeviceStatePaginatedQueryPayload;
  devices: DevicePaginatedQueryPayload;
  /**
   * Look up Texture devices by the meterId stored on MeterStaticState,
   * scoped to a specific workspace. Used by the location domain to partition
   * GridElement consumers into Texture-tracked and untracked groups.
   * Returns distinct results within the workspace.
   */
  devicesByMeterIds: Array<DeviceByMeterIdResult>;
  downloadUrl: DownloadUrlResult;
  energyConsumption: MetricPayloadResponse;
  energyEmissions: MetricPayloadResponse;
  energyGeneration: MetricPayloadResponse;
  energyProduction: MetricPayloadResponse;
  energyStorage: MetricPayloadResponse;
  enphaseGridServicesEnrollments: EnphaseGridServicesEnrollmentsResponse;
  enrollment: Maybe<Enrollment>;
  enrollmentFilter: FilterMeta;
  enrollmentReportConfig: Maybe<EnrollmentReportConfig>;
  enrollments: Maybe<EnrollmentPaginatedQueryPayload>;
  ercotDayAheadMarketSettlementPointPrices: ErcotDayAheadMarketSettlementPointPriceResponse;
  /**
   * Aggregated event performance report for program reporting.
   * Returns pre-computed hourly buckets using backend CAGGs.
   * Single query replaces 6+ current frontend queries.
   */
  eventPerformanceReport: EventPerformanceReport;
  events: Array<Event>;
  fieldConfigurations: Array<FieldConfiguration>;
  /**
   * Fleet health report for enrolled devices.
   * Returns health metrics (success rate, response time, connectivity) and issues.
   * Uses a 30-day rolling window for metrics.
   */
  fleetHealthReport: FleetHealthReport;
  /**
   * Get a collection by its ID
   * @deprecated Use getCollectionByIdV2
   */
  getCollectionById: Collection;
  getCollectionByIdV2: CollectionV2;
  /**
   * Get paginated list of collections by workspace ID
   * @deprecated Use getCollectionsForWorkspaceV2
   */
  getCollectionsForWorkspace: CollectionPaginatedQueryPayload;
  getCollectionsForWorkspaceV2: CollectionPaginatedQueryPayloadV2;
  /** Get paginated list of entities by collection ID */
  getEntitiesByCollectionId: CollectionEntitiesPaginatedQueryPayload;
  /** Get paginated list of shared collections */
  getSharedCollections: CollectionPaginatedQueryPayload;
  /**
   * Fetch a GridElement by ID. For overhead/underground line elements, this
   * returns a virtual collapsed representation of the entire line segment.
   */
  gridElement: GridElement;
  /**
   * Fetches the total grid energy for a site. This represents the import/export energy flow from the grid.
   * Negative values represent energy export. Postive values represent energy import.
   */
  gridEnergy: MetricPayloadResponse;
  invitation: Maybe<Invitation>;
  /**
   * List all invitations for the authenticated user's organization.
   * Reads the organization from JWT claims — no Oso authorization required.
   * Designed for use with API key bearer tokens (management keys).
   */
  invitations: InvitationPaginatedQueryPayload;
  isValidAddress: AddressValidationResult;
  lead: Maybe<Lead>;
  leads: LeadsPaginatedQueryPayload;
  lifecycleDefinition: Maybe<LifecycleDefinition>;
  lifecycleInstance: Maybe<LifecycleInstance>;
  lifecycleInstances: Maybe<LifecycleInstancePaginatedPayload>;
  /** Get paginated management audit logs for an organization. Only accessible by client credentials (API service). */
  managementAuditLogs: ManagementAuditLogPaginatedPayload;
  /**
   * Get a specific manufacturer assignment if the current organization has access.
   * Returns null if the organization does not have access to manage this manufacturer.
   * Requires authentication.
   */
  manufacturerAssignment: Maybe<ManufacturerAssignment>;
  /**
   * Get all manufacturers assigned to a specific organization.
   * Only Texture super admins can perform this action.
   */
  manufacturerAssignmentsForOrganization: Array<ManufacturerAssignment>;
  manufacturerCredentials: ManufacturerCredentialsResponse;
  /**
   * Get a single device by ID.
   * Requires the calling organization to have a ManufacturerAssignment for the device's manufacturer.
   * Returns null if not found or not authorized.
   */
  manufacturerDevice: Maybe<ManufacturerDevice>;
  /**
   * Get a single device model by ID.
   * Requires the calling organization to have a ManufacturerAssignment for the model's manufacturer.
   * Returns null if not found or not authorized.
   */
  manufacturerDeviceModel: Maybe<ManufacturerDeviceModel>;
  /**
   * List device models for a manufacturer.
   * Requires the calling organization to have a ManufacturerAssignment for the given manufacturer.
   */
  manufacturerDeviceModels: Array<ManufacturerDeviceModel>;
  /**
   * List devices for a manufacturer.
   * Requires the calling organization to have a ManufacturerAssignment for the given manufacturer.
   */
  manufacturerDevices: ManufacturerDevicesPaginatedPayload;
  /** Get a single manufacturer integration by ID or slug */
  manufacturerIntegration: Maybe<ManufacturerIntegrationProfile>;
  /** Get all manufacturer integrations with optional filtering */
  manufacturerIntegrations: Array<ManufacturerIntegrationProfile>;
  manufacturerPollingIntervals: Array<ManufacturerPollingInterval>;
  /**
   * Get recent telemetry events for a manufacturer.
   * Requires authentication and the user's organization must have access to the manufacturer.
   */
  manufacturerRecentTelemetry: Array<RecentTelemetryEvent>;
  /**
   * Get telemetry statistics for a manufacturer.
   * Requires authentication and the user's organization must have access to the manufacturer.
   */
  manufacturerTelemetryStats: ManufacturerTelemetryStats;
  /**
   * Get daily telemetry counts over time for a manufacturer.
   * Requires authentication and the user's organization must have access to the manufacturer.
   */
  manufacturerTelemetryTimeSeries: Array<TelemetryTimeSeriesDataPoint>;
  /**
   * Look up a ManufacturerUserConnection by its unique key.
   * Returns the stable connection ID used for polling and connection.established events.
   */
  manufacturerUserConnection: Maybe<PollableConnection>;
  manufacturers: Array<DeviceManufacturerProfile>;
  me: Maybe<LoggedUser>;
  /**
   * List all memberships for the authenticated user's organization.
   * Reads the organization from JWT claims — no Oso authorization required.
   * Designed for use with API key bearer tokens (management keys).
   */
  members: Array<Membership>;
  membership: Membership;
  /**
   * Fetches meter consumption data aggregated from MeterState.lastIntervalKwhUsage.
   * Returns energy consumed in Watt-hours per time bucket.
   */
  meterConsumption: MetricPayloadResponse;
  /**
   * Resolve a device model by slug, checking both canonical DeviceModel slugs
   * and manufacturer alias slugs (DeviceModelSlug table). Returns null if no match.
   */
  modelBySlug: Maybe<DeviceModelProfile>;
  models: Array<DeviceModelProfile>;
  /** Get the current user's pending organization access requests. */
  myPendingOrganizationAccessRequests: Array<OrganizationAccessRequest>;
  /** Get a single OAuth application by ID */
  oauthApplication: OAuthApplication;
  /** Get paginated list of OAuth applications for a workspace */
  oauthApplications: OAuthApplicationPaginatedQueryPayload;
  /**
   * Get OEM device information for telemetry ingestion.
   * Validates device exists, is OEM_DIRECT provisioned, and manufacturer is allowed.
   */
  oemDeviceForTelemetry: OemDeviceForTelemetryResult;
  /**
   * Get OEM devices for a manufacturer.
   * Requires authentication and the user's organization must have access to the manufacturer.
   */
  oemDevices: OemDevicesPaginatedPayload;
  organization: Maybe<Organization>;
  /** Get an organization access request by token. Used by admins to review requests. */
  organizationAccessRequest: Maybe<OrganizationAccessRequest>;
  organizationInvitations: InvitationPaginatedQueryPayload;
  organizationMembers: MembershipPaginatedQueryPayload;
  organizationWorkspaces: WorkspacePaginatedQueryPayload;
  /** List all organizations. Only accessible by super admins. */
  organizations: OrganizationPaginatedQueryPayload;
  /** Get organizations that match the current user's email domain. */
  organizationsForMyDomain: Array<Organization>;
  /**
   * Returns all platform fields from the field registry without any allowlist
   * or configuration filtering. Used by the admin panel to browse the full
   * field catalog for configuration.
   */
  platformFields: Array<PlatformField>;
  /**
   * Internal query — returns all active (non-expired) ManufacturerUserConnections for a given
   * manufacturer, used by the OEM adapter's connectionScheduler job to fan out per-connection polls.
   */
  pollableConnections: PollableConnectionsPage;
  program: Maybe<Program>;
  programBySlug_Old: Maybe<Program_Old>;
  programVariant: Maybe<ProgramVariant>;
  programVariants: Array<ProgramVariant>;
  program_Old: Maybe<Program_Old>;
  programs: Array<Program>;
  programs_Old: ProgramsPaginatedQueryPayload_Old;
  reportEnergy: ReportEnergyResponse;
  reportEnergyFilterOptions: ReportEnergyFilterOptionsResponse;
  reportEnergyTagCategories: ReportEnergyTagCategoriesResponse;
  reportEnergyTagOptions: ReportEnergyFilterOptionsResponse;
  /**
   * Lightweight query for event dropdown options.
   * Does not fetch batch/command data - optimized for UI dropdowns.
   */
  reportEventOptions: ReportEventOptionsResponse;
  /**
   * Fetch the SCADA topology tree rooted at the element identified by elementGuid.
   * Pass GridElement.elementGuid; the matching ScadaGridNode becomes the root so the
   * diagram shows that element at the top with its children below. Returns null when
   * no ScadaGridNode exists for the given GUID (GUID mismatch between Milsoft and VEC
   * SCADA), in which case the client should retry with the parent element's GUID.
   * Returns a flat node list with parentId references and latest telemetry readings.
   * elementName is accepted but unused - retained for backward compatibility with
   * Apollo-tracked operations that previously sent it. Pass elementGuid instead.
   */
  scadaTopology: Maybe<ScadaTopologyResult>;
  searchDevices: SearchDevicesPaginatedQueryPayload;
  /**
   * Search platform fields by display name or fact key across all entity types.
   * Returns matching fields from the full registry catalog.
   */
  searchPlatformFields: Array<PlatformField>;
  site: Site;
  siteFilter: FilterMeta;
  siteGrowthStats: Array<GrowthDataPoint>;
  sites: SitePaginatedQueryPayload;
  /** List all super admin grants (active and revoked). Only accessible by super admins. */
  superAdminGrants: SuperAdminGrantPaginatedQueryPayload;
  tagSchedule: TagSchedule;
  tagSchedulesForTag: TagSchedulesForTagQueryPayload;
  tags: Array<Scalars['String']['output']>;
  /** Fetch tags with the count of unique sites that have devices with each tag */
  tagsWithSiteCounts: Array<TagWithSiteCount>;
  /**
   * Generalized telemetry query. Fetches time-series data for any metrics
   * from any sources (DER devices or SCADA grid nodes) with optional
   * hierarchy rollup and txQL derived metric expressions.
   */
  telemetryQuery: TelemetryQueryResult;
  /** Fetches the total energy storage capacity for a workspace. This represents the maximum energy storage capacity of all devices in the workspace. */
  totalEnergyCapacity: MetricPayloadResponse;
  /**
   * TODO: Should we create separate metric query input types to denote that we do not support filters?
   * OR should we continue to support filters and allow this to also filter by associative values?
   */
  totalEnergyConsumption: MetricPayloadResponse;
  /** Fetches the total energy generation for a workspace. This represents the total energy generated from inverters across all devices in the workspace. */
  totalEnergyGeneration: MetricPayloadResponse;
  totalEnergyProduction: MetricPayloadResponse;
  /** Fetches the total energy storage for a workspace. This represents the current energy storage capacity of all devices in the workspace. */
  totalEnergyStorage: MetricPayloadResponse;
  /**
   * Fetches the total grid energy for a workspace. This represents the import/export energy flow from the grid.
   * Negative values represent energy export. Postive values represent energy import.
   */
  totalGridEnergy: MetricPayloadResponse;
  usageForOrganization: Array<Maybe<Usage>>;
  /**
   * Get a single user by ID.
   * Requires authentication. Returns user data if:
   * - The authenticated user is requesting their own data, OR
   * - The authenticated user is a super admin
   */
  user: Maybe<User>;
  userProfile: UserProfile;
  /** Get the current user's settings. Returns the most recent settings record. */
  userSettings: Maybe<UserSettings>;
  /** Returns all utilities (US electrical utilities) with their IDs. */
  utilities: Array<UtilityOption>;
  validateAddresses: Array<AddressValidationBatchResult>;
  /**
   * Validate that manufacturer IDs are assigned to an organization.
   * Returns only the manufacturer IDs from the input that ARE assigned to the org.
   * Used for internal service-to-service validation (e.g., identity domain validating manufacturer API keys).
   */
  validateManufacturerAssignments: Array<Scalars['ID']['output']>;
  /** Validate a workflow configuration [Auth: requires_client_or_user_authentication] */
  validateWorkflow: ValidationResult;
  virtualAccount: Maybe<VirtualAccount>;
  virtualAccounts: Array<VirtualAccount>;
  virtualDevice: Maybe<VirtualDevice>;
  virtualDevices: Array<VirtualDevice>;
  /** Get a single workflow by ID [Auth: requires_client_or_user_authentication] */
  workflow: Maybe<Workflow>;
  /** Get a single workflow execution by ID [Auth: requires_client_or_user_authentication] */
  workflowExecution: Maybe<WorkflowExecution>;
  /** Get the workflow JSON schema catalog [Auth: requires_client_or_user_authentication] */
  workflowSchema: Scalars['JSON']['output'];
  /** List workflows with optional filtering and pagination [Auth: requires_client_or_user_authentication] */
  workflows: WorkflowConnection;
  workspace: Maybe<Workspace>;
  workspaceAlertConfig: WorkspaceAlertConfig;
  workspaceConnectConfig: Maybe<WorkspaceConnectConfig>;
  workspaceProgram: Maybe<WorkspaceProgram>;
  workspaceProgramEvent: Maybe<WorkspaceProgramEvent>;
  workspacePrograms: Maybe<WorkspaceProgramPaginatedQueryPayload>;
  workspaceSystemConnection: WorkspaceSystemConnection;
  workspaceSystemConnections: WorkspaceSystemConnections;
  workspaces: Array<Workspace>;
};


export type QueryAiDeviceQueryArgs = {
  input: AiDeviceQueryInput;
};


export type QueryAlertsArgs = {
  input: AlertsInput;
};


export type QueryAllUsersArgs = {
  input: AllUsersInput;
};


export type QueryApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApiKeysArgs = {
  input: ApiKeysInput;
};


export type QueryAppByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryAppGrantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppGrantsArgs = {
  category: InputMaybe<AppCategory>;
  enabled: InputMaybe<Scalars['Boolean']['input']>;
  provider: InputMaybe<AppProvider>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryAppProviderGrantArgs = {
  appProviderGrantId: Scalars['ID']['input'];
};


export type QueryAppProvidersArgs = {
  options: InputMaybe<AppProvidersOptions>;
  workspaceId: Scalars['String']['input'];
};


export type QueryAppProvidersForWorkspacesArgs = {
  input: AppProvidersForWorkspacesInput;
};


export type QueryAppUsageStatsArgs = {
  endDate: InputMaybe<Scalars['DateTime']['input']>;
  grantId: Scalars['ID']['input'];
  startDate: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAppsArgs = {
  authType: InputMaybe<AuthType>;
  category: InputMaybe<AppCategory>;
  oauthOnly: InputMaybe<Scalars['Boolean']['input']>;
  provider: InputMaybe<AppProvider>;
  search: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuditLogsArgs = {
  input: AuditLogsInput;
};


export type QueryAvailableFieldsArgs = {
  entityType: InputMaybe<Scalars['String']['input']>;
  lifecycleDefinitionId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBatchFetchLocationsByIdArgs = {
  ids: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCheckApiKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryCheckAppAuthenticationSessionArgs = {
  token: Scalars['String']['input'];
};


export type QueryCheckDuplicateDevicesArgs = {
  input: DuplicateDeviceCheckInput;
};


export type QueryCheckEmailVerificationStatusArgs = {
  email: Scalars['String']['input'];
};


export type QueryCommandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommandWebhookArgs = {
  manufacturerId: Scalars['ID']['input'];
};


export type QueryCommandWebhookDeliveriesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  manufacturerId: Scalars['ID']['input'];
};


export type QueryConnectSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConnectSessionsArgs = {
  input: ConnectSessionsInput;
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  input: ContactsInput;
};


export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerConnectionArgs = {
  connectionId: Scalars['ID']['input'];
};


export type QueryCustomerFilterArgs = {
  field: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryCustomersArgs = {
  input: CustomersInput;
};


export type QueryCustomersForWorkspaceArgs = {
  input: CustomersForWorkspaceInput;
};


export type QueryDestinationsArgs = {
  input: DestinationsInput;
};


export type QueryDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDeviceCommandsArgs = {
  input: DeviceCommandsInput;
};


export type QueryDeviceFilterArgs = {
  field: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryDeviceFiltersArgs = {
  workspaceId: Scalars['String']['input'];
};


export type QueryDeviceGrowthStatsArgs = {
  input: GrowthStatsInput;
};


export type QueryDeviceParticipationReportArgs = {
  input: ProgramReportFilterInput;
};


export type QueryDeviceScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type QueryDeviceScheduleForDeviceArgs = {
  deviceId: Scalars['ID']['input'];
};


export type QueryDeviceSchedulesForDeviceArgs = {
  deviceId: Scalars['ID']['input'];
};


export type QueryDeviceStateHistoryArgs = {
  input: DeviceStateHistoryInput;
};


export type QueryDevicesArgs = {
  input: DevicesInput;
};


export type QueryDevicesByMeterIdsArgs = {
  meterIds: Array<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryDownloadUrlArgs = {
  uploadId: Scalars['ID']['input'];
};


export type QueryEnergyConsumptionArgs = {
  input: MetricQueryInput;
};


export type QueryEnergyEmissionsArgs = {
  input: MetricQueryInput;
};


export type QueryEnergyGenerationArgs = {
  input: MetricQueryInput;
};


export type QueryEnergyProductionArgs = {
  input: MetricQueryInput;
};


export type QueryEnergyStorageArgs = {
  input: MetricQueryInput;
};


export type QueryEnphaseGridServicesEnrollmentsArgs = {
  input: EnphaseGridServicesEnrollmentsInput;
};


export type QueryEnrollmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEnrollmentFilterArgs = {
  field: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryEnrollmentReportConfigArgs = {
  workspaceProgramId: Scalars['ID']['input'];
};


export type QueryEnrollmentsArgs = {
  enrollmentGroupIds: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination: InputMaybe<OffsetPagination>;
  statuses: InputMaybe<Array<EligibilityStatus>>;
  tags: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceProgramId: Scalars['ID']['input'];
};


export type QueryEventPerformanceReportArgs = {
  input: ProgramReportFilterInput;
};


export type QueryEventsArgs = {
  input: EventInput;
  workspaceId: Scalars['ID']['input'];
};


export type QueryFieldConfigurationsArgs = {
  context: InputMaybe<Scalars['String']['input']>;
  entityType: InputMaybe<Scalars['String']['input']>;
};


export type QueryFleetHealthReportArgs = {
  input: FleetHealthFilterInput;
};


export type QueryGetCollectionByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCollectionByIdV2Args = {
  id: Scalars['ID']['input'];
};


export type QueryGetCollectionsForWorkspaceArgs = {
  input: GetCollectionsForWorkspaceInput;
};


export type QueryGetCollectionsForWorkspaceV2Args = {
  input: GetCollectionsForWorkspaceInput;
};


export type QueryGetEntitiesByCollectionIdArgs = {
  id: Scalars['ID']['input'];
  input: GetEntitiesByCollectionIdInput;
};


export type QueryGridElementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGridEnergyArgs = {
  input: MetricQueryInput;
};


export type QueryInvitationArgs = {
  id: Scalars['String']['input'];
};


export type QueryInvitationsArgs = {
  input: OrganizationInvitationsInput;
};


export type QueryIsValidAddressArgs = {
  address: Address;
};


export type QueryLeadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadsArgs = {
  input: LeadsForWorkspaceInput;
};


export type QueryLifecycleDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLifecycleInstanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLifecycleInstancesArgs = {
  pagination: InputMaybe<OffsetPagination>;
  workspaceProgramId: Scalars['ID']['input'];
};


export type QueryManagementAuditLogsArgs = {
  input: ManagementAuditLogsInput;
};


export type QueryManufacturerAssignmentArgs = {
  manufacturerId: Scalars['ID']['input'];
};


export type QueryManufacturerAssignmentsForOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryManufacturerCredentialsArgs = {
  input: ManufacturerCredentialsInput;
};


export type QueryManufacturerDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryManufacturerDeviceModelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryManufacturerDeviceModelsArgs = {
  filter: InputMaybe<ManufacturerDeviceModelsFilter>;
  manufacturerId: Scalars['ID']['input'];
};


export type QueryManufacturerDevicesArgs = {
  filter: InputMaybe<ManufacturerDevicesFilter>;
  manufacturerId: Scalars['ID']['input'];
  pagination: InputMaybe<ListPagination>;
};


export type QueryManufacturerIntegrationArgs = {
  id: InputMaybe<Scalars['ID']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
};


export type QueryManufacturerIntegrationsArgs = {
  filters: InputMaybe<ManufacturerIntegrationFilters>;
};


export type QueryManufacturerRecentTelemetryArgs = {
  input: ManufacturerRecentTelemetryInput;
};


export type QueryManufacturerTelemetryStatsArgs = {
  input: ManufacturerTelemetryStatsInput;
};


export type QueryManufacturerTelemetryTimeSeriesArgs = {
  input: ManufacturerTelemetryTimeSeriesInput;
};


export type QueryManufacturerUserConnectionArgs = {
  input: ManufacturerUserConnectionInput;
};


export type QueryMembershipArgs = {
  id: Scalars['String']['input'];
};


export type QueryMeterConsumptionArgs = {
  input: MetricQueryInput;
};


export type QueryModelBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryModelsArgs = {
  input: InputMaybe<ModelInput>;
};


export type QueryOauthApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOauthApplicationsArgs = {
  input: OAuthApplicationsInput;
};


export type QueryOemDeviceForTelemetryArgs = {
  input: OemDeviceForTelemetryInput;
};


export type QueryOemDevicesArgs = {
  input: OemDevicesInput;
};


export type QueryOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationAccessRequestArgs = {
  token: Scalars['String']['input'];
};


export type QueryOrganizationInvitationsArgs = {
  input: OrganizationInvitationsInput;
};


export type QueryOrganizationMembersArgs = {
  input: OrganizationMembersInput;
};


export type QueryOrganizationWorkspacesArgs = {
  input: OrganizationWorkspacesInput;
};


export type QueryOrganizationsArgs = {
  input: OrganizationsInput;
};


export type QueryPlatformFieldsArgs = {
  entityType: InputMaybe<Scalars['String']['input']>;
};


export type QueryPollableConnectionsArgs = {
  input: PollableConnectionsInput;
};


export type QueryProgramArgs = {
  input: SlugOrIdInput;
};


export type QueryProgramBySlug_OldArgs = {
  slug: Scalars['String']['input'];
};


export type QueryProgramVariantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramVariantsArgs = {
  programId: Scalars['ID']['input'];
};


export type QueryProgram_OldArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramsArgs = {
  includeAll: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPrograms_OldArgs = {
  input: ProgramsForWorkspaceInput_Old;
};


export type QueryReportEnergyArgs = {
  input: ReportEnergyInput;
};


export type QueryReportEnergyFilterOptionsArgs = {
  input: ReportEnergyFilterOptionsInput;
};


export type QueryReportEnergyTagCategoriesArgs = {
  input: ReportEnergyTagCategoriesInput;
};


export type QueryReportEnergyTagOptionsArgs = {
  input: ReportEnergyTagOptionsInput;
};


export type QueryReportEventOptionsArgs = {
  input: ReportEventOptionsInput;
};


export type QueryScadaTopologyArgs = {
  elementGuid: InputMaybe<Scalars['String']['input']>;
  elementName: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchDevicesArgs = {
  input: SearchDevicesInput;
};


export type QuerySearchPlatformFieldsArgs = {
  query: Scalars['String']['input'];
};


export type QuerySiteArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySiteFilterArgs = {
  field: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerySiteGrowthStatsArgs = {
  input: GrowthStatsInput;
};


export type QuerySitesArgs = {
  input: SitesInput;
};


export type QuerySuperAdminGrantsArgs = {
  input: SuperAdminGrantsInput;
};


export type QueryTagScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type QueryTagSchedulesForTagArgs = {
  input: TagSchedulesForTagInput;
};


export type QueryTagsArgs = {
  filter: TagsFilter;
};


export type QueryTagsWithSiteCountsArgs = {
  filter: TagsFilter;
};


export type QueryTelemetryQueryArgs = {
  input: TelemetryQueryInput;
};


export type QueryTotalEnergyCapacityArgs = {
  input: MetricQueryInput;
};


export type QueryTotalEnergyConsumptionArgs = {
  input: MetricQueryInput;
};


export type QueryTotalEnergyGenerationArgs = {
  input: MetricQueryInput;
};


export type QueryTotalEnergyProductionArgs = {
  input: MetricQueryInput;
};


export type QueryTotalEnergyStorageArgs = {
  input: MetricQueryInput;
};


export type QueryTotalGridEnergyArgs = {
  input: MetricQueryInput;
};


export type QueryUsageForOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserProfileArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryValidateAddressesArgs = {
  addresses: Array<Address>;
};


export type QueryValidateManufacturerAssignmentsArgs = {
  manufacturerIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryValidateWorkflowArgs = {
  input: ValidateWorkflowInput;
};


export type QueryVirtualAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVirtualAccountsArgs = {
  workspaceId: Scalars['String']['input'];
};


export type QueryVirtualDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVirtualDevicesArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkflowExecutionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkflowsArgs = {
  input: WorkflowsInput;
};


export type QueryWorkspaceArgs = {
  id: Scalars['String']['input'];
};


export type QueryWorkspaceAlertConfigArgs = {
  workspaceId: Scalars['String']['input'];
};


export type QueryWorkspaceConnectConfigArgs = {
  input: WorkspaceConnectConfigInput;
};


export type QueryWorkspaceProgramArgs = {
  input: SlugOrIdInput;
};


export type QueryWorkspaceProgramEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkspaceProgramsArgs = {
  input: SlugOrIdInput;
};


export type QueryWorkspaceSystemConnectionArgs = {
  input: WorkspaceSystemConnectionInput;
};


export type QueryWorkspaceSystemConnectionsArgs = {
  input: WorkspaceSystemConnectionsInput;
};


export type QueryWorkspacesArgs = {
  orgId: InputMaybe<Scalars['String']['input']>;
};

/** A recent telemetry event from a device. */
export type RecentTelemetryEvent = {
  __typename?: 'RecentTelemetryEvent';
  /** Battery charge percentage (if battery device) */
  batteryChargePercentage: Maybe<Scalars['Float']['output']>;
  /** Charger power in watts (if charger device) */
  chargerPower: Maybe<Scalars['Float']['output']>;
  /** The device ID */
  deviceId: Scalars['ID']['output'];
  /** The device name (if set) */
  deviceName: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this telemetry record */
  id: Scalars['ID']['output'];
  /** Inverter power in watts (if inverter device) */
  inverterPower: Maybe<Scalars['Float']['output']>;
  /** The manufacturer's device ID */
  manufacturerDeviceId: Scalars['String']['output'];
  /** When the telemetry was received */
  timestamp: Scalars['DateTime']['output'];
};

/** Organization recipient details for sharing */
export type RecipientOrgDetails = {
  /** Email address to identify the organization */
  email: Scalars['String']['input'];
};

export type RefreshAuthenticationSessionInput = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterCDeviceError = BadUserInputError;

/** Required data for creating a new canonical device */
export type RegisterCDeviceInput = {
  /** Data provider slug that identifies the source system */
  dataProviderSlug?: InputMaybe<Scalars['String']['input']>;
  /** The manufacturer of the device */
  manufacturer: Scalars['String']['input'];
  /** The ID assigned to the device by the manufacturer */
  manufacturerDeviceId: Scalars['String']['input'];
  /** The model of the device */
  model: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** Raw model string from the original data source */
  rawModel?: InputMaybe<Scalars['String']['input']>;
  /** Raw type string from the original data source */
  rawType?: InputMaybe<Scalars['String']['input']>;
  /** The serial number of the device */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** The type of the device (e.g., sensor, actuator, etc.) */
  type: DeviceType;
};

export type RegisterCDeviceMutationResponse = IMutationResponse & {
  __typename?: 'RegisterCDeviceMutationResponse';
  cDevice: Maybe<CDevice>;
  errors: Maybe<Array<RegisterCDeviceError>>;
  success: Scalars['Boolean']['output'];
};

export type RemoveRequirementInput = {
  requirementId: Scalars['String']['input'];
  stageId: Scalars['ID']['input'];
};

export type RemoveTagFromEnrollmentsInput = {
  enrollmentIds: Array<Scalars['ID']['input']>;
  tag: Scalars['String']['input'];
  workspaceProgramId: Scalars['ID']['input'];
};

/** Input for removing a transition from a stage */
export type RemoveTransitionInput = {
  stageId: Scalars['ID']['input'];
  transitionId: Scalars['ID']['input'];
};

export type ReorderStagesInput = {
  lifecycleDefinitionId: Scalars['ID']['input'];
  stageIds: Array<Scalars['ID']['input']>;
};

/** Input for reordering transitions within a stage (priority order) */
export type ReorderTransitionsInput = {
  stageId: Scalars['ID']['input'];
  /** Ordered list of transition IDs - first = highest priority */
  transitionIds: Array<Scalars['ID']['input']>;
};

export type ReportBatchMetrics = {
  __typename?: 'ReportBatchMetrics';
  /** Commands failed */
  failed: Scalars['Int']['output'];
  /** Commands issued */
  issued: Scalars['Int']['output'];
  /** Commands pending */
  pending: Scalars['Int']['output'];
  /** Commands succeeded */
  succeeded: Scalars['Int']['output'];
};

export type ReportDateRangeInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type ReportDeviceDisplayType =
  | 'BATTERY'
  | 'EV'
  | 'INVERTER'
  | 'OTHER'
  | 'THERMOSTAT';

export type ReportDeviceFilterInput = {
  /** Filter to specific device IDs */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by device type */
  deviceTypes?: InputMaybe<Array<DeviceType>>;
  /** Filter by participation status */
  participationStatus?: InputMaybe<ParticipationStatusFilter>;
};

export type ReportEnergyFilterOptionsInput = {
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange: DateRangeInput;
  dimension: ReportFilterDimension;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  workspaceId: Scalars['ID']['input'];
};

export type ReportEnergyFilterOptionsResponse = {
  __typename?: 'ReportEnergyFilterOptionsResponse';
  hasMore: Scalars['Boolean']['output'];
  values: Array<Scalars['String']['output']>;
};

export type ReportEnergyInput = {
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange: DateRangeInput;
  granularity: TimeGranularity;
  groupBySerial?: InputMaybe<Scalars['Boolean']['input']>;
  includeValidationFlags?: InputMaybe<Scalars['Boolean']['input']>;
  includeWindowEnd?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measures?: InputMaybe<Array<ReportEnergyMeasure>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyValidData?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<OrderByInput>>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<TagFilterInput>>;
  validationFlags?: InputMaybe<ValidationFlagsFilter>;
  workspaceId: Scalars['ID']['input'];
};

export type ReportEnergyMeasure =
  | 'BATTERY_CHARGE_W'
  | 'BATTERY_CHARGE_WH'
  | 'BATTERY_DISCHARGE_W'
  | 'BATTERY_DISCHARGE_WH'
  | 'BATTERY_TO_GRID_W'
  | 'BATTERY_TO_GRID_WH'
  | 'BATTERY_TO_HOME_W'
  | 'BATTERY_TO_HOME_WH'
  | 'GRID_EXPORT_W'
  | 'GRID_EXPORT_WH'
  | 'GRID_IMPORT_W'
  | 'GRID_IMPORT_WH'
  | 'GRID_NET_W'
  | 'GRID_NET_WH'
  | 'GRID_TO_BATTERY_W'
  | 'GRID_TO_BATTERY_WH'
  | 'GRID_TO_HOME_W'
  | 'GRID_TO_HOME_WH'
  | 'PV_GENERATION_W'
  | 'PV_GENERATION_WH'
  | 'PV_TO_BATTERY_W'
  | 'PV_TO_BATTERY_WH'
  | 'PV_TO_GRID_W'
  | 'PV_TO_GRID_WH'
  | 'PV_TO_HOME_W'
  | 'PV_TO_HOME_WH'
  | 'RECORD_COUNT'
  | 'SOC_AVG_PERCENT'
  | 'SOC_MAX_PERCENT'
  | 'SOC_MIN_PERCENT'
  | 'TOTAL_CONSUMPTION_W'
  | 'TOTAL_CONSUMPTION_WH';

export type ReportEnergyMetadata = {
  __typename?: 'ReportEnergyMetadata';
  dateRange: DateRangeMeta;
  granularity: TimeGranularity;
  totalRecords: Scalars['Int']['output'];
};

export type ReportEnergyRecord = {
  __typename?: 'ReportEnergyRecord';
  batteryChargeW: Maybe<Scalars['Float']['output']>;
  batteryChargeWh: Maybe<Scalars['Float']['output']>;
  batteryDischargeW: Maybe<Scalars['Float']['output']>;
  batteryDischargeWh: Maybe<Scalars['Float']['output']>;
  batteryFlowReasonable: Maybe<Scalars['Boolean']['output']>;
  batteryToGridW: Maybe<Scalars['Float']['output']>;
  batteryToGridWh: Maybe<Scalars['Float']['output']>;
  batteryToHomeW: Maybe<Scalars['Float']['output']>;
  batteryToHomeWh: Maybe<Scalars['Float']['output']>;
  energyBalanceOk: Maybe<Scalars['Boolean']['output']>;
  exportHasSource: Maybe<Scalars['Boolean']['output']>;
  gridExportW: Maybe<Scalars['Float']['output']>;
  gridExportWh: Maybe<Scalars['Float']['output']>;
  gridImportW: Maybe<Scalars['Float']['output']>;
  gridImportWh: Maybe<Scalars['Float']['output']>;
  gridNetW: Maybe<Scalars['Float']['output']>;
  gridNetWh: Maybe<Scalars['Float']['output']>;
  gridToBatteryW: Maybe<Scalars['Float']['output']>;
  gridToBatteryWh: Maybe<Scalars['Float']['output']>;
  gridToHomeW: Maybe<Scalars['Float']['output']>;
  gridToHomeWh: Maybe<Scalars['Float']['output']>;
  importHasDest: Maybe<Scalars['Boolean']['output']>;
  isValidData: Scalars['Boolean']['output'];
  locCity: Maybe<Scalars['String']['output']>;
  locPostalCode: Maybe<Scalars['String']['output']>;
  locState: Maybe<Scalars['String']['output']>;
  nonNegativeValues: Maybe<Scalars['Boolean']['output']>;
  pvGenerationW: Maybe<Scalars['Float']['output']>;
  pvGenerationWh: Maybe<Scalars['Float']['output']>;
  pvToBatteryW: Maybe<Scalars['Float']['output']>;
  pvToBatteryWh: Maybe<Scalars['Float']['output']>;
  pvToGridW: Maybe<Scalars['Float']['output']>;
  pvToGridWh: Maybe<Scalars['Float']['output']>;
  pvToHomeW: Maybe<Scalars['Float']['output']>;
  pvToHomeWh: Maybe<Scalars['Float']['output']>;
  recordCount: Maybe<Scalars['Int']['output']>;
  serial: Maybe<Scalars['String']['output']>;
  socAvgPercent: Maybe<Scalars['Float']['output']>;
  socMaxPercent: Maybe<Scalars['Float']['output']>;
  socMinPercent: Maybe<Scalars['Float']['output']>;
  tags: Maybe<Array<ReportEnergyTag>>;
  totalConsumptionW: Maybe<Scalars['Float']['output']>;
  totalConsumptionWh: Maybe<Scalars['Float']['output']>;
  windowEnd: Maybe<Scalars['DateTime']['output']>;
  windowStart: Maybe<Scalars['DateTime']['output']>;
};

export type ReportEnergyResponse = {
  __typename?: 'ReportEnergyResponse';
  data: Array<ReportEnergyRecord>;
  metadata: ReportEnergyMetadata;
};

export type ReportEnergyTag = {
  __typename?: 'ReportEnergyTag';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ReportEnergyTagCategoriesInput = {
  workspaceId: Scalars['ID']['input'];
};

export type ReportEnergyTagCategoriesResponse = {
  __typename?: 'ReportEnergyTagCategoriesResponse';
  categories: Array<TagCategory>;
};

export type ReportEnergyTagOptionsInput = {
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  postalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  tagKey: Scalars['String']['input'];
  tags?: InputMaybe<Array<TagFilterInput>>;
  workspaceId: Scalars['ID']['input'];
};

export type ReportEventOption = {
  __typename?: 'ReportEventOption';
  endsAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
};

export type ReportEventOptionsInput = {
  /** Maximum number of events to return (default: 50) */
  maxEvents?: InputMaybe<Scalars['Int']['input']>;
  programScope: ProgramScopeInput;
  workspaceId: Scalars['ID']['input'];
};

export type ReportEventOptionsResponse = {
  __typename?: 'ReportEventOptionsResponse';
  events: Array<ReportEventOption>;
};

export type ReportFilterDimension =
  | 'CITY'
  | 'POSTAL_CODE'
  | 'SERIAL'
  | 'STATE';

export type ReportParticipationStatus =
  | 'DID_NOT_PARTICIPATE'
  | 'PARTICIPATED';

export type ReportPeriod =
  | 'LAST_7D'
  | 'LAST_24H'
  | 'LAST_30D'
  | 'LAST_60D'
  | 'LAST_90D';

export type ReportTimeRange = {
  __typename?: 'ReportTimeRange';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type RequestPasswordResetInput = {
  email: Scalars['String']['input'];
};

export type RequestUploadInput = {
  enrollmentId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  sizeBytes: Scalars['Int']['input'];
};

export type RequestUploadResult = {
  __typename?: 'RequestUploadResult';
  expiresAt: Scalars['DateTime']['output'];
  uploadId: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type RequeueAlertResult = {
  __typename?: 'RequeueAlertResult';
  alertId: Scalars['String']['output'];
  error: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RequeueAlertsInput = {
  alertIds: Array<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type RequeueAlertsResponse = {
  __typename?: 'RequeueAlertsResponse';
  failedCount: Scalars['Int']['output'];
  requeuedCount: Scalars['Int']['output'];
  results: Array<RequeueAlertResult>;
  success: Scalars['Boolean']['output'];
};

export type Requirement =
  | 'location'
  | 'manufacturer'
  | 'utilityZone';

/** An unsatisfied stage requirement blocking advancement. */
export type RequirementBlocker = {
  __typename?: 'RequirementBlocker';
  /** Input type hint for rendering (text, address, boolean, etc.) */
  fieldType: Scalars['String']['output'];
  /** The attribute key (e.g., 'full_name') */
  key: Scalars['String']['output'];
  /** Human-readable label */
  label: Scalars['String']['output'];
  /** Whether this requirement has been satisfied */
  satisfied: Scalars['Boolean']['output'];
  /** Where this attribute comes from */
  source: BlockerSource;
};

export type RequirementConfig = {
  _type: Scalars['String']['output'];
};

export type RequirementSelectOption = {
  __typename?: 'RequirementSelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Computed satisfaction status of a single stage requirement. */
export type RequirementStatus = {
  __typename?: 'RequirementStatus';
  /** True if the requirement has no condition, or its condition evaluates to true */
  applicable: Scalars['Boolean']['output'];
  requirement: StageRequirement;
  /** True if dataBag[requirement.factKey] is non-null and non-empty-string */
  satisfied: Scalars['Boolean']['output'];
  /** The current value from the data bag for this requirement */
  value: Maybe<Scalars['JSON']['output']>;
};

export type ResendInvitationInput = {
  invitationId: Scalars['String']['input'];
};

/** Input for resending MFA code */
export type ResendMfaCodeInput = {
  email: Scalars['String']['input'];
  mfaChallengeId: Scalars['String']['input'];
};

/** Response for resending MFA code */
export type ResendMfaCodeResponse = {
  __typename?: 'ResendMfaCodeResponse';
  cooldownRemainingSeconds: Maybe<Scalars['Int']['output']>;
  errorCode: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  newChallengeId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResendVerificationEmailInput = {
  email: Scalars['String']['input'];
};

/** Possible errors that can occur during password reset */
export type ResetPasswordError =
  | 'INVALID_TOKEN'
  | 'PASSWORD_UPDATE_FAILED'
  | 'TOKEN_ALREADY_USED'
  | 'TOKEN_EXPIRED';

export type ResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Response type for password reset */
export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  /** Error code if the operation failed */
  error: Maybe<ResetPasswordError>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type ResourceClaim = {
  __typename?: 'ResourceClaim';
  resourceId: Scalars['ID']['output'];
  resourceType: Scalars['String']['output'];
};

export type ResumeThermostatScheduleInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Result for a single grant event re-trigger */
export type RetriggerGrantEventResult = {
  __typename?: 'RetriggerGrantEventResult';
  /** Error message if failed */
  error: Maybe<Scalars['String']['output']>;
  /** The provider grant ID */
  providerGrantId: Scalars['String']['output'];
  /** Status: "emitted", "skipped" (deleted), or "error" */
  status: Scalars['String']['output'];
  /** Whether the event was successfully emitted */
  success: Scalars['Boolean']['output'];
};

/** Input for re-triggering grant events */
export type RetriggerGrantEventsInput = {
  /**
   * List of provider grant IDs to re-trigger events for.
   * Pass ["*"] to re-trigger for all non-deleted grants.
   */
  providerGrantIds: Array<Scalars['String']['input']>;
};

/** Response for re-triggering grant events */
export type RetriggerGrantEventsResponse = {
  __typename?: 'RetriggerGrantEventsResponse';
  /** Number of events successfully emitted */
  emittedCount: Scalars['Int']['output'];
  /** Number of errors */
  errorCount: Scalars['Int']['output'];
  /** Detailed results for each grant */
  results: Array<RetriggerGrantEventResult>;
  /** Number of grants skipped (deleted) */
  skippedCount: Scalars['Int']['output'];
  /** Whether the overall operation succeeded */
  success: Scalars['Boolean']['output'];
  /** Total number of grants processed */
  totalCount: Scalars['Int']['output'];
};

export type RetryCommandInput = {
  commandId: Scalars['ID']['input'];
};

export type RevokeInvitationInput = {
  id: Scalars['String']['input'];
};

/** Input for revoking super admin access */
export type RevokeSuperAdminInput = {
  /** Optional reason for revoking access */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user to revoke super admin access from */
  userId: Scalars['ID']['input'];
};

export type RevokeWorkspaceAccessGrantInput = {
  workspaceAccessGrantId: Scalars['ID']['input'];
};

export type Role =
  | 'ADMIN'
  | 'OPERATOR'
  | 'USER'
  | 'VIEWER';

export type RuleAttribute = {
  __typename?: 'RuleAttribute';
  config: Maybe<RuleAttributeConfig>;
  fieldType: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

export type RuleAttributeConfig = BooleanAttributeConfig | NumberAttributeConfig | SelectAttributeConfig;

export type SavantGrant = {
  __typename?: 'SavantGrant';
  credentialId: Maybe<Scalars['ID']['output']>;
  credentials: Maybe<ClientSecretCredentials>;
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Input for saving a workflow draft */
export type SaveWorkflowDraftInput = {
  /** JSON configuration conforming to workflow schema */
  config: Scalars['JSON']['input'];
  /** Description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the workflow */
  name: Scalars['String']['input'];
};

/**
 * A flat node in the SCADA grid topology. The tree structure is expressed via
 * parentId references. Clients build the tree locally — this avoids GraphQL
 * depth limits and supports arbitrary topology depth.
 */
export type ScadaGridNode = {
  __typename?: 'ScadaGridNode';
  gsGuid: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  nodeType: Scalars['String']['output'];
  parentId: Maybe<Scalars['BigInt']['output']>;
  telemetry: Array<ScadaTelemetryReading>;
};

/** A single telemetry reading for a SCADA grid node. */
export type ScadaTelemetryReading = {
  __typename?: 'ScadaTelemetryReading';
  metricName: Scalars['String']['output'];
  ts: Scalars['DateTime']['output'];
  unit: Scalars['String']['output'];
  value: Maybe<Scalars['Float']['output']>;
  valueText: Maybe<Scalars['String']['output']>;
};

/**
 * A flat node list representing a SCADA topology tree.
 * Clients build the tree from nodes using parentId references.
 * rootNodeId is the ID of the node to use as the diagram root — typically the
 * matched element itself (breaker, transformer, regulator) for focused views,
 * or the substation when the full topology is returned.
 */
export type ScadaTopologyResult = {
  __typename?: 'ScadaTopologyResult';
  allNormal: Scalars['Boolean']['output'];
  lastReadingAt: Maybe<Scalars['DateTime']['output']>;
  nodes: Array<ScadaGridNode>;
  rootNodeId: Scalars['BigInt']['output'];
  totalTelemetryPoints: Scalars['Int']['output'];
};

export type ScheduleSupportedDeviceType =
  | 'battery'
  | 'thermostat'
  | 'vehicle';

/**
 * Filter for searching devices via Elasticsearch. Supports all filter fields
 * including state, location, tags, and collection membership.
 */
export type SearchDevicesFilter = {
  collectionMembership?: InputMaybe<Array<Scalars['ID']['input']>>;
  connected?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Filter by device IDs (DeviceOnWorkspace IDs) */
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<DeviceLocationFilter>;
  manufacturer?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturerDeviceId?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturerUserId?: InputMaybe<Array<Scalars['String']['input']>>;
  model?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<DeviceStateFilter>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<DeviceType>>;
  workspaceId: Scalars['ID']['input'];
};

export type SearchDevicesInput = {
  filter: SearchDevicesFilter;
  orderBy?: InputMaybe<DeviceOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<DeviceSearchInput>;
};

export type SearchDevicesPaginatedQueryPayload = {
  __typename?: 'SearchDevicesPaginatedQueryPayload';
  data: Maybe<Array<Device>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type SelectAttributeConfig = {
  __typename?: 'SelectAttributeConfig';
  options: Array<SelectOption>;
};

export type SelectOption = {
  __typename?: 'SelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SelectRequirementConfig = RequirementConfig & {
  __typename?: 'SelectRequirementConfig';
  _type: Scalars['String']['output'];
  options: Maybe<Array<RequirementSelectOption>>;
  placeholder: Maybe<Scalars['String']['output']>;
};

export type SendBatchCommandInput = {
  battery?: InputMaybe<BatteryBatchCommandInput>;
  charger?: InputMaybe<ChargerBatchCommandInput>;
  thermostat?: InputMaybe<ThermostatBatchCommandInput>;
  vehicle?: InputMaybe<VehicleBatchCommandInput>;
};

export type SendCommandInput = {
  battery?: InputMaybe<BatteryCommandInput>;
  charger?: InputMaybe<ChargerCommandInput>;
  thermostat?: InputMaybe<ThermostatCommandInput>;
  vehicle?: InputMaybe<VehicleCommandInput>;
};

export type SendCommandResponse = {
  __typename?: 'SendCommandResponse';
  data: Maybe<Command>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SendWorkspaceInvitationInput = {
  recipientEmail: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

/** A user login session tracking authentication history */
export type Session = {
  __typename?: 'Session';
  /** How the user authenticated */
  authMethod: SessionAuthMethod;
  /** When this session record was created */
  createdAt: Scalars['DateTime']['output'];
  /** When the session expires (from JWT expiration) */
  expiresAt: Scalars['DateTime']['output'];
  /** Unique identifier for the session */
  id: Scalars['ID']['output'];
  /** IP address of the client (if available) */
  ipAddress: Maybe<Scalars['String']['output']>;
  /** The organization the user authenticated to */
  organization: Maybe<Organization>;
  /** The ID of the organization the user authenticated to */
  organizationId: Scalars['ID']['output'];
  /** When the session started (token was issued) */
  startedAt: Scalars['DateTime']['output'];
  /** User agent string of the client (if available) */
  userAgent: Maybe<Scalars['String']['output']>;
  /** The ID of the user this session belongs to */
  userId: Scalars['ID']['output'];
};

/** Authentication method used for a session */
export type SessionAuthMethod =
  | 'API_KEY'
  | 'EMAIL_PASSWORD'
  | 'MFA_VERIFICATION'
  | 'OAUTH'
  | 'REFRESH'
  | 'SUPER_ADMIN';

/** Paginated response for sessions */
export type SessionPaginatedQueryPayload = {
  __typename?: 'SessionPaginatedQueryPayload';
  data: Maybe<Array<Session>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

/** Input for querying user sessions */
export type SessionsInput = {
  pagination?: InputMaybe<ListPagination>;
};

export type SetBatteryOperatingModeInput = {
  dischargePowerPercent?: InputMaybe<Scalars['Float']['input']>;
  dischargePowerRate?: InputMaybe<Scalars['Float']['input']>;
  dischargeStrategy?: InputMaybe<Scalars['String']['input']>;
  enableGridInteraction?: InputMaybe<Scalars['Boolean']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  executionPriority?: InputMaybe<Array<Scalars['String']['input']>>;
  maximumBatteryReserve?: InputMaybe<Scalars['Float']['input']>;
  minimumBatteryReserve?: InputMaybe<Scalars['Float']['input']>;
  operatingMode: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetBatteryReserveInput = {
  chargePercentage: Scalars['Float']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetChargerOperatingModeInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  operatingMode: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetThermostatFanModeInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  fanMode: ThermostatFanMode;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetThermostatOperatingModeInput = {
  coolTarget?: InputMaybe<Scalars['Float']['input']>;
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  heatTarget?: InputMaybe<Scalars['Float']['input']>;
  operatingMode: ThermostatMode;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetVehicleChargeLimitInput = {
  chargeLimit: Scalars['Int']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  homeRadiusMeters?: InputMaybe<Scalars['Float']['input']>;
  requireHomeLocation?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetVehicleOperatingModeInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  homeRadiusMeters?: InputMaybe<Scalars['Float']['input']>;
  operatingMode: Scalars['String']['input'];
  requireHomeLocation?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetWebhookDestinationEnabledInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type SetWorkspaceConnectConfigInput = {
  config: WorkspaceConnectConfigData;
  profile?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type SetWorkspaceConnectConfigResponse = {
  __typename?: 'SetWorkspaceConnectConfigResponse';
  config: Maybe<WorkspaceConnectConfig>;
  error: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type Severities = {
  __typename?: 'Severities';
  critical: Scalars['Boolean']['output'];
  info: Scalars['Boolean']['output'];
  warning: Scalars['Boolean']['output'];
};

export type SeveritiesInput = {
  critical: Scalars['Boolean']['input'];
  info: Scalars['Boolean']['input'];
  warning: Scalars['Boolean']['input'];
};

export type Severity =
  | 'CRITICAL'
  | 'INFO'
  | 'WARNING';

export type ShareCollectionByEmailError = CollectionNotFoundError | ShareCollectionInvalidInputError | UnauthorizedError;

/** Input for sharing a collection with an invitee by email */
export type ShareCollectionByEmailInput = {
  /** The ID of the collection to share */
  collectionId: Scalars['ID']['input'];
  /** Email address of invitee */
  recipientEmail: Scalars['String']['input'];
};

export type ShareCollectionByEmailResponse = IMutationResponse & {
  __typename?: 'ShareCollectionByEmailResponse';
  /** The collection that was shared, if successful */
  collection: Maybe<CollectionV2>;
  /** Any errors that occurred during the operation */
  errors: Maybe<Array<ShareCollectionByEmailError>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Union of all possible share collection errors */
export type ShareCollectionError = AlreadyMemberError | CollectionNotFoundError | OrganizationNotFoundError | UnauthorizedError;

export type ShareCollectionInvalidInputError = IMutationError & {
  __typename?: 'ShareCollectionInvalidInputError';
  invalidFields: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Input for sharing a collection with an organization */
export type ShareCollectionWithOrgInput = {
  /** The ID of the collection to share */
  collectionId: Scalars['ID']['input'];
  /** Organization recipient information */
  recipientOrgDetails: RecipientOrgDetails;
};

/** Response type for sharing a collection with an organization */
export type ShareCollectionWithOrgResponse = IMutationResponse & {
  __typename?: 'ShareCollectionWithOrgResponse';
  /** The collection that was shared, if successful */
  collection: Maybe<Collection>;
  /** Any errors that occurred during the operation */
  errors: Maybe<Array<ShareCollectionError>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Represents a resource that has been shared with an organization through a workspace invitation */
export type SharedResource = {
  __typename?: 'SharedResource';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  resourceId: Scalars['String']['output'];
  resourceType: SharedResourceType;
  updatedAt: Scalars['DateTime']['output'];
};

/** Types of resources that can be shared */
export type SharedResourceType =
  | 'COLLECTION';

export type ShovelsGrant = {
  __typename?: 'ShovelsGrant';
  credentialId: Maybe<Scalars['ID']['output']>;
  credentials: Maybe<ApiKeyCredentials>;
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SignUpUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Site = {
  __typename?: 'Site';
  alerts: Maybe<Array<Alert>>;
  /** The bill meters associated with the site (sourced from utility bills). */
  billMeters: Array<BillMeter>;
  /** List of end users that own the site. */
  connectedCustomers: Array<Customer>;
  /** The time the site was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The devices associated with the site. */
  devices: Array<Device>;
  /** The energy modeling for the site */
  energyModeling: Maybe<EnergyModeling>;
  /** The aggregated energy usage data from a utility data provider for a given range. */
  energyUsage: Array<EnergyUsagePeriod>;
  enrollments: Maybe<EnrollmentPaginatedQueryPayload>;
  events: Array<Event>;
  gridHierarchy: Maybe<FullGridElementHierarchyForSite>;
  /** The unique Texture ID assigned to the site. */
  id: Scalars['ID']['output'];
  loadZone: Maybe<LoadZone>;
  /** The location of the site. */
  location: Location;
  /** The meter intervals from the utility data provider for a given range. */
  meterIntervals: Array<Maybe<MeterInterval>>;
  /**
   * Meter-type devices associated with this site.
   * Resolved from the Device Domain — ground-truth telemetry from MDM sources.
   */
  meters: Array<Device>;
  /** The name of the site. */
  name: Maybe<Scalars['String']['output']>;
  /** The customer that first connected the site. */
  owner: Maybe<Customer>;
  /** The permits of the site */
  permits: Maybe<Array<Permit>>;
  /** The provider of the site */
  provider: Maybe<Scalars['String']['output']>;
  /** A user-provided reference ID for the site. */
  referenceId: Maybe<Scalars['String']['output']>;
  /** The time the site was last updated. */
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  utilities: Array<Utility>;
  /** The weather at the site. */
  weather: Maybe<Weather>;
  wholesaleMarket: Maybe<WholesaleMarket>;
  /** The workspace this Site belongs to. */
  workspaceId: Scalars['ID']['output'];
};


export type SiteDevicesArgs = {
  input: InputMaybe<DevicesFilter>;
};


export type SiteEnergyUsageArgs = {
  input: EnergyUsageInput;
};


export type SiteEnrollmentsArgs = {
  input: InputMaybe<EnrollmentInput>;
};


export type SiteEventsArgs = {
  input: EventInput;
};


export type SiteMeterIntervalsArgs = {
  input: MeterIntervalInput;
};

/** Input type for creating a site */
export type SiteCreateInput = {
  /** City where the site is located */
  city: Scalars['String']['input'];
  /** Country where the site is located */
  country: Scalars['String']['input'];
  /** Latitude coordinate of the site location */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude coordinate of the site location */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** User provided name for the site */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Postal code where the site is located */
  postalCode: Scalars['String']['input'];
  /** Customer reference ID this site belongs to */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** State/province where the site is located */
  state: Scalars['String']['input'];
  /** Primary street address of the site */
  streetOne: Scalars['String']['input'];
  /** Secondary street address of the site (optional) */
  streetTwo?: InputMaybe<Scalars['String']['input']>;
  /** ID of the workspace this site belongs to */
  workspaceId: Scalars['String']['input'];
};

/** Response type for the createSite mutation */
export type SiteCreateMutationResponse = {
  __typename?: 'SiteCreateMutationResponse';
  /** Array of errors if the operation failed */
  errors: Maybe<Array<CreateSiteError>>;
  /** The created site if successful */
  site: Maybe<Site>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type SiteLocationFilter = {
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCode?: InputMaybe<Array<Scalars['String']['input']>>;
  state?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Built by @asPaginatedQuery directive??? */
export type SiteOrderByInput = {
  createdAt?: InputMaybe<PaginatedQueryOrderBy>;
};

/** Built by @asPaginatedQuery directive */
export type SitePaginatedQueryPayload = {
  __typename?: 'SitePaginatedQueryPayload';
  data: Maybe<Array<Site>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type SiteSearchInput = {
  address?: InputMaybe<FieldSearchInput>;
  name?: InputMaybe<FieldSearchInput>;
  referenceId?: InputMaybe<FieldSearchInput>;
  siteType?: InputMaybe<FieldSearchInput>;
};

/** Response type for the updateSite mutation */
export type SiteUpdateMutationResponse = {
  __typename?: 'SiteUpdateMutationResponse';
  /** Array of errors if the operation failed */
  errors: Maybe<Array<UpdateSiteError>>;
  /** The updated site if successful */
  site: Maybe<Site>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Response type for the upsertSite mutation */
export type SiteUpsertMutationResponse = {
  __typename?: 'SiteUpsertMutationResponse';
  /** Array of errors if the operation failed */
  errors: Maybe<Array<UpsertSiteError>>;
  /** The upserted site if successful */
  site: Maybe<Site>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Filter criteria for querying sites */
export type SitesFilter = {
  /** filter by site location attributes */
  location?: InputMaybe<SiteLocationFilter>;
  /** Array of site names to filter by */
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Array of customer reference IDs to filter by */
  referenceId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ID of the workspace to filter sites by */
  workspaceId: Scalars['ID']['input'];
};

/** Built by @asPaginatedQuery directive??? */
export type SitesInput = {
  filter: SitesFilter;
  orderBy?: InputMaybe<SiteOrderByInput>;
  pagination?: InputMaybe<ListPagination>;
  search?: InputMaybe<SiteSearchInput>;
};

export type SlugOrIdInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type SolarEdgeCredentials = {
  __typename?: 'SolarEdgeCredentials';
  allowGridExport: Maybe<Scalars['Boolean']['output']>;
  chargeStorageUsingPvOnly: Maybe<Scalars['Boolean']['output']>;
  inverterSerialNumbers: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  monitoringSiteIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  storageControlMode: Maybe<Scalars['String']['output']>;
  storageReserve: Maybe<Scalars['Float']['output']>;
};

export type SolarEdgeGrant = {
  __typename?: 'SolarEdgeGrant';
  credentialId: Maybe<Scalars['ID']['output']>;
  credentials: Maybe<SolarEdgeCredentials>;
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SortOrder =
  | 'ASC'
  | 'DESC';

/**
 * A single step in the lifecycle journey.
 * Stages can be terminal (end states) or non-terminal, and are connected via transitions.
 */
export type StageDefinition = {
  __typename?: 'StageDefinition';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isInitial: Scalars['Boolean']['output'];
  isTerminal: Scalars['Boolean']['output'];
  lifecycleDefinitionId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Maybe<Scalars['Int']['output']>;
  requirements: Array<StageRequirement>;
  slug: Scalars['String']['output'];
  transitions: Array<StageTransition>;
  updatedAt: Scalars['DateTime']['output'];
  /** UI presentation configuration for enrollment flow */
  userFacingConfig: Maybe<StageUserFacingConfig>;
  /** Validation warnings for transition rules on this stage (e.g., attribute/slug mismatches) */
  validationWarnings: Array<ValidationWarning>;
};

/** A requirement that must be satisfied at a particular lifecycle stage. */
export type StageRequirement = {
  __typename?: 'StageRequirement';
  condition: Maybe<Scalars['JSON']['output']>;
  config: Maybe<RequirementConfig>;
  description: Maybe<Scalars['String']['output']>;
  /** The canonical key used to look up this requirement's value in the data bag */
  factKey: Maybe<Scalars['String']['output']>;
  fieldType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  /** Whether this requirement maps to a PLATFORM registry field or a CUSTOM operator-defined field */
  source: Maybe<FieldSource>;
};

export type StageRequirementInput = {
  condition?: InputMaybe<Scalars['JSON']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The canonical data bag key for this requirement. Preferred over slug. */
  factKey?: InputMaybe<Scalars['String']['input']>;
  fieldType: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A transition defines a path from one stage to another, optionally guarded by a rule.
 * Transitions are evaluated in order; the first matching transition is used.
 * A transition with null rule acts as a default (always matches).
 */
export type StageTransition = {
  __typename?: 'StageTransition';
  id: Scalars['ID']['output'];
  lifecycleDefinitionId: Scalars['ID']['output'];
  /** Criteria rule that must match for this transition (null = default/always matches) */
  rule: Maybe<Scalars['JSON']['output']>;
  /** The target stage this transition leads to */
  targetStage: StageDefinition;
  targetStageSlug: Scalars['String']['output'];
};

export type StageTransitionInput = {
  id: Scalars['ID']['input'];
  rule?: InputMaybe<Scalars['JSON']['input']>;
  targetStageSlug: Scalars['String']['input'];
};

/**
 * UI presentation configuration for a lifecycle stage.
 * Controls how the stage renders to end users in the enrollment flow.
 */
export type StageUserFacingConfig = {
  __typename?: 'StageUserFacingConfig';
  /** How this stage renders to end users: 'form' (default), 'info_message', or 'hidden' */
  displayMode: Scalars['String']['output'];
  /** Optional icon key override (default derived from variant) */
  icon: Maybe<Scalars['String']['output']>;
  /** Rich text (HTML) message shown when displayMode is 'info_message' */
  message: Maybe<Scalars['String']['output']>;
  /** Text label for an optional redirect button shown on terminal states */
  redirectButtonText: Maybe<Scalars['String']['output']>;
  /** URL the redirect button navigates to on terminal states */
  redirectButtonUrl: Maybe<Scalars['String']['output']>;
  /** Semantic variant for visual treatment: 'pending', 'success', 'error', 'info' */
  variant: Maybe<Scalars['String']['output']>;
};

export type StageUserFacingConfigInput = {
  displayMode: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  redirectButtonText?: InputMaybe<Scalars['String']['input']>;
  redirectButtonUrl?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

export type Status =
  | 'ACKNOWLEDGED'
  | 'IGNORED'
  | 'OPEN'
  | 'RESOLVED';

export type SubmitEnrollmentCustomerInfoInput = {
  accountReference?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitEnrollmentIdentificationType =
  | 'CUSTOMER_ID'
  | 'CUSTOMER_INFO';

export type SubmitEnrollmentInput = {
  address: AddressInput;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerInfo?: InputMaybe<SubmitEnrollmentCustomerInfoInput>;
  facts: Scalars['JSON']['input'];
  identificationType: SubmitEnrollmentIdentificationType;
  workspaceProgramId: Scalars['ID']['input'];
};

export type SubmitEnrollmentPayload = {
  __typename?: 'SubmitEnrollmentPayload';
  customerId: Scalars['ID']['output'];
  enrollmentId: Scalars['ID']['output'];
  lifecycleInstanceId: Scalars['ID']['output'];
  siteId: Scalars['ID']['output'];
};

/** Represents a grant of super admin privileges to a user */
export type SuperAdminGrant = {
  __typename?: 'SuperAdminGrant';
  /** When the grant was created */
  createdAt: Scalars['DateTime']['output'];
  /** When the grant expires, null if indefinite */
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  /** The user who granted the super admin access */
  grantedBy: User;
  /** Unique identifier for the grant */
  id: Scalars['ID']['output'];
  /** Optional reason for why the grant was given */
  reason: Maybe<Scalars['String']['output']>;
  /** When the grant was revoked, null if still active */
  revokedAt: Maybe<Scalars['DateTime']['output']>;
  /** The user who revoked the grant, null if not revoked */
  revokedBy: Maybe<User>;
  /** Optional reason for why the grant was revoked */
  revokedReason: Maybe<Scalars['String']['output']>;
  /** When the grant was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who was granted super admin access */
  user: User;
};

/** Paginated response for super admin grants */
export type SuperAdminGrantPaginatedQueryPayload = {
  __typename?: 'SuperAdminGrantPaginatedQueryPayload';
  data: Maybe<Array<SuperAdminGrant>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

/** Filter options for super admin grants query */
export type SuperAdminGrantsFilter = {
  /** Include revoked grants in the results */
  includeRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter grants by user ID */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for querying super admin grants */
export type SuperAdminGrantsInput = {
  filter?: InputMaybe<SuperAdminGrantsFilter>;
  pagination?: InputMaybe<ListPagination>;
};

export type SupportLevel =
  | 'blocked'
  | 'development'
  | 'planned'
  | 'production'
  | 'uat';

export type SyncConnectionEstablishedEventsResponse = IMutationResponse & {
  __typename?: 'SyncConnectionEstablishedEventsResponse';
  errors: Maybe<Scalars['Int']['output']>;
  message: Maybe<Scalars['String']['output']>;
  processed: Maybe<Scalars['Int']['output']>;
  skipped: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TagCategory = {
  __typename?: 'TagCategory';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type TagFilterInput = {
  key: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type TagRule = {
  __typename?: 'TagRule';
  createdAt: Scalars['DateTime']['output'];
  daysOfWeek: Array<Scalars['Int']['output']>;
  deviceOperatingMode: Scalars['JSON']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  startTime: Scalars['String']['output'];
  tagScheduleId: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type TagSchedule = {
  __typename?: 'TagSchedule';
  batches: Array<Batch>;
  createdAt: Scalars['DateTime']['output'];
  defaultDeviceOperatingMode: Scalars['JSON']['output'];
  deviceType: ScheduleSupportedDeviceType;
  endsAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  rules: Array<TagRule>;
  startsAt: Scalars['DateTime']['output'];
  tag: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type TagScheduleFilterInput = {
  tag: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type TagScheduleInput = {
  defaultDeviceOperatingMode: Scalars['JSON']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  timezone: Scalars['String']['input'];
};

export type TagSchedulesForTagInput = {
  filter: TagScheduleFilterInput;
};

export type TagSchedulesForTagQueryPayload = {
  __typename?: 'TagSchedulesForTagQueryPayload';
  data: Array<TagSchedule>;
  meta: Maybe<ListPayloadMeta>;
};

/** A tag with the count of unique sites that have devices with this tag */
export type TagWithSiteCount = {
  __typename?: 'TagWithSiteCount';
  /** The unique identifier of the tag */
  id: Scalars['ID']['output'];
  /** The name of the tag */
  name: Scalars['String']['output'];
  /** The number of unique sites that have devices with this tag */
  siteCount: Scalars['Int']['output'];
};

export type TagsFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type TelemetryBucketResult = {
  __typename?: 'TelemetryBucketResult';
  bucket: Scalars['DateTime']['output'];
  groupKey: Scalars['String']['output'];
  groupLabel: Maybe<Scalars['String']['output']>;
  values: Scalars['JSON']['output'];
};

export type TelemetryBucketSize =
  | 'DAY'
  | 'FIFTEEN_MINUTES'
  | 'FIVE_MINUTES'
  | 'HOUR';

/**
 * Which statistic to read from each time bucket.
 * Controls what value is extracted from the pre-aggregated CAGG data for each
 * metric within a single bucket period.
 * Example: AVG returns the average real_power over a 15-minute bucket;
 * MAX returns the peak value within that bucket.
 */
export type TelemetryBucketStat =
  | 'AVG'
  | 'COUNT'
  | 'MAX'
  | 'MIN'
  | 'SUM';

export type TelemetryMetricValue = {
  __typename?: 'TelemetryMetricValue';
  metric: Scalars['String']['output'];
  value: Maybe<Scalars['Float']['output']>;
};

export type TelemetryQueryInput = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
  bucketSize: TelemetryBucketSize;
  /** Which statistic to read from each time bucket (default: AVG) */
  bucketStat?: InputMaybe<TelemetryBucketStat>;
  /** txQL expressions for derived metrics (evaluated per-bucket) */
  expressions?: InputMaybe<Array<TxQlExpressionInput>>;
  /** Canonical metric names from the Metric table */
  metrics: Array<Scalars['String']['input']>;
  /** Client-supplied constants available as params.* in txQL expressions */
  params?: InputMaybe<Scalars['JSON']['input']>;
  rollup?: InputMaybe<TelemetryRollupInput>;
  sourceScope: TelemetrySourceScopeInput;
};

export type TelemetryQueryMeta = {
  __typename?: 'TelemetryQueryMeta';
  bucketCount: Scalars['Int']['output'];
  bucketSize: Scalars['String']['output'];
  expressionNames: Array<Scalars['String']['output']>;
  metrics: Array<Scalars['String']['output']>;
  sourceCount: Scalars['Int']['output'];
};

export type TelemetryQueryResult = {
  __typename?: 'TelemetryQueryResult';
  buckets: Array<TelemetryBucketResult>;
  meta: TelemetryQueryMeta;
  /** Reduction results from aggregation txQL expressions (pct_where, count_where, etc.) */
  reductions: Scalars['JSON']['output'];
};

export type TelemetryRollupInput = {
  depth?: InputMaybe<Scalars['Int']['input']>;
  /** Which hierarchy level to group results at */
  groupBy: HierarchyGroupBy;
  /** How to combine child values (SUM for power, AVG for voltage, MAX for worst-case) */
  reducer: HierarchyReducer;
};

export type TelemetrySourceScopeInput = {
  /** Device IDs for DER device queries. Requires workspaceId. */
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** ScadaGridNode gsGuids for specific node queries */
  gsGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Root gsGuid for subtree queries (fetches all descendants) */
  subtreeRootGsGuid?: InputMaybe<Scalars['String']['input']>;
  /** Workspace ID — required when querying by deviceIds */
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** A single data point in the telemetry time series. */
export type TelemetryTimeSeriesDataPoint = {
  __typename?: 'TelemetryTimeSeriesDataPoint';
  /** Number of telemetry updates on this day */
  count: Scalars['Int']['output'];
  /** The date (start of day) */
  date: Scalars['DateTime']['output'];
};

export type TerminateConnectionInput = {
  /** ID of the ManufacturerUserConnection to terminate. */
  manufacturerUserConnectionId: Scalars['ID']['input'];
  /** Optional reason for termination. Defaults to 'Manually terminated'. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type TerminateConnectionResponse = {
  __typename?: 'TerminateConnectionResponse';
  error: Maybe<Error>;
  success: Scalars['Boolean']['output'];
  /** Number of connections terminated. 0 means the connection(s) were already expired. */
  terminatedCount: Maybe<Scalars['Int']['output']>;
};

/** Terminate a connection for a manufacturer account identified by manufacturer + manufacturerUserId + clientId. */
export type TerminateManufacturerConnectionsInput = {
  /** The OAuth app clientId that owns the connection. */
  clientId: Scalars['String']['input'];
  manufacturer: Scalars['String']['input'];
  manufacturerUserId: Scalars['String']['input'];
  /** Optional reason for termination. Defaults to 'Manually terminated'. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Terms-and-conditions acceptance requirement. When present on a stage, the
 * enrollment form renders a required checkbox whose label links to the program's
 * T&C URL (read from WorkspaceProgram.customFields.termsAndConditions.href on
 * the client). Submitting writes three facts: `terms_accepted` (boolean, the
 * satisfaction fact the evaluator checks) plus `terms_accepted_at` (timestamp)
 * and `terms_accepted_url` (URL snapshot) as audit metadata.
 */
export type TermsAcceptanceRequirementConfig = RequirementConfig & {
  __typename?: 'TermsAcceptanceRequirementConfig';
  _type: Scalars['String']['output'];
};

export type TextRequirementConfig = RequirementConfig & {
  __typename?: 'TextRequirementConfig';
  _type: Scalars['String']['output'];
  placeholder: Maybe<Scalars['String']['output']>;
};

export type ThermostatBatchCommandInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pauseSchedule?: InputMaybe<PauseThermostatScheduleInput>;
  resumeSchedule?: InputMaybe<ResumeThermostatScheduleInput>;
  setFanMode?: InputMaybe<SetThermostatFanModeInput>;
  setOperatingMode?: InputMaybe<SetThermostatOperatingModeInput>;
  slug: ThermostatCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type ThermostatCommandInput = {
  id: Scalars['ID']['input'];
  pauseSchedule?: InputMaybe<PauseThermostatScheduleInput>;
  resumeSchedule?: InputMaybe<ResumeThermostatScheduleInput>;
  setFanMode?: InputMaybe<SetThermostatFanModeInput>;
  setOperatingMode?: InputMaybe<SetThermostatOperatingModeInput>;
  slug: ThermostatCommandSlug;
};

export type ThermostatCommandSlug =
  | 'thermostat_pause_schedule'
  | 'thermostat_resume_schedule'
  | 'thermostat_set_fan_mode'
  | 'thermostat_set_operating_mode';

export type ThermostatFanMode =
  | 'auto'
  | 'circulate'
  | 'off'
  | 'on'
  | 'unknown';

export type ThermostatMode =
  | 'auto'
  | 'cool'
  | 'eco'
  | 'heat'
  | 'off'
  | 'unknown';

export type ThermostatState = {
  __typename?: 'ThermostatState';
  ambientTemperature: Scalars['Int']['output'];
  coolTarget: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fanMode: ThermostatFanMode;
  heatTarget: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  operatingMode: ThermostatMode;
};

/** Thermostat state input. Matches ThermostatState DB schema. */
export type ThermostatStateInput = {
  ambientTemperature: Scalars['Int']['input'];
  coolTarget: Scalars['Int']['input'];
  createdAt: Scalars['DateTime']['input'];
  fanMode: ThermostatFanMode;
  heatTarget: Scalars['Int']['input'];
  operatingMode: ThermostatMode;
};

export type ThermostatStaticState = {
  __typename?: 'ThermostatStaticState';
  /** Supported fan modes */
  allowedFanModes: Array<ThermostatFanMode>;
  /** Operating modes supported by this thermostat */
  allowedModes: Array<ThermostatMode>;
  /** Extended capabilities for additional features (scheduling, deadband, mode-specific constraints, etc.) */
  extendedCapabilities: Maybe<Scalars['JSON']['output']>;
  /** Maximum cool setpoint temperature in Fahrenheit */
  maxCoolSetpoint: Maybe<Scalars['Int']['output']>;
  /** Maximum heat setpoint temperature in Fahrenheit */
  maxHeatSetpoint: Maybe<Scalars['Int']['output']>;
  /** Minimum cool setpoint temperature in Fahrenheit */
  minCoolSetpoint: Maybe<Scalars['Int']['output']>;
  /** Minimum heat setpoint temperature in Fahrenheit */
  minHeatSetpoint: Maybe<Scalars['Int']['output']>;
};

export type TimeGranularity =
  | 'DAY'
  | 'FIFTEEN_MINUTES'
  | 'HOUR'
  | 'MONTH'
  | 'TOTAL'
  | 'WEEK';

export type TimeScopeInput = {
  /** Required when type is DATE_RANGE */
  dateRange?: InputMaybe<ReportDateRangeInput>;
  /** Required when type is PERIOD */
  period?: InputMaybe<ReportPeriod>;
  /**
   * PERIOD: Relative time period (LAST_24H, LAST_7D, LAST_30D, LAST_60D, LAST_90D)
   * DATE_RANGE: Explicit start/end dates
   * EVENT_WINDOW: Use event's own time bounds (only valid for SINGLE_EVENT scope)
   */
  type: TimeScopeType;
};

export type TimeScopeType =
  | 'DATE_RANGE'
  | 'EVENT_WINDOW'
  | 'PERIOD';

/** Error returned when the verification token has expired */
export type TokenExpiredError = IMutationError & {
  __typename?: 'TokenExpiredError';
  message: Scalars['String']['output'];
};

/** Error returned when the verification token is not found */
export type TokenNotFoundError = IMutationError & {
  __typename?: 'TokenNotFoundError';
  message: Scalars['String']['output'];
};

/** An unsatisfied rule condition on a specific transition. */
export type TransitionBlocker = {
  __typename?: 'TransitionBlocker';
  /** The current value in the data bag */
  actual: Maybe<Scalars['JSON']['output']>;
  /** The attribute key being evaluated */
  attribute: Scalars['String']['output'];
  /** The value the rule expects */
  expected: Maybe<Scalars['JSON']['output']>;
  /** Input type hint */
  fieldType: Scalars['String']['output'];
  /** Comparison operator (EQUALS, GREATER_THAN, etc.) */
  operator: Scalars['String']['output'];
  /** Whether this individual rule passed */
  satisfied: Scalars['Boolean']['output'];
  /** Where this attribute comes from */
  source: BlockerSource;
};

/** Computed readiness status of a single stage transition. */
export type TransitionStatus = {
  __typename?: 'TransitionStatus';
  /** True if the transition rule is null (default) or evaluates to true */
  ready: Scalars['Boolean']['output'];
  transition: StageTransition;
};

export type TransitionToStageInput = {
  instanceId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['ID']['input'];
};

/**
 * Input for triggering a connection poll event.
 * Provide either manufacturerUserConnectionId OR manufacturerCredentialId (not both).
 */
export type TriggerConnectionPollInput = {
  /**
   * When using manufacturerCredentialId with multiple connections,
   * set this to true to allow triggering polls for all of them.
   * Defaults to false for safety.
   */
  allowMultiple?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * ID of a ManufacturerCredential to poll all connections for.
   * If the credential has multiple connections, allowMultiple must be true.
   */
  manufacturerCredentialId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * ID of a specific ManufacturerUserConnection to poll.
   * This will trigger exactly one poll for this connection.
   */
  manufacturerUserConnectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type TriggerConnectionPollResponse = {
  __typename?: 'TriggerConnectionPollResponse';
  error: Maybe<Error>;
  /** Number of poll events triggered (useful when allowMultiple is true) */
  pollsTriggered: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 * A txQL (Texture Query Language) expression for computing derived metrics.
 * Expressions are evaluated per-bucket using a safe, sandboxed SQL-subset
 * expression engine. See txQL documentation for available functions and syntax.
 */
export type TxQlExpressionInput = {
  /** txQL expression string */
  expr: Scalars['String']['input'];
  /** Output field name for this expression */
  name: Scalars['String']['input'];
};

/** Error returned when user is not authorized to perform the operation */
export type UnauthorizedError = IMutationError & {
  __typename?: 'UnauthorizedError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type UnifiedCommandInput = {
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  payload: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateApiKeyInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type UpdateAppProviderGrantPollingCronPatternInput = {
  grantId: Scalars['ID']['input'];
  /** Standard cron expression for BullMQ repeat (e.g. "0 7 * * *"). Null clears override. */
  pollingCronPattern?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppProviderGrantPollingCronPatternResponse = {
  __typename?: 'UpdateAppProviderGrantPollingCronPatternResponse';
  grant: Maybe<Grant>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateBatchInput = {
  batchId: Scalars['ID']['input'];
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
  payload: Scalars['JSON']['input'];
  slug: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateBatteryBatchInput = {
  batchId: Scalars['ID']['input'];
  setBatteryReserve?: InputMaybe<SetBatteryReserveInput>;
  setOperatingMode?: InputMaybe<SetBatteryOperatingModeInput>;
  slug: BatteryCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateChargerBatchInput = {
  batchId: Scalars['ID']['input'];
  setOperatingMode?: InputMaybe<SetChargerOperatingModeInput>;
  slug: ChargerCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateCollectionData = {
  /** New criteria for the collection */
  criteria?: InputMaybe<CollectionCriteriaInput>;
  /** New description for the collection */
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  /** Whether the collection is dynamic */
  dynamic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the collection is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** New name for the collection */
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  /** New visibility level */
  visibility?: InputMaybe<VisibilityLevel>;
};

export type UpdateCollectionDataV2 = {
  /** New criteria for the collection */
  criteria?: InputMaybe<CollectionCriteriaInputV2>;
  /** New description for the collection */
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  /** Whether the collection is dynamic */
  dynamic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the collection is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** New name for the collection */
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  /** New visibility level */
  visibility?: InputMaybe<VisibilityLevel>;
};

/** Input for updating an existing collection */
export type UpdateCollectionInput = {
  /** The data to update the collection with */
  data: UpdateCollectionData;
  /** The ID of the collection to update */
  id: Scalars['ID']['input'];
};

/** Input for updating an existing collection */
export type UpdateCollectionInputV2 = {
  /** The data to update the collection with */
  data: UpdateCollectionDataV2;
  /** The ID of the collection to update */
  id: Scalars['ID']['input'];
};

export type UpdateCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeviceInput = {
  id: Scalars['ID']['input'];
  siteProfileId?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDeviceManufacturerInput = {
  /** Whether this manufacturer is available in Texture Connect */
  availableInTextureConnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name of the manufacturer */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Support level for this manufacturer */
  supportLevel?: InputMaybe<SupportLevel>;
  /** Whether this manufacturer supports grid services */
  supportsGridServices?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDeviceModelInput = {
  /** Display name of the device model */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Support level for this device model */
  supportLevel?: InputMaybe<SupportLevel>;
  /** Type of device */
  type?: InputMaybe<DeviceType>;
};

export type UpdateDeviceScheduleInput = {
  rules: Array<UpdateRuleInput>;
  schedule: UpdateScheduleInput;
};

export type UpdateEmailDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventTypes?: InputMaybe<Array<EventType>>;
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEnrollmentInput = {
  address?: InputMaybe<Scalars['JSON']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  eligibilityReason?: InputMaybe<Scalars['String']['input']>;
  eligibilityStatus?: InputMaybe<EligibilityStatus>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrollmentId?: InputMaybe<Scalars['ID']['input']>;
  enrollmentStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  leadId?: InputMaybe<Scalars['ID']['input']>;
  manufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referenceDescription?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateEnrollmentReportConfigInput = {
  manufacturerSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceProgramId: Scalars['ID']['input'];
};

export type UpdateEnrollmentUploadStatusInput = {
  enrollmentUploadId: Scalars['ID']['input'];
  rejectedReason?: InputMaybe<Scalars['String']['input']>;
  status: EnrollmentDocumentStatus;
};

export type UpdateKafkaDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  eventTypes?: InputMaybe<Array<EventType>>;
  id: Scalars['String']['input'];
  kafkaConfig?: InputMaybe<Scalars['JSON']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLeadInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<LeadSource>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeadStatus>;
};

export type UpdateLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  streetOne?: InputMaybe<Scalars['String']['input']>;
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManufacturerCredentialInput = {
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<ManufacturerCredentialParamsInput>;
  status?: InputMaybe<ManufacturerCredentialStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateManufacturerCredentialResponse = {
  __typename?: 'UpdateManufacturerCredentialResponse';
  credential: Maybe<ManufacturerCredential>;
  error: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

/** Input for updating a manufacturer device model */
export type UpdateManufacturerDeviceModelInput = {
  /** Display name of the device model */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Support level for this device model */
  supportLevel?: InputMaybe<SupportLevel>;
};

export type UpdateManufacturerIntegrationInput = {
  /** Configuration fields as JSON */
  configurationFields?: InputMaybe<Scalars['JSON']['input']>;
  /** Rich text description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Documentation blocks as JSON */
  documentationBlocks?: InputMaybe<Scalars['JSON']['input']>;
  /** Learn more URL for documentation */
  learnMoreUrl?: InputMaybe<Scalars['String']['input']>;
  /** Display name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Support level for this integration */
  supportLevel?: InputMaybe<SupportLevel>;
};

export type UpdateMembershipInput = {
  id: Scalars['String']['input'];
  role?: InputMaybe<Role>;
};

export type UpdateOAuthApplicationInput = {
  allowedScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  redirectUris?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateOrganizationInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mfaEmailOtpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredTemperatureUnit?: InputMaybe<PreferredTemperatureUnit>;
};

export type UpdateProgramInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibilityCriteria?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  programTerms?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProgramInput_Old = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibilityCriteria?: InputMaybe<Scalars['String']['input']>;
  programTerms?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgramVariantInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programTerms?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRequirementInput = {
  condition?: InputMaybe<Scalars['JSON']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: kept for backward compatibility, ignored by resolver */
  fieldType?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: kept for backward compatibility, ignored by resolver */
  name?: InputMaybe<Scalars['String']['input']>;
  requirementId: Scalars['String']['input'];
  /** Deprecated: kept for backward compatibility, ignored by resolver */
  slug?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['ID']['input'];
};

export type UpdateRuleInput = {
  daysOfWeek: Array<Scalars['Int']['input']>;
  deviceOperatingMode: Scalars['JSON']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type UpdateScheduleInput = {
  cleanupDeviceOperatingMode?: InputMaybe<Scalars['JSON']['input']>;
  defaultDeviceOperatingMode: Scalars['JSON']['input'];
  deviceTimezone?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Error type for site update operations */
export type UpdateSiteError = {
  __typename?: 'UpdateSiteError';
  /** Machine readable error code */
  errorCode: Maybe<UpdateSiteErrorCode>;
  /** Human readable error message */
  message: Scalars['String']['output'];
};

/** Possible error codes that can occur during site update */
export type UpdateSiteErrorCode =
  /** Error occurred in the location service */
  | 'LOCATION_SERVICE_ERROR'
  /** Site not found */
  | 'SITE_NOT_FOUND'
  /** Error occurred in the site repository */
  | 'SITE_REPOSITORY_ERROR';

/** Input type for updating a site */
export type UpdateSiteInput = {
  /** City where the site is located */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country where the site is located */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the workspace site to update */
  id: Scalars['ID']['input'];
  /** Latitude coordinate of the site location */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude coordinate of the site location */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** User provided name for the site */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Postal code where the site is located */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Customer reference ID this site belongs to */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** State/province where the site is located */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Primary street address of the site */
  streetOne?: InputMaybe<Scalars['String']['input']>;
  /** Secondary street address of the site (optional) */
  streetTwo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSmsDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  eventTypes?: InputMaybe<Array<EventType>>;
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<Array<StageRequirementInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['ID']['input'];
  transitions?: InputMaybe<Array<StageTransitionInput>>;
  userFacingConfig?: InputMaybe<StageUserFacingConfigInput>;
};

export type UpdateThermostatBatchInput = {
  batchId: Scalars['ID']['input'];
  pauseSchedule?: InputMaybe<PauseThermostatScheduleInput>;
  resumeSchedule?: InputMaybe<ResumeThermostatScheduleInput>;
  setFanMode?: InputMaybe<SetThermostatFanModeInput>;
  setOperatingMode?: InputMaybe<SetThermostatOperatingModeInput>;
  slug: ThermostatCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/** Input for updating an existing transition */
export type UpdateTransitionInput = {
  rule?: InputMaybe<Scalars['JSON']['input']>;
  stageId: Scalars['ID']['input'];
  targetStageSlug?: InputMaybe<Scalars['String']['input']>;
  transitionId: Scalars['ID']['input'];
};

export type UpdateUserEmailInput = {
  newEmail: Scalars['String']['input'];
  oldEmail: Scalars['String']['input'];
};

export type UpdateUserInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserProfileInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingRole?: InputMaybe<Scalars['String']['input']>;
  preferredTemperatureUnit?: InputMaybe<PreferredTemperatureUnit>;
  preferredTimeZone?: InputMaybe<Scalars['String']['input']>;
  profilePhoto?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating user settings */
export type UpdateUserSettingsInput = {
  /** The settings JSON blob to store */
  settings: Scalars['JSON']['input'];
};

export type UpdateVehicleBatchInput = {
  batchId: Scalars['ID']['input'];
  setChargeLimit?: InputMaybe<SetVehicleChargeLimitInput>;
  setOperatingMode?: InputMaybe<SetVehicleOperatingModeInput>;
  slug: VehicleCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateWebhookDestinationInput = {
  deviceType?: InputMaybe<DeviceTypeScope>;
  eventTypes?: InputMaybe<Array<EventType>>;
  headers?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  includeWeather?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an existing workflow */
export type UpdateWorkflowInput = {
  /** JSON configuration conforming to workflow schema */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** Description of the workflow */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the workflow is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the workflow */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkspaceInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkspaceProgramEventInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
  workspaceProgramId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkspaceProgramInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eligibilityCriteria?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  programTerms?: InputMaybe<Scalars['String']['input']>;
  programVariantId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertDeviceError = CDeviceError & {
  __typename?: 'UpsertDeviceError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Input for upserting a device (create or find canonical device, then add to workspace) */
export type UpsertDeviceInput = {
  /** Whether the device is connected (defaults to false) */
  connected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional connection ID that created this device-workspace association */
  connectionId?: InputMaybe<Scalars['String']['input']>;
  /** Data provider slug that identifies the source system */
  dataProviderSlug?: InputMaybe<Scalars['String']['input']>;
  /** The manufacturer slug (e.g., 'solaredge', 'tesla') */
  manufacturer: Scalars['String']['input'];
  /** The manufacturer's unique device ID */
  manufacturerDeviceId: Scalars['String']['input'];
  /** The site ID in the manufacturer's system (e.g., AlsoEnergy siteId) */
  manufacturerSiteId?: InputMaybe<Scalars['String']['input']>;
  /** The user ID in the manufacturer's system (e.g., account email or ID) */
  manufacturerUserId?: InputMaybe<Scalars['String']['input']>;
  /** The device model string */
  model: Scalars['String']['input'];
  /** Optional display name for the device */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Raw model string from the original data source */
  rawModel?: InputMaybe<Scalars['String']['input']>;
  /** Raw type string from the original data source */
  rawType?: InputMaybe<Scalars['String']['input']>;
  /** External reference ID for the device in this workspace (required) */
  referenceId: Scalars['String']['input'];
  /** The serial number of the device */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  /** Optional site profile ID to associate the device with */
  siteProfileId?: InputMaybe<Scalars['ID']['input']>;
  /** Static state configuration for the device (capacity, power ratings, etc.) */
  staticState?: InputMaybe<DeviceStaticStateInput>;
  /** Optional tags to apply to the device */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The device type */
  type: DeviceType;
  /** The workspace to add the device to */
  workspaceId: Scalars['ID']['input'];
};

export type UpsertDeviceMutationResponse = IMutationResponse & {
  __typename?: 'UpsertDeviceMutationResponse';
  device: Maybe<Device>;
  errors: Maybe<Array<UpsertDeviceError>>;
  success: Scalars['Boolean']['output'];
};

export type UpsertFieldConfigurationInput = {
  configSchema?: InputMaybe<Scalars['JSON']['input']>;
  contexts?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityType: Scalars['String']['input'];
  factKey: Scalars['String']['input'];
};

/** Error type for site upsert operations */
export type UpsertSiteError = {
  __typename?: 'UpsertSiteError';
  /** Machine readable error code */
  errorCode: Maybe<UpsertSiteErrorCode>;
  /** Human readable error message */
  message: Scalars['String']['output'];
};

/** Possible error codes that can occur during site upsert */
export type UpsertSiteErrorCode =
  /** Error occurred in the location service */
  | 'LOCATION_SERVICE_ERROR'
  /** Error occurred in the site repository */
  | 'SITE_REPOSITORY_ERROR';

/** Input type for upserting a site */
export type UpsertSiteInput = {
  /** City where the site is located */
  city: Scalars['String']['input'];
  /** Country where the site is located */
  country: Scalars['String']['input'];
  /** User provided name for the site */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Postal code where the site is located */
  postalCode: Scalars['String']['input'];
  /** Utility provider for the site */
  provider?: InputMaybe<Scalars['String']['input']>;
  /** Reference ID for the site (user-provided identifier) */
  referenceId?: InputMaybe<Scalars['String']['input']>;
  /** State/province where the site is located */
  state: Scalars['String']['input'];
  /** Primary street address of the site */
  streetOne: Scalars['String']['input'];
  /** Secondary street address of the site (optional) */
  streetTwo?: InputMaybe<Scalars['String']['input']>;
  /** ID of the workspace this site belongs to */
  workspaceId: Scalars['String']['input'];
};

export type Usage = {
  __typename?: 'Usage';
  date: Scalars['DateTime']['output'];
  deviceCount: Scalars['Int']['output'];
  energyUsage: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  workspaceId: Scalars['ID']['output'];
};

/** Usage statistics over different time periods */
export type UsageOverTime = {
  __typename?: 'UsageOverTime';
  /** Usage in the last 7 days */
  last7Days: UsagePeriod;
  /** Usage in the last 24 hours */
  last24Hours: UsagePeriod;
  /** Usage in the last 30 days */
  last30Days: UsagePeriod;
  /** Usage in the last hour */
  lastHour: UsagePeriod;
};

/** Usage data for a specific time period */
export type UsagePeriod = {
  __typename?: 'UsagePeriod';
  /** Average latency in milliseconds */
  averageLatencyMs: Scalars['Float']['output'];
  /** Number of API calls in this period */
  calls: Scalars['Int']['output'];
  /** Data transferred in bytes */
  dataTransferred: Scalars['Long']['output'];
  /** Success rate as percentage (0-100) */
  successRate: Scalars['Float']['output'];
  /** Most used endpoints */
  topEndpoints: Array<EndpointUsage>;
};

/** External User type from identity domain */
export type User = UserFields & {
  __typename?: 'User';
  /** Whether the user's email addresses are verified. */
  areEmailsVerified: Scalars['Boolean']['output'];
  /** User's logs from Texture's auth provider */
  authProviderLogs: AuthProviderLogPaginatedQueryPayload;
  /** The timestamp the user was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user's email addresses. */
  emails: Maybe<Array<Maybe<Email>>>;
  /** The unique identifier for the user issued by the external identity provider. */
  externalUserId: Scalars['String']['output'];
  /** @deprecated This field is accessed on the UserProfile type */
  firstName: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is accessed on the UserProfile type */
  fullName: Maybe<Scalars['String']['output']>;
  /**
   * The unique identifier for the user issued by Texture. This is the primary key for the user record.
   * It is a [CUID](https://github.com/paralleldrive/cuid?tab=readme-ov-file#motivation) generated by Prisma.
   */
  id: Scalars['String']['output'];
  /** Whether the user is a Texture employee. */
  isTextureEmployee: Scalars['Boolean']['output'];
  /** The ID of the organization the user most recently authenticated to. */
  lastAuthenticatedOrganizationId: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is accessed on the UserProfile type */
  lastName: Maybe<Scalars['String']['output']>;
  /** The memberships to organizations the user is a part of. */
  memberships: Maybe<Array<Maybe<Membership>>>;
  profile: UserProfile;
  /** @deprecated This field is accessed on the UserProfile type */
  profilePhoto: Maybe<Scalars['String']['output']>;
  /** User's login sessions for tracking authentication history */
  sessions: SessionPaginatedQueryPayload;
  /** @deprecated We use auth0 */
  supertokensId: Scalars['String']['output'];
  /** The timestamp the user was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** External User type from identity domain */
export type UserAuthProviderLogsArgs = {
  input: InputMaybe<AuthProviderLogsInput>;
};


/** External User type from identity domain */
export type UserSessionsArgs = {
  input: InputMaybe<SessionsInput>;
};

export type UserFields = {
  /** Whether the user's email addresses are verified. */
  areEmailsVerified: Scalars['Boolean']['output'];
  /** User's logs from Texture's auth provider */
  authProviderLogs: AuthProviderLogPaginatedQueryPayload;
  /** The timestamp the user was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user's email addresses. */
  emails: Maybe<Array<Maybe<Email>>>;
  /** The unique identifier for the user issued by the external identity provider. */
  externalUserId: Scalars['String']['output'];
  /** @deprecated This field is accessed on the UserProfile type */
  firstName: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is accessed on the UserProfile type */
  fullName: Maybe<Scalars['String']['output']>;
  /**
   * The unique identifier for the user issued by Texture. This is the primary key for the user record.
   * It is a [CUID](https://github.com/paralleldrive/cuid?tab=readme-ov-file#motivation) generated by Prisma.
   */
  id: Scalars['String']['output'];
  /** Whether the user is a Texture employee. */
  isTextureEmployee: Scalars['Boolean']['output'];
  /** The ID of the organization the user most recently authenticated to. */
  lastAuthenticatedOrganizationId: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is accessed on the UserProfile type */
  lastName: Maybe<Scalars['String']['output']>;
  /** The memberships to organizations the user is a part of. */
  memberships: Maybe<Array<Maybe<Membership>>>;
  profile: UserProfile;
  /** @deprecated This field is accessed on the UserProfile type */
  profilePhoto: Maybe<Scalars['String']['output']>;
  /** User's login sessions for tracking authentication history */
  sessions: SessionPaginatedQueryPayload;
  /** @deprecated We use auth0 */
  supertokensId: Scalars['String']['output'];
  /** The timestamp the user was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


export type UserFieldsAuthProviderLogsArgs = {
  input: InputMaybe<AuthProviderLogsInput>;
};


export type UserFieldsSessionsArgs = {
  input: InputMaybe<SessionsInput>;
};

/** Paginated response for users */
export type UserPaginatedQueryPayload = {
  __typename?: 'UserPaginatedQueryPayload';
  data: Maybe<Array<User>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

/** The profile of a Texture user. This information is publicly accessible by other members within an organization. */
export type UserProfile = {
  __typename?: 'UserProfile';
  /** @deprecated This field is accessed on the User type */
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated This field is accessed on the User type */
  emails: Maybe<Array<EmailV2>>;
  /** @deprecated This field is accessed on the User type */
  externalUserId: Scalars['String']['output'];
  /** The user's first name. */
  firstName: Maybe<Scalars['String']['output']>;
  /** The user's full name. */
  fullName: Maybe<Scalars['String']['output']>;
  /**
   * The unique identifier for the user issued by Texture. This is the primary key for the user record.
   * It is a [CUID](https://github.com/paralleldrive/cuid?tab=readme-ov-file#motivation) generated by Prisma.
   */
  id: Scalars['ID']['output'];
  /** @deprecated This field is accessed on the User type */
  lastAuthenticatedOrganizationId: Maybe<Scalars['String']['output']>;
  /** The user's last name. */
  lastName: Maybe<Scalars['String']['output']>;
  legacyProfile: Scalars['Boolean']['output'];
  /** @deprecated This field is accessed on the User type */
  memberships: Maybe<Array<Membership>>;
  /** Preferred temperature unit for the user. */
  preferredTemperatureUnit: Maybe<PreferredTemperatureUnit>;
  preferredTimeZone: Maybe<Scalars['String']['output']>;
  /** The user's profile photo URL. */
  profilePhoto: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is accessed on the User type */
  updatedAt: Scalars['DateTime']['output'];
};

/** User settings stored as a JSON blob. Append-only for version history. */
export type UserSettings = {
  __typename?: 'UserSettings';
  /** When this settings record was created */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier for this settings record */
  id: Scalars['ID']['output'];
  /** The settings JSON blob */
  settings: Scalars['JSON']['output'];
  /** The ID of the user this settings record belongs to */
  userId: Scalars['ID']['output'];
};

export type Utility = {
  __typename?: 'Utility';
  name: Scalars['String']['output'];
  utilityType: UtilityType;
};

export type UtilityApiGrant = {
  __typename?: 'UtilityApiGrant';
  credentialId: Maybe<Scalars['ID']['output']>;
  credentials: Maybe<ApiKeyCredentials>;
  logoUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UtilityOption = {
  __typename?: 'UtilityOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UtilityType =
  | 'COOPERATIVE'
  | 'INVESTOR_OWNED'
  | 'MUNICIPAL'
  | 'POLITICAL_SUBDIVISION'
  | 'UNKNOWN';

/** Input for validating workflow configuration */
export type ValidateWorkflowInput = {
  /** JSON workflow configuration to validate */
  config: Scalars['JSON']['input'];
};

export type ValidationFlagsFilter = {
  batteryFlowReasonable?: InputMaybe<Scalars['Boolean']['input']>;
  energyBalanceOk?: InputMaybe<Scalars['Boolean']['input']>;
  exportHasSource?: InputMaybe<Scalars['Boolean']['input']>;
  importHasDest?: InputMaybe<Scalars['Boolean']['input']>;
  nonNegativeValues?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Validation error or warning for workflow configuration */
export type ValidationIssue = {
  __typename?: 'ValidationIssue';
  /** Error code for categorization */
  code: Scalars['String']['output'];
  /** Additional guidance for fixing the issue */
  hint: Maybe<Scalars['String']['output']>;
  /** Issue severity level: 'error' or 'warning' */
  level: Scalars['String']['output'];
  /** Human-readable error message */
  message: Scalars['String']['output'];
  /** Node ID if error is node-specific */
  nodeId: Maybe<Scalars['String']['output']>;
  /** JSON pointer path to the problematic field */
  path: Scalars['String']['output'];
};

/** Complete workflow validation result */
export type ValidationResult = {
  __typename?: 'ValidationResult';
  /** All validation issues (errors and warnings) */
  allIssues: Array<ValidationIssue>;
  /** Number of validation errors */
  errorCount: Scalars['Int']['output'];
  /** List of validation errors */
  errors: Array<ValidationIssue>;
  /** Whether the workflow is valid */
  isValid: Scalars['Boolean']['output'];
  /** Number of validation warnings */
  warningCount: Scalars['Int']['output'];
  /** List of validation warnings */
  warnings: Array<ValidationIssue>;
};

export type ValidationWarning = {
  __typename?: 'ValidationWarning';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  stageSlug: Maybe<Scalars['String']['output']>;
  suggestedFix: Maybe<Scalars['String']['output']>;
  transitionId: Maybe<Scalars['String']['output']>;
};

export type VehicleBatchCommandInput = {
  deviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  setChargeLimit?: InputMaybe<SetVehicleChargeLimitInput>;
  setOperatingMode?: InputMaybe<SetVehicleOperatingModeInput>;
  slug: VehicleCommandSlug;
  tag?: InputMaybe<Scalars['String']['input']>;
  workspaceDeviceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type VehicleCommandInput = {
  id: Scalars['ID']['input'];
  setChargeLimit?: InputMaybe<SetVehicleChargeLimitInput>;
  setOperatingMode?: InputMaybe<SetVehicleOperatingModeInput>;
  slug: VehicleCommandSlug;
};

export type VehicleCommandSlug =
  | 'vehicle_set_charge_limit'
  | 'vehicle_set_operating_mode';

export type VehicleLocation = ILocation & {
  __typename?: 'VehicleLocation';
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
};

export type VehicleState = {
  __typename?: 'VehicleState';
  charge: Maybe<Scalars['Float']['output']>;
  chargeCompletedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use chargeCompletedAt */
  chargeCompletionDate: Maybe<Scalars['DateTime']['output']>;
  chargeLimit: Maybe<Scalars['Float']['output']>;
  chargePercentage: Scalars['Float']['output'];
  chargerCurrent: Maybe<Scalars['Float']['output']>;
  chargerVoltage: Maybe<Scalars['Float']['output']>;
  chargerWattage: Maybe<Scalars['Float']['output']>;
  chargingState: BatteryChargingState;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isPluggedIn: Maybe<Scalars['Boolean']['output']>;
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  range: Scalars['Float']['output'];
};

export type VehicleStaticState = {
  __typename?: 'VehicleStaticState';
  capacity: Maybe<Scalars['Float']['output']>;
  extendedCapabilities: Maybe<Scalars['JSON']['output']>;
  /**
   * Whether the manufacturer virtual key has been paired with this vehicle.
   * Null when virtual key pairing is not applicable for the manufacturer,
   * or when pairing status is temporarily unavailable (for example, fleet-status API unavailable).
   */
  keyPaired: Maybe<Scalars['Boolean']['output']>;
};

/** Possible errors that can occur during email verification */
export type VerifyEmailError = EmailAlreadyVerifiedError | GenericError | TokenExpiredError | TokenNotFoundError;

/** Response type for email verification */
export type VerifyEmailResponse = {
  __typename?: 'VerifyEmailResponse';
  /** The email that was verified, if successful */
  email: Maybe<Email>;
  /** Any errors that occurred during the operation */
  errors: Maybe<Array<VerifyEmailError>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Input for verifying MFA code */
export type VerifyMfaCodeInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  mfaChallengeId: Scalars['String']['input'];
};

export type ViewKeyPayload = {
  __typename?: 'ViewKeyPayload';
  /** The full API key value. */
  key: Scalars['String']['output'];
};

export type VirtualAccount = {
  __typename?: 'VirtualAccount';
  createdAt: Scalars['DateTime']['output'];
  devices: Array<VirtualDevice>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  type: VirtualAccountType;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
};

export type VirtualAccountType =
  | 'DEFAULT'
  | 'OAUTH';

export type VirtualDevice = {
  __typename?: 'VirtualDevice';
  accountId: Scalars['String']['output'];
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  type: VirtualDeviceType;
  updatedAt: Scalars['DateTime']['output'];
};

export type VirtualDeviceType =
  | 'battery'
  | 'charger'
  | 'inverter'
  | 'thermostat'
  | 'vehicle';

export type VisibilityLevel =
  | 'INTERNAL'
  | 'SHARED';

export type Weather = {
  __typename?: 'Weather';
  cloudiness: Maybe<WeatherFloat>;
  conditions: Maybe<WeatherString>;
  dewPoint: Maybe<WeatherFloat>;
  humidity: Maybe<WeatherFloat>;
  provider: Scalars['String']['output'];
  sunrise: Maybe<WeatherString>;
  sunset: Maybe<WeatherString>;
  temperature: Maybe<WeatherFloat>;
};

export type WeatherFloat = WeatherUnit & {
  __typename?: 'WeatherFloat';
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type WeatherString = WeatherUnit & {
  __typename?: 'WeatherString';
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type WeatherUnit = {
  unit: Scalars['String']['output'];
};

export type WebhookDelivery = {
  __typename?: 'WebhookDelivery';
  commandType: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  responseTimeMs: Maybe<Scalars['Int']['output']>;
  status: WebhookDeliveryStatus;
  statusCode: Maybe<Scalars['Int']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type WebhookDeliveryStatus =
  | 'FAILED'
  | 'SUCCESS';

export type WebhookStatus =
  | 'ACTIVE'
  | 'DISABLED'
  | 'FAILING';

export type WebhookTestResult = {
  __typename?: 'WebhookTestResult';
  error: Maybe<Scalars['String']['output']>;
  responseTimeMs: Maybe<Scalars['Int']['output']>;
  statusCode: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type WholesaleMarket = {
  __typename?: 'WholesaleMarket';
  name: Scalars['String']['output'];
};

export type WindowSize =
  | 'DAY'
  | 'FIFTEEN_MINUTES'
  | 'HOUR'
  | 'MONTH'
  | 'WEEK'
  | 'YEAR';

/** Workflow definition stored as JSON conforming to the workflow schema */
export type Workflow = {
  __typename?: 'Workflow';
  /** JSON configuration conforming to workflow schema */
  config: Scalars['JSON']['output'];
  /** ISO 8601 datetime when the workflow was created */
  createdAt: Scalars['String']['output'];
  /** Organization where the workflow was created */
  createdByOrganizationId: Maybe<Scalars['String']['output']>;
  /** User who created the workflow */
  createdByUserId: Maybe<Scalars['String']['output']>;
  /** Workspace where the workflow was created */
  createdByWorkspaceId: Maybe<Scalars['String']['output']>;
  /** Description of the workflow */
  description: Maybe<Scalars['String']['output']>;
  /** Whether the workflow is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Unique identifier for the workflow */
  id: Scalars['ID']['output'];
  /** Whether the workflow is valid according to schema and business rules */
  isValid: Scalars['Boolean']['output'];
  /** Latest draft version of this workflow */
  latestDraft: Maybe<WorkflowDraft>;
  /** Name of the workflow */
  name: Scalars['String']['output'];
  /** ISO 8601 datetime when the workflow was last updated */
  updatedAt: Scalars['String']['output'];
  /** Validation errors if the workflow is not valid */
  validationErrors: Maybe<Array<ValidationIssue>>;
};

/** Paginated workflow response */
export type WorkflowConnection = {
  __typename?: 'WorkflowConnection';
  /** Whether there are more results */
  hasMore: Scalars['Boolean']['output'];
  /** List of workflows */
  items: Array<Workflow>;
  /** Total count of workflows matching the filter */
  totalCount: Scalars['Int']['output'];
};

/** Workflow draft version for auto-save functionality */
export type WorkflowDraft = {
  __typename?: 'WorkflowDraft';
  /** JSON configuration for this draft */
  config: Scalars['JSON']['output'];
  /** ISO 8601 datetime when the draft was created */
  createdAt: Scalars['String']['output'];
  /** Organization where this draft was created */
  createdByOrganizationId: Maybe<Scalars['String']['output']>;
  /** User who created this draft */
  createdByUserId: Maybe<Scalars['String']['output']>;
  /** Workspace where this draft was created */
  createdByWorkspaceId: Maybe<Scalars['String']['output']>;
  /** Description of the workflow in this draft */
  description: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the draft */
  id: Scalars['ID']['output'];
  /** Whether this draft is valid */
  isValid: Scalars['Boolean']['output'];
  /** Name of the workflow in this draft */
  name: Scalars['String']['output'];
  /** Validation errors for this draft */
  validationErrors: Maybe<Array<ValidationIssue>>;
  /** Version number of this draft */
  version: Scalars['Int']['output'];
  /** The workflow this draft belongs to */
  workflowId: Scalars['ID']['output'];
};

/** Workflow execution instance */
export type WorkflowExecution = {
  __typename?: 'WorkflowExecution';
  /** ISO 8601 datetime when execution completed */
  completedAt: Maybe<Scalars['String']['output']>;
  /** Execution context and state */
  context: Scalars['JSON']['output'];
  /** Current step being executed */
  currentStep: Maybe<Scalars['String']['output']>;
  /** Error message if failed */
  error: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the execution */
  id: Scalars['ID']['output'];
  /** ISO 8601 datetime when execution started */
  startedAt: Scalars['String']['output'];
  /** Current execution status */
  status: WorkflowStatus;
  /** The workflow being executed */
  workflow: Workflow;
};

/** Filter criteria for workflow queries */
export type WorkflowFilter = {
  /** Filter by enabled status */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by name (partial match) */
  nameLike?: InputMaybe<Scalars['String']['input']>;
};

/** Workflow execution status */
export type WorkflowStatus =
  | 'CANCELLED'
  | 'COMPLETED'
  | 'FAILED'
  | 'PENDING'
  | 'RUNNING'
  | 'WAITING_MODAL';

/** Input for querying workflows */
export type WorkflowsInput = {
  /** Optional filter criteria */
  filter?: InputMaybe<WorkflowFilter>;
  /** Maximum number of results to return */
  limit?: Scalars['Int']['input'];
  /** Number of results to skip for pagination */
  offset?: Scalars['Int']['input'];
  /** ID of the workspace to query workflows from */
  workspaceId: Scalars['String']['input'];
};

/** External Workspace type from identity domain */
export type Workspace = {
  __typename?: 'Workspace';
  accessGrants: Maybe<Array<WorkspaceAccessGrant>>;
  alertConfig: WorkspaceAlertConfig;
  /** Hourly battery charge time series, in kWh. */
  batteryChargeKwhSeries: Array<BatteryChargeDataPoint>;
  /** Monthly cumulative inverter capacity time series, in kilowatts. */
  capacityKwSeries: Array<CapacityGrowthDataPoint>;
  collections: Maybe<Array<Collection>>;
  createdAt: Scalars['DateTime']['output'];
  /** Total current battery charge across all batteries, in kWh. */
  currentBatteryChargeKwh: Maybe<Scalars['Float']['output']>;
  deletionProtection: Scalars['Boolean']['output'];
  /** Total number of devices in this workspace. */
  deviceCount: Scalars['Int']['output'];
  /** Monthly cumulative device count time series. */
  deviceCountSeries: Array<DeviceGrowthDataPoint>;
  devices: Array<Device>;
  /** Total enrolled enrollments (including legacy approved) in this workspace. */
  enrollmentCount: Scalars['Int']['output'];
  /** Monthly cumulative enrolled (including legacy approved) enrollment count series. */
  enrollmentCountSeries: Array<EnrollmentGrowthDataPoint>;
  id: Scalars['ID']['output'];
  invitations: Maybe<Array<WorkspaceInvitation>>;
  keys: Maybe<Array<ApiKey>>;
  name: Scalars['String']['output'];
  organization: Maybe<Organization>;
  organizationId: Scalars['String']['output'];
  /** Shared resources accessible in this workspace (only populated when accessed through WorkspaceAccessGrant) */
  sharedResources: Maybe<Array<SharedResource>>;
  /** Total rated battery capacity across all batteries, in kWh. */
  totalBatteryCapacityKwh: Maybe<Scalars['Float']['output']>;
  /** Total nameplate capacity of inverters in this workspace, in kilowatts. */
  totalCapacityKw: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** External Workspace type from identity domain */
export type WorkspaceBatteryChargeKwhSeriesArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};


/** External Workspace type from identity domain */
export type WorkspaceCapacityKwSeriesArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};


/** External Workspace type from identity domain */
export type WorkspaceDeviceCountSeriesArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};


/** External Workspace type from identity domain */
export type WorkspaceEnrollmentCountSeriesArgs = {
  from: InputMaybe<Scalars['DateTime']['input']>;
  to: InputMaybe<Scalars['DateTime']['input']>;
};

export type WorkspaceAccessGrant = {
  __typename?: 'WorkspaceAccessGrant';
  grantee: Maybe<Organization>;
  id: Scalars['ID']['output'];
  workspace: Workspace;
};

export type WorkspaceAlertConfig = {
  __typename?: 'WorkspaceAlertConfig';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  oemOverrides: Array<OemOverride>;
  severities: Severities;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
};

export type WorkspaceAlertConfigInput = {
  enabled: Scalars['Boolean']['input'];
  oemOverrides: Array<OemOverrideInput>;
  severities: SeveritiesInput;
};

export type WorkspaceConnectConfig = {
  __typename?: 'WorkspaceConnectConfig';
  linkSessionConfig: Maybe<LinkSessionConfigDefaults>;
};

export type WorkspaceConnectConfigData = {
  linkSessionConfig?: InputMaybe<LinkSessionConfigDefaultsInput>;
};

export type WorkspaceConnectConfigInput = {
  profile?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type WorkspaceInvitation = {
  __typename?: 'WorkspaceInvitation';
  createdBy: UserProfile;
  id: Scalars['ID']['output'];
  recipientEmail: Scalars['String']['output'];
  status: WorkspaceInvitationStatus;
  workspace: Workspace;
};

export type WorkspaceInvitationStatus =
  | 'ACCEPTED'
  | 'CANCELLED'
  | 'PENDING';

export type WorkspacePaginatedQueryPayload = {
  __typename?: 'WorkspacePaginatedQueryPayload';
  data: Maybe<Array<Workspace>>;
  error: Maybe<Scalars['String']['output']>;
  meta: Maybe<ListPayloadMeta>;
};

export type WorkspaceProgram = {
  __typename?: 'WorkspaceProgram';
  createdAt: Scalars['DateTime']['output'];
  customFields: Maybe<Scalars['JSON']['output']>;
  description: Maybe<Scalars['String']['output']>;
  eligibilityCriteria: Maybe<Scalars['String']['output']>;
  enrollmentReportConfig: Maybe<EnrollmentReportConfig>;
  events: Array<WorkspaceProgramEvent>;
  groups: Array<EnrollmentGroup>;
  id: Scalars['ID']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  program: Program;
  programTerms: Maybe<Scalars['String']['output']>;
  programVariant: Maybe<ProgramVariant>;
  programVariantId: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type WorkspaceProgramEvent = {
  __typename?: 'WorkspaceProgramEvent';
  /** @deprecated Use batches instead */
  batch: Maybe<Batch>;
  /** @deprecated Use batchIds instead */
  batchId: Maybe<Scalars['String']['output']>;
  batchIds: Array<Scalars['String']['output']>;
  batches: Array<Batch>;
  createdAt: Scalars['DateTime']['output'];
  endsAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  startsAt: Maybe<Scalars['DateTime']['output']>;
  status: WorkspaceProgramEventStatus;
  type: Scalars['String']['output'];
  workspaceProgram: WorkspaceProgram;
  workspaceProgramId: Scalars['ID']['output'];
};

export type WorkspaceProgramEventStatus =
  | 'active'
  | 'completed'
  | 'draft'
  | 'pending';

export type WorkspaceProgramPaginatedQueryPayload = {
  __typename?: 'WorkspaceProgramPaginatedQueryPayload';
  data: Array<WorkspaceProgram>;
  meta: ListPayloadMeta;
};

export type WorkspaceSystemConnection = WorkspaceSystemConnectionInterface & {
  __typename?: 'WorkspaceSystemConnection';
  createdAt: Scalars['DateTime']['output'];
  customerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  manufacturerData: Maybe<Scalars['JSON']['output']>;
  manufacturerSlug: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
  systemIdentifier: Scalars['String']['output'];
  tags: Maybe<Array<Scalars['String']['output']>>;
  workspaceId: Scalars['ID']['output'];
};

export type WorkspaceSystemConnectionInput = {
  id: Scalars['ID']['input'];
};

export type WorkspaceSystemConnectionInterface = {
  createdAt: Scalars['DateTime']['output'];
  customerId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  manufacturerData: Maybe<Scalars['JSON']['output']>;
  manufacturerSlug: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
  systemIdentifier: Scalars['String']['output'];
  tags: Maybe<Array<Scalars['String']['output']>>;
  workspaceId: Scalars['ID']['output'];
};

export type WorkspaceSystemConnections = {
  __typename?: 'WorkspaceSystemConnections';
  connectedCustomersAndSites: Array<ConnectedCustomerAndSite>;
};

export type WorkspaceSystemConnectionsInput = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<ListPagination>;
  siteId?: InputMaybe<Scalars['ID']['input']>;
  systemId?: InputMaybe<Scalars['String']['input']>;
  systemIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

/** Input for writing lifecycle facts to an enrollment. */
export type WriteLifecycleFactInput = {
  enrollmentId: Scalars['ID']['input'];
  facts: Scalars['JSON']['input'];
  source: Scalars['String']['input'];
};

export type GetUsersCountForHomepageQueryVariables = Exact<{
  input: AllUsersInput;
}>;


export type GetUsersCountForHomepageQuery = { __typename?: 'Query', allUsers: { __typename?: 'UserPaginatedQueryPayload', meta: { __typename?: 'ListPayloadMeta', totalCount: number } | null } };

export type GetSuperAdminCountForHomepageQueryVariables = Exact<{
  input: SuperAdminGrantsInput;
}>;


export type GetSuperAdminCountForHomepageQuery = { __typename?: 'Query', superAdminGrants: { __typename?: 'SuperAdminGrantPaginatedQueryPayload', meta: { __typename?: 'ListPayloadMeta', totalCount: number } | null } };

export type UserForDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserForDetailQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, createdAt: string, updatedAt: string, externalUserId: string, isTextureEmployee: boolean, profile: { __typename?: 'UserProfile', fullName: string | null, profilePhoto: string | null }, emails: Array<{ __typename?: 'Email', email: string, verified: boolean } | null> | null, memberships: Array<{ __typename?: 'Membership', id: string, role: Role, organization: { __typename?: 'Organization', id: string, name: string } | null } | null> | null } | null };

export type SuperAdminGrantsForUserQueryVariables = Exact<{
  input: SuperAdminGrantsInput;
}>;


export type SuperAdminGrantsForUserQuery = { __typename?: 'Query', superAdminGrants: { __typename?: 'SuperAdminGrantPaginatedQueryPayload', data: Array<{ __typename?: 'SuperAdminGrant', id: string, reason: string | null, expiresAt: string | null, revokedAt: string | null, revokedReason: string | null, createdAt: string, updatedAt: string, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', fullName: string | null } }, grantedBy: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', fullName: string | null } }, revokedBy: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', fullName: string | null } } | null }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number } | null } };

export type GrantSuperAdminAccessMutationVariables = Exact<{
  input: GrantSuperAdminInput;
}>;


export type GrantSuperAdminAccessMutation = { __typename?: 'Mutation', grantSuperAdmin: { __typename?: 'SuperAdminGrant', id: string, user: { __typename?: 'User', id: string } } };

export type RevokeSuperAdminAccessMutationVariables = Exact<{
  input: RevokeSuperAdminInput;
}>;


export type RevokeSuperAdminAccessMutation = { __typename?: 'Mutation', revokeSuperAdmin: { __typename?: 'SuperAdminGrant', id: string, revokedAt: string | null } };

export type AllUsersQueryVariables = Exact<{
  input: AllUsersInput;
}>;


export type AllUsersQuery = { __typename?: 'Query', allUsers: { __typename?: 'UserPaginatedQueryPayload', error: string | null, data: Array<{ __typename?: 'User', id: string, createdAt: string, externalUserId: string, isTextureEmployee: boolean, profile: { __typename?: 'UserProfile', fullName: string | null, profilePhoto: string | null }, emails: Array<{ __typename?: 'Email', email: string, verified: boolean } | null> | null }> | null, meta: { __typename?: 'ListPayloadMeta', count: number, totalCount: number, totalPages: number, hasPreviousPage: boolean, hasNextPage: boolean, pagination: { __typename?: 'ListPayloadMetaPagination', offset: { __typename?: 'OffsetPaginationInfo', page: number | null, perPage: number | null } | null } | null } | null } };

export type GetAffiliatedByOrganizationsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAffiliatedByOrganizationsQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, affiliatedByOrganizations: Array<{ __typename?: 'OrganizationAffiliation', id: string, organizationId: string, createdAt: string, organization: { __typename?: 'Organization', id: string, name: string, logo: string | null }, createdBy: { __typename?: 'UserProfile', fullName: string | null } | null }> } | null };

export type GetAllOrganizationsForGrowthQueryVariables = Exact<{
  input: OrganizationsInput;
}>;


export type GetAllOrganizationsForGrowthQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationPaginatedQueryPayload', data: Array<{ __typename?: 'Organization', id: string, createdAt: string }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number } | null } };

export type GetRecentUsersForHomepageQueryVariables = Exact<{
  input: AllUsersInput;
}>;


export type GetRecentUsersForHomepageQuery = { __typename?: 'Query', allUsers: { __typename?: 'UserPaginatedQueryPayload', data: Array<{ __typename?: 'User', id: string, createdAt: string, profile: { __typename?: 'UserProfile', fullName: string | null, profilePhoto: string | null }, emails: Array<{ __typename?: 'Email', email: string } | null> | null, memberships: Array<{ __typename?: 'Membership', id: string, organization: { __typename?: 'Organization', id: string, name: string } | null } | null> | null }> | null } };

export type OrganizationAffiliationFieldsFragment = { __typename?: 'OrganizationAffiliation', id: string, organizationId: string, affiliatedOrganizationId: string, createdAt: string, affiliatedOrganization: { __typename?: 'Organization', id: string, name: string, logo: string | null }, createdBy: { __typename?: 'UserProfile', fullName: string | null } | null };

export type CreateOrganizationAffiliationMutationVariables = Exact<{
  input: CreateOrganizationAffiliationInput;
}>;


export type CreateOrganizationAffiliationMutation = { __typename?: 'Mutation', createOrganizationAffiliation: { __typename?: 'OrganizationAffiliation', id: string, organizationId: string, affiliatedOrganizationId: string, createdAt: string, affiliatedOrganization: { __typename?: 'Organization', id: string, name: string, logo: string | null }, createdBy: { __typename?: 'UserProfile', fullName: string | null } | null } };

export type RemoveOrganizationAffiliationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveOrganizationAffiliationMutation = { __typename?: 'Mutation', removeOrganizationAffiliation: boolean };

export type GetOrganizationAffiliationsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOrganizationAffiliationsQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, affiliatedOrganizations: Array<{ __typename?: 'OrganizationAffiliation', id: string, organizationId: string, affiliatedOrganizationId: string, createdAt: string, affiliatedOrganization: { __typename?: 'Organization', id: string, name: string, logo: string | null }, createdBy: { __typename?: 'UserProfile', fullName: string | null } | null }> } | null };

export type PlaceholderQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaceholderQueryQuery = { __typename: 'Query' };

export type GetAllWorkspacesViaOrganizationsQueryVariables = Exact<{
  input: OrganizationsInput;
}>;


export type GetAllWorkspacesViaOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationPaginatedQueryPayload', error: string | null, data: Array<{ __typename?: 'Organization', id: string, name: string, workspaces: Array<{ __typename?: 'Workspace', id: string, name: string, organizationId: string, deletionProtection: boolean, createdAt: string, updatedAt: string }> | null }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasPreviousPage: boolean, hasNextPage: boolean, pagination: { __typename?: 'ListPayloadMetaPagination', offset: { __typename?: 'OffsetPaginationInfo', page: number | null, perPage: number | null } | null } | null } | null } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, name: string, domain: string | null, logo: string | null, industry: string | null, personal: boolean, createdAt: string, updatedAt: string } };

export type CreateProgramMutationVariables = Exact<{
  input: CreateProgramInput;
}>;


export type CreateProgramMutation = { __typename?: 'Mutation', createProgram: { __typename?: 'Program', id: string, slug: string, name: string } };

export type CreateDeviceModelMutationVariables = Exact<{
  input: CreateDeviceModelInput;
}>;


export type CreateDeviceModelMutation = { __typename?: 'Mutation', createDeviceModel: { __typename?: 'DeviceModelProfile', id: string | null, slug: string, name: string, logo: string | null, type: DeviceType | null, supportLevel: SupportLevel | null, manufacturerId: string | null } };

export type UpdateDeviceModelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDeviceModelInput;
}>;


export type UpdateDeviceModelMutation = { __typename?: 'Mutation', updateDeviceModel: { __typename?: 'DeviceModelProfile', id: string | null, slug: string, name: string, logo: string | null, type: DeviceType | null, supportLevel: SupportLevel | null, manufacturerId: string | null } };

export type DeleteDeviceModelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDeviceModelMutation = { __typename?: 'Mutation', deleteDeviceModel: boolean };

export type GetFieldConfigurationsQueryVariables = Exact<{
  entityType: InputMaybe<Scalars['String']['input']>;
  context: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFieldConfigurationsQuery = { __typename?: 'Query', fieldConfigurations: Array<{ __typename?: 'FieldConfiguration', id: string, factKey: string, entityType: string, contexts: Array<string>, configSchema: unknown, enabled: boolean, createdAt: string, updatedAt: string }> };

export type SearchPlatformFieldsQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchPlatformFieldsQuery = { __typename?: 'Query', searchPlatformFields: Array<{ __typename?: 'PlatformField', factKey: string, displayName: string, fieldType: string, entityType: string, description: string | null, source: string }> };

export type UpsertFieldConfigurationMutationVariables = Exact<{
  input: UpsertFieldConfigurationInput;
}>;


export type UpsertFieldConfigurationMutation = { __typename?: 'Mutation', upsertFieldConfiguration: { __typename?: 'FieldConfiguration', id: string, factKey: string, entityType: string, contexts: Array<string>, configSchema: unknown, enabled: boolean, createdAt: string, updatedAt: string } };

export type ManufacturerAssignmentFieldsFragment = { __typename?: 'ManufacturerAssignment', id: string, organizationId: string, createdAt: string, createdBy: { __typename?: 'ManufacturerAssignmentCreatedBy', fullName: string | null } | null, manufacturer: { __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null } };

export type GetManufacturerAssignmentsForOrganizationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetManufacturerAssignmentsForOrganizationQuery = { __typename?: 'Query', manufacturerAssignmentsForOrganization: Array<{ __typename?: 'ManufacturerAssignment', id: string, organizationId: string, createdAt: string, createdBy: { __typename?: 'ManufacturerAssignmentCreatedBy', fullName: string | null } | null, manufacturer: { __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null } }> };

export type AssignManufacturerMutationVariables = Exact<{
  manufacturerId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type AssignManufacturerMutation = { __typename?: 'Mutation', assignManufacturer: { __typename?: 'ManufacturerAssignment', id: string, organizationId: string, createdAt: string, createdBy: { __typename?: 'ManufacturerAssignmentCreatedBy', fullName: string | null } | null, manufacturer: { __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null } } };

export type RevokeManufacturerAssignmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RevokeManufacturerAssignmentMutation = { __typename?: 'Mutation', revokeManufacturerAssignment: boolean };

export type GetManufacturerModelsQueryVariables = Exact<{
  input: InputMaybe<ModelInput>;
}>;


export type GetManufacturerModelsQuery = { __typename?: 'Query', models: Array<{ __typename?: 'DeviceModelProfile', id: string | null, slug: string, name: string, logo: string | null, type: DeviceType | null, supportLevel: SupportLevel | null, manufacturerId: string | null }> };

export type CreateDeviceManufacturerMutationVariables = Exact<{
  input: CreateDeviceManufacturerInput;
}>;


export type CreateDeviceManufacturerMutation = { __typename?: 'Mutation', createDeviceManufacturer: { __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null, vectorIcon: string | null, supportLevel: SupportLevel | null, supportsGridServices: boolean | null, availableInTextureConnect: boolean | null } };

export type UpdateDeviceManufacturerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDeviceManufacturerInput;
}>;


export type UpdateDeviceManufacturerMutation = { __typename?: 'Mutation', updateDeviceManufacturer: { __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null, vectorIcon: string | null, supportLevel: SupportLevel | null, supportsGridServices: boolean | null, availableInTextureConnect: boolean | null } };

export type DeleteDeviceManufacturerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDeviceManufacturerMutation = { __typename?: 'Mutation', deleteDeviceManufacturer: boolean };

export type GetManufacturersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManufacturersQuery = { __typename?: 'Query', manufacturers: Array<{ __typename?: 'DeviceManufacturerProfile', id: string | null, slug: string, name: string, logo: string | null, icon: string | null, vectorIcon: string | null, supportLevel: SupportLevel | null, supportsGridServices: boolean | null, availableInTextureConnect: boolean | null }> };

export type GetOAuthApplicationByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOAuthApplicationByIdQuery = { __typename?: 'Query', oauthApplication: { __typename?: 'OAuthApplication', id: string, clientId: string, name: string, description: string | null, redirectUris: Array<string>, allowedScopes: Array<string>, type: OAuthApplicationType, isFirstParty: boolean, createdAt: string, updatedAt: string } };

export type GetOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationQuery = { __typename?: 'Query', me: { __typename?: 'LoggedUser', id: string, memberships: Array<{ __typename?: 'Membership', id: string, role: Role, isAdmin: boolean, organization: { __typename?: 'Organization', id: string } | null } | null> | null, authenticatedOrganization: { __typename?: 'Organization', id: string, name: string, logo: string | null, preferredTemperatureUnit: PreferredTemperatureUnit, industry: string | null, mfaEmailOtpEnabled: boolean, location: { __typename?: 'OrganizationLocation', country: string | null } | null } | null } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string, logo: string | null, preferredTemperatureUnit: PreferredTemperatureUnit, industry: string | null, mfaEmailOtpEnabled: boolean, location: { __typename?: 'OrganizationLocation', country: string | null } | null } };

export type UpdateOrganizationLocationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateLocationInput;
}>;


export type UpdateOrganizationLocationMutation = { __typename?: 'Mutation', updateOrganizationLocation: { __typename?: 'Organization', id: string, location: { __typename?: 'OrganizationLocation', country: string | null } | null } };

export type GetOrganizationByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetOrganizationByIdQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, name: string, logo: string | null, domain: string | null, url: string | null, industry: string | null, personal: boolean, billingId: string | null, mfaEmailOtpEnabled: boolean, ssoEnabled: boolean, ssoProvider: string | null, preferredTemperatureUnit: PreferredTemperatureUnit, enphaseGridServicesOrganizationToken: string | null, auth0OrganizationId: string | null, auth0OrganizationName: string | null, createdAt: string, updatedAt: string, location: { __typename?: 'OrganizationLocation', country: string | null, state: string | null, city: string | null, streetOne: string | null, streetTwo: string | null, postalCode: string | null } | null, ownerProfile: { __typename?: 'UserProfile', id: string, firstName: string | null, lastName: string | null, fullName: string | null, profilePhoto: string | null } | null, workspaces: Array<{ __typename?: 'Workspace', id: string, name: string }> | null, enabledPacks: Array<{ __typename?: 'OrganizationPack', id: string, pack: PackType, enabledAt: string, enabledBy: { __typename?: 'UserProfile', id: string, firstName: string | null, lastName: string | null, fullName: string | null } | null }> } | null };

export type GetOrganizationMembersQueryVariables = Exact<{
  input: OrganizationMembersInput;
}>;


export type GetOrganizationMembersQuery = { __typename?: 'Query', organizationMembers: { __typename?: 'MembershipPaginatedQueryPayload', error: string | null, data: Array<{ __typename?: 'Membership', id: string, role: Role, owner: boolean, isAdmin: boolean, userId: string, organizationId: string, createdAt: string, updatedAt: string, userProfile: { __typename?: 'UserProfile', id: string, firstName: string | null, lastName: string | null, fullName: string | null, profilePhoto: string | null } | null }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasPreviousPage: boolean, hasNextPage: boolean, pagination: { __typename?: 'ListPayloadMetaPagination', offset: { __typename?: 'OffsetPaginationInfo', page: number | null, perPage: number | null } | null } | null } | null } };

export type EnablePackMutationVariables = Exact<{
  input: EnablePackInput;
}>;


export type EnablePackMutation = { __typename?: 'Mutation', enablePack: { __typename?: 'OrganizationPack', id: string, pack: PackType, enabledAt: string, enabledBy: { __typename?: 'UserProfile', id: string, firstName: string | null, lastName: string | null, fullName: string | null } | null } };

export type DisablePackMutationVariables = Exact<{
  input: DisablePackInput;
}>;


export type DisablePackMutation = { __typename?: 'Mutation', disablePack: boolean };

export type GetOrganizationsQueryVariables = Exact<{
  input: OrganizationsInput;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationPaginatedQueryPayload', error: string | null, data: Array<{ __typename?: 'Organization', id: string, name: string, logo: string | null, domain: string | null, industry: string | null, personal: boolean, createdAt: string, updatedAt: string, memberships: Array<{ __typename?: 'Membership', id: string }> | null, workspaces: Array<{ __typename?: 'Workspace', id: string }> | null }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasPreviousPage: boolean, hasNextPage: boolean, pagination: { __typename?: 'ListPayloadMetaPagination', offset: { __typename?: 'OffsetPaginationInfo', page: number | null, perPage: number | null } | null } | null } | null } };

export type GetProgramByIdQueryVariables = Exact<{
  input: SlugOrIdInput;
}>;


export type GetProgramByIdQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, slug: string, description: string | null, states: Array<string>, active: boolean, public: boolean, year: number | null, endDate: string | null, eligibilityCriteria: string | null, programTerms: string | null, createdAt: string, updatedAt: string } | null };

export type GetAllProgramsQueryVariables = Exact<{
  includeAll: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllProgramsQuery = { __typename?: 'Query', programs: Array<{ __typename?: 'Program', id: string, name: string, slug: string, description: string | null, states: Array<string>, active: boolean, public: boolean, year: number | null, createdAt: string, updatedAt: string }> };

export type UpdateOAuthApplicationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateOAuthApplicationInput;
}>;


export type UpdateOAuthApplicationMutation = { __typename?: 'Mutation', updateOAuthApplication: { __typename?: 'OAuthApplication', id: string, clientId: string, name: string, description: string | null, redirectUris: Array<string>, allowedScopes: Array<string>, type: OAuthApplicationType, isFirstParty: boolean, createdAt: string, updatedAt: string } };

export type UpdateProgramMutationVariables = Exact<{
  input: UpdateProgramInput;
}>;


export type UpdateProgramMutation = { __typename?: 'Mutation', updateProgram: { __typename?: 'Program', id: string, name: string, slug: string, description: string | null, states: Array<string>, active: boolean, public: boolean, year: number | null, endDate: string | null, eligibilityCriteria: string | null, programTerms: string | null, createdAt: string, updatedAt: string } };

export type GetUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProfileQuery = { __typename?: 'Query', me: { __typename?: 'LoggedUser', id: string, profile: { __typename?: 'UserProfile', firstName: string | null, lastName: string | null, fullName: string | null, profilePhoto: string | null, preferredTemperatureUnit: PreferredTemperatureUnit | null, preferredTimeZone: string | null }, email: { __typename?: 'Email', email: string, verified: boolean } | null, memberships: Array<{ __typename?: 'Membership', id: string, role: Role, isAdmin: boolean, organization: { __typename?: 'Organization', id: string, name: string, preferredTemperatureUnit: PreferredTemperatureUnit } | null } | null> | null, authenticatedOrganization: { __typename?: 'Organization', id: string, name: string, preferredTemperatureUnit: PreferredTemperatureUnit } | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: { __typename?: 'UserProfile', id: string, firstName: string | null, lastName: string | null, fullName: string | null, profilePhoto: string | null, preferredTemperatureUnit: PreferredTemperatureUnit | null, preferredTimeZone: string | null } };

export type UpdateUserEmailMutationVariables = Exact<{
  input: UpdateUserEmailInput;
}>;


export type UpdateUserEmailMutation = { __typename?: 'Mutation', updateUserEmail: void | null };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: void | null };

export type ResendVerificationEmailMutationVariables = Exact<{
  input: ResendVerificationEmailInput;
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail: void | null };

export type GetUserByIdForRecentlyViewedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserByIdForRecentlyViewedQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', fullName: string | null, profilePhoto: string | null }, emails: Array<{ __typename?: 'Email', email: string } | null> | null } | null };

export type GetUserSettingsForAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSettingsForAdminQuery = { __typename?: 'Query', userSettings: { __typename?: 'UserSettings', id: string, userId: string, settings: unknown, createdAt: string } | null };

export type UpdateUserSettingsForAdminMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateUserSettingsForAdminMutation = { __typename?: 'Mutation', updateUserSettings: { __typename?: 'UserSettings', id: string, userId: string, settings: unknown, createdAt: string } };

export type GetWorkspaceApiKeysQueryVariables = Exact<{
  input: ApiKeysInput;
}>;


export type GetWorkspaceApiKeysQuery = { __typename?: 'Query', apiKeys: { __typename?: 'ApiKeyPaginatedQueryPayload', data: Array<{ __typename?: 'ApiKey', id: string, name: string, key: string, type: ApiKeyType, revoked: boolean, createdAt: string, updatedAt: string }> | null, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } | null } };

export type GetWorkspaceByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetWorkspaceByIdQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, name: string, organizationId: string, deletionProtection: boolean, createdAt: string, updatedAt: string, organization: { __typename?: 'Organization', id: string, name: string } | null } | null };

export type GetWorkspaceConnectSessionsQueryVariables = Exact<{
  input: ConnectSessionsInput;
}>;


export type GetWorkspaceConnectSessionsQuery = { __typename?: 'Query', connectSessions: { __typename?: 'ConnectSessionsResponse', meta: { __typename?: 'ListPayloadMeta', totalCount: number, totalPages: number, pagination: { __typename?: 'ListPayloadMetaPagination', offset: { __typename?: 'OffsetPaginationInfo', page: number | null, perPage: number | null } | null } | null } | null, data: Array<{ __typename?: 'ConnectSession', id: string, workspaceId: string, status: ConnectSessionStatus, customerId: string | null, siteId: string | null, manufacturer: string | null, tags: Array<string> | null, createdAt: string, updatedAt: string, expiresAt: string }> } };

export type GetWorkspaceDestinationsQueryVariables = Exact<{
  input: DestinationsInput;
}>;


export type GetWorkspaceDestinationsQuery = { __typename?: 'Query', destinations: { __typename?: 'DestinationListPayload', data: Array<{ __typename?: 'Destination', id: string, workspaceId: string, label: string | null, url: string | null, destinationType: DestinationType | null, deviceType: DeviceTypeScope | null, phoneNumber: string | null, email: string | null, eventTypes: Array<EventType>, createdAt: string, updatedAt: string } | null>, meta: { __typename?: 'ListPayloadMeta', totalCount: number, count: number, totalPages: number, hasNextPage: boolean, hasPreviousPage: boolean } | null } };

export type GetWorkspaceOAuthApplicationsQueryVariables = Exact<{
  input: OAuthApplicationsInput;
}>;


export type GetWorkspaceOAuthApplicationsQuery = { __typename?: 'Query', oauthApplications: { __typename?: 'OAuthApplicationPaginatedQueryPayload', edges: Array<{ __typename?: 'OAuthApplicationEdge', node: { __typename?: 'OAuthApplication', id: string, clientId: string, name: string, description: string | null, redirectUris: Array<string>, allowedScopes: Array<string>, type: OAuthApplicationType, isFirstParty: boolean, createdAt: string, updatedAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null } } };

export type GetWorkspaceProgramsQueryVariables = Exact<{
  input: SlugOrIdInput;
}>;


export type GetWorkspaceProgramsQuery = { __typename?: 'Query', workspacePrograms: { __typename?: 'WorkspaceProgramPaginatedQueryPayload', data: Array<{ __typename?: 'WorkspaceProgram', id: string, title: string | null, slug: string, description: string | null, url: string, logoUrl: string | null, createdAt: string, updatedAt: string, program: { __typename?: 'Program', id: string, name: string, slug: string } }>, meta: { __typename?: 'ListPayloadMeta', totalCount: number } } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'LoggedUser', id: string, profile: { __typename?: 'UserProfile', fullName: string | null, preferredTemperatureUnit: PreferredTemperatureUnit | null, preferredTimeZone: string | null, profilePhoto: string | null }, email: { __typename?: 'Email', email: string, verified: boolean } | null, memberships: Array<{ __typename?: 'Membership', id: string, role: Role, isAdmin: boolean, organization: { __typename?: 'Organization', id: string, name: string } | null } | null> | null } | null };

export const OrganizationAffiliationFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationAffiliationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationAffiliation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<OrganizationAffiliationFieldsFragment, unknown>;
export const ManufacturerAssignmentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ManufacturerAssignmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ManufacturerAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]} as unknown as DocumentNode<ManufacturerAssignmentFieldsFragment, unknown>;
export const GetUsersCountForHomepageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersCountForHomepage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllUsersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersCountForHomepageQuery, GetUsersCountForHomepageQueryVariables>;
export const GetSuperAdminCountForHomepageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSuperAdminCountForHomepage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SuperAdminGrantsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"superAdminGrants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetSuperAdminCountForHomepageQuery, GetSuperAdminCountForHomepageQueryVariables>;
export const UserForDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserForDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"isTextureEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserForDetailQuery, UserForDetailQueryVariables>;
export const SuperAdminGrantsForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SuperAdminGrantsForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SuperAdminGrantsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"superAdminGrants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"revokedAt"}},{"kind":"Field","name":{"kind":"Name","value":"revokedReason"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"revokedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<SuperAdminGrantsForUserQuery, SuperAdminGrantsForUserQueryVariables>;
export const GrantSuperAdminAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GrantSuperAdminAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GrantSuperAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantSuperAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GrantSuperAdminAccessMutation, GrantSuperAdminAccessMutationVariables>;
export const RevokeSuperAdminAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeSuperAdminAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RevokeSuperAdminInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeSuperAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"revokedAt"}}]}}]}}]} as unknown as DocumentNode<RevokeSuperAdminAccessMutation, RevokeSuperAdminAccessMutationVariables>;
export const AllUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllUsersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"externalUserId"}},{"kind":"Field","name":{"kind":"Name","value":"isTextureEmployee"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<AllUsersQuery, AllUsersQueryVariables>;
export const GetAffiliatedByOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAffiliatedByOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedByOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetAffiliatedByOrganizationsQuery, GetAffiliatedByOrganizationsQueryVariables>;
export const GetAllOrganizationsForGrowthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllOrganizationsForGrowth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllOrganizationsForGrowthQuery, GetAllOrganizationsForGrowthQueryVariables>;
export const GetRecentUsersForHomepageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecentUsersForHomepage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AllUsersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRecentUsersForHomepageQuery, GetRecentUsersForHomepageQueryVariables>;
export const CreateOrganizationAffiliationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganizationAffiliation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrganizationAffiliationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganizationAffiliation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationAffiliationFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationAffiliationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationAffiliation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<CreateOrganizationAffiliationMutation, CreateOrganizationAffiliationMutationVariables>;
export const RemoveOrganizationAffiliationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveOrganizationAffiliation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeOrganizationAffiliation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveOrganizationAffiliationMutation, RemoveOrganizationAffiliationMutationVariables>;
export const GetOrganizationAffiliationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationAffiliations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganizationAffiliationFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganizationAffiliationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationAffiliation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"affiliatedOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode<GetOrganizationAffiliationsQuery, GetOrganizationAffiliationsQueryVariables>;
export const PlaceholderQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlaceholderQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<PlaceholderQueryQuery, PlaceholderQueryQueryVariables>;
export const GetAllWorkspacesViaOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllWorkspacesViaOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"workspaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"deletionProtection"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<GetAllWorkspacesViaOrganizationsQuery, GetAllWorkspacesViaOrganizationsQueryVariables>;
export const CreateOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"personal"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const CreateProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProgramInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateProgramMutation, CreateProgramMutationVariables>;
export const CreateDeviceModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDeviceModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDeviceModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDeviceModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerId"}}]}}]}}]} as unknown as DocumentNode<CreateDeviceModelMutation, CreateDeviceModelMutationVariables>;
export const UpdateDeviceModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDeviceModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDeviceModelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeviceModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerId"}}]}}]}}]} as unknown as DocumentNode<UpdateDeviceModelMutation, UpdateDeviceModelMutationVariables>;
export const DeleteDeviceModelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDeviceModel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDeviceModel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteDeviceModelMutation, DeleteDeviceModelMutationVariables>;
export const GetFieldConfigurationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFieldConfigurations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"context"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityType"}}},{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"context"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"factKey"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"contexts"}},{"kind":"Field","name":{"kind":"Name","value":"configSchema"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetFieldConfigurationsQuery, GetFieldConfigurationsQueryVariables>;
export const SearchPlatformFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchPlatformFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPlatformFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factKey"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<SearchPlatformFieldsQuery, SearchPlatformFieldsQueryVariables>;
export const UpsertFieldConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertFieldConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertFieldConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertFieldConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"factKey"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"contexts"}},{"kind":"Field","name":{"kind":"Name","value":"configSchema"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpsertFieldConfigurationMutation, UpsertFieldConfigurationMutationVariables>;
export const GetManufacturerAssignmentsForOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetManufacturerAssignmentsForOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturerAssignmentsForOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ManufacturerAssignmentFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ManufacturerAssignmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ManufacturerAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]} as unknown as DocumentNode<GetManufacturerAssignmentsForOrganizationQuery, GetManufacturerAssignmentsForOrganizationQueryVariables>;
export const AssignManufacturerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignManufacturer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"manufacturerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignManufacturer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"manufacturerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"manufacturerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ManufacturerAssignmentFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ManufacturerAssignmentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ManufacturerAssignment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]} as unknown as DocumentNode<AssignManufacturerMutation, AssignManufacturerMutationVariables>;
export const RevokeManufacturerAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeManufacturerAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeManufacturerAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RevokeManufacturerAssignmentMutation, RevokeManufacturerAssignmentMutationVariables>;
export const GetManufacturerModelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetManufacturerModels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ModelInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"models"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturerId"}}]}}]}}]} as unknown as DocumentNode<GetManufacturerModelsQuery, GetManufacturerModelsQueryVariables>;
export const CreateDeviceManufacturerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDeviceManufacturer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDeviceManufacturerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDeviceManufacturer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"vectorIcon"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"supportsGridServices"}},{"kind":"Field","name":{"kind":"Name","value":"availableInTextureConnect"}}]}}]}}]} as unknown as DocumentNode<CreateDeviceManufacturerMutation, CreateDeviceManufacturerMutationVariables>;
export const UpdateDeviceManufacturerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDeviceManufacturer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDeviceManufacturerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeviceManufacturer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"vectorIcon"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"supportsGridServices"}},{"kind":"Field","name":{"kind":"Name","value":"availableInTextureConnect"}}]}}]}}]} as unknown as DocumentNode<UpdateDeviceManufacturerMutation, UpdateDeviceManufacturerMutationVariables>;
export const DeleteDeviceManufacturerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDeviceManufacturer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDeviceManufacturer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteDeviceManufacturerMutation, DeleteDeviceManufacturerMutationVariables>;
export const GetManufacturersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetManufacturers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manufacturers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"vectorIcon"}},{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}},{"kind":"Field","name":{"kind":"Name","value":"supportsGridServices"}},{"kind":"Field","name":{"kind":"Name","value":"availableInTextureConnect"}}]}}]}}]} as unknown as DocumentNode<GetManufacturersQuery, GetManufacturersQueryVariables>;
export const GetOAuthApplicationByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOAuthApplicationById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oauthApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUris"}},{"kind":"Field","name":{"kind":"Name","value":"allowedScopes"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isFirstParty"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetOAuthApplicationByIdQuery, GetOAuthApplicationByIdQueryVariables>;
export const GetOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authenticatedOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"mfaEmailOtpEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const UpdateOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrganizationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"mfaEmailOtpEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateOrganizationLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganizationLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationLocationMutation, UpdateOrganizationLocationMutationVariables>;
export const GetOrganizationByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"personal"}},{"kind":"Field","name":{"kind":"Name","value":"billingId"}},{"kind":"Field","name":{"kind":"Name","value":"mfaEmailOtpEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ssoEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"ssoProvider"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"enphaseGridServicesOrganizationToken"}},{"kind":"Field","name":{"kind":"Name","value":"auth0OrganizationId"}},{"kind":"Field","name":{"kind":"Name","value":"auth0OrganizationName"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"streetOne"}},{"kind":"Field","name":{"kind":"Name","value":"streetTwo"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enabledPacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pack"}},{"kind":"Field","name":{"kind":"Name","value":"enabledAt"}},{"kind":"Field","name":{"kind":"Name","value":"enabledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationByIdQuery, GetOrganizationByIdQueryVariables>;
export const GetOrganizationMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationMembersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"owner"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"userProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>;
export const EnablePackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnablePack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EnablePackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enablePack"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pack"}},{"kind":"Field","name":{"kind":"Name","value":"enabledAt"}},{"kind":"Field","name":{"kind":"Name","value":"enabledBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode<EnablePackMutation, EnablePackMutationVariables>;
export const DisablePackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisablePack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisablePackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disablePack"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DisablePackMutation, DisablePackMutationVariables>;
export const GetOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"personal"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetProgramByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProgramById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SlugOrIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"program"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"states"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"eligibilityCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"programTerms"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetProgramByIdQuery, GetProgramByIdQueryVariables>;
export const GetAllProgramsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllPrograms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAll"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"programs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeAll"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAll"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"states"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAllProgramsQuery, GetAllProgramsQueryVariables>;
export const UpdateOAuthApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOAuthApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOAuthApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOAuthApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUris"}},{"kind":"Field","name":{"kind":"Name","value":"allowedScopes"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isFirstParty"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateOAuthApplicationMutation, UpdateOAuthApplicationMutationVariables>;
export const UpdateProgramDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProgram"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProgramInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProgram"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"states"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"eligibilityCriteria"}},{"kind":"Field","name":{"kind":"Name","value":"programTerms"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateProgramMutation, UpdateProgramMutationVariables>;
export const GetUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTimeZone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"authenticatedOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const UpdateUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTimeZone"}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UpdateUserEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>;
export const ChangePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChangePasswordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ResendVerificationEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendVerificationEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResendVerificationEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendVerificationEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const GetUserByIdForRecentlyViewedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserByIdForRecentlyViewed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserByIdForRecentlyViewedQuery, GetUserByIdForRecentlyViewedQueryVariables>;
export const GetUserSettingsForAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserSettingsForAdmin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetUserSettingsForAdminQuery, GetUserSettingsForAdminQueryVariables>;
export const UpdateUserSettingsForAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserSettingsForAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"settings"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<UpdateUserSettingsForAdminMutation, UpdateUserSettingsForAdminMutationVariables>;
export const GetWorkspaceApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspaceApiKeys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApiKeysInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKeys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"revoked"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceApiKeysQuery, GetWorkspaceApiKeysQueryVariables>;
export const GetWorkspaceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspaceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"deletionProtection"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceByIdQuery, GetWorkspaceByIdQueryVariables>;
export const GetWorkspaceConnectSessionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspaceConnectSessions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectSessionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectSessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"pagination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceConnectSessionsQuery, GetWorkspaceConnectSessionsQueryVariables>;
export const GetWorkspaceDestinationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspaceDestinations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DestinationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"destinations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceId"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"destinationType"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"eventTypes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceDestinationsQuery, GetWorkspaceDestinationsQueryVariables>;
export const GetWorkspaceOAuthApplicationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspaceOAuthApplications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OAuthApplicationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oauthApplications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"redirectUris"}},{"kind":"Field","name":{"kind":"Name","value":"allowedScopes"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isFirstParty"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceOAuthApplicationsQuery, GetWorkspaceOAuthApplicationsQueryVariables>;
export const GetWorkspaceProgramsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkspacePrograms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SlugOrIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspacePrograms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"program"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkspaceProgramsQuery, GetWorkspaceProgramsQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTemperatureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTimeZone"}},{"kind":"Field","name":{"kind":"Name","value":"profilePhoto"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;